/* Kladiora: üst bar döngüsü, menü, alttan açılan paneller, sticky bar, sepete ekleme, giriş animasyonu,
   video çözünürlük seçimi, fotoğraf galerisi, atmosfer efektleri, şifre çözme başlık, chroma key yükleyici, 3D görüntüleyici. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = !!(window.Shopify && window.Shopify.designMode);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  // Yalnız genişlik değişince (29.09.2026, uygulama içi tarayıcı): araç çubuğu kaydırırken açılıp kapanınca yalnız boy
  // değişir; boya bağlı olmayan ölçümler o zaman yapılmaz. Düzen görüntü alanının genişliği (iki parmakla büyütmede değişmez)
  const onWidth = (fn) => { let w = document.documentElement.clientWidth; addEventListener('resize', () => { const x = document.documentElement.clientWidth; if (x === w) return; w = x; fn(); }, { passive: true }); };
  const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
  // Sayfa tamamen yüklendikten ve tarayıcı boşa çıktıktan sonra (LCP ve etkileşimi etkilemez)
  const afterLoad = (fn) => (document.readyState === 'complete' ? idle(fn) : addEventListener('load', () => idle(fn), { once: true }));
  // Kaydırma sessizliği (28.09.2026): ağır işler (3D modelin indirilip hazırlanması, model-viewer'ın açılması) sayfa içi
  // yumuşak kaydırma (kzGliding) ve parmakla kaydırma sürerken başlamaz; kaydırma durunca (son olaydan min ms sonra)
  // boşta başlar. Kaydırma/dokunma sürdükçe beklenir (max yalnız takılı yumuşak kaydırmayı aşar, cap verildiyse her
  // durumda üst sınır). Önce geçişin ortasında başlayan 3D
  // hazırlığı geçişi 20 kare/sn'ye düşürüyordu (ölçüldü: KARARLAR §8)
  // Parmak ekrandayken de meşgul (29.09.2026, uygulama içi tarayıcı kasması; KARARLAR §8): yalnız 'scroll' olayına
  // bakınca kaydırmalar arasındaki kısa durakta (parmak yeniden inerken) ağır iş başlıyor, max süresi de kaydırmanın
  // ortasında zorla başlatıyordu. Artık parmak ekrandayken ya da son kaydırmadan bu yana min ms geçmeden hiç başlamaz;
  // max yalnız takılı kalmış yumuşak kaydırmayı (kzGliding) aşar. Kaydırma olayı yakalama evresinde: iç kaydırıcılar
  // (model kartları) da sayılır. touchend kaçarsa 3 sn sonra parmak kalkmış sayılır
  let lastScroll = 0, touching = 0, touchT = 0;
  const act = () => { lastScroll = performance.now(); };
  const pc = { passive: true, capture: true };
  addEventListener('scroll', act, pc);
  addEventListener('touchstart', (e) => { touching = (e.touches && e.touches.length) || 1; touchT = performance.now(); act(); }, pc);
  addEventListener('touchmove', (e) => { touching = (e.touches && e.touches.length) || 1; touchT = performance.now(); act(); }, pc);
  ['touchend', 'touchcancel'].forEach((ty) => addEventListener(ty, (e) => { touching = e.touches ? e.touches.length : 0; act(); }, pc));
  const inTouch = () => { if (touching && performance.now() - touchT > 3000) touching = 0; return touching > 0; };
  window.kzTouching = inTouch;
  // cap: bu süreden sonra (ms) kaydırma sürse de başlar; yalnız içerik gösteren hafif işlerde (işaret çizgileri)
  const quiet = (fn, min = 300, max = 4000, cap = Infinity) => {
    const t0 = performance.now();
    const busy = () => { const now = performance.now(); return now - t0 < cap && (inTouch() || now - lastScroll < min || (now - t0 < max && !!window.kzGliding)); };
    const tryRun = () => { if (busy()) { setTimeout(tryRun, 120); return; } idle(() => { if (busy()) tryRun(); else fn(); }); }; // boşta sırası gelince de bakar
    tryRun();
  };
  window.kzQuiet = quiet;
  // ---------- Metin etiketleri (<yesil>, <isik3>, <p16>, <#26a343>, <ok>…): tek çevirici (29.09 → 17.10.2026) ----------
  // Sunucuda snippets/kz-tags.liquid çevirir (kz- bölümleri ve Emsal ürün bölümü). Bu çevirici aynı kurallarla tarayıcıda:
  // tema editöründe yazarken (kz-ed.js), JS'in eklediği yazılarda (product-emsal.js: emsal-products.json) ve sunucunun
  // çevirmediği yerlerde (Dawn sayfaları: koleksiyon, sepet, sayfa, arama; varyant/sepet güncellemeleri) kalan etiketler
  // için (fixDom). Yazım serbest: büyük/küçük harf, Türkçe harf ve iç boşluk fark etmez (<Yeşil>, <YEŞİL>, < kalın >,
  // <Satır>, <IŞIK5>, <P16> → asıl ad). Kurallar kz-tags.liquid ile aynıdır: orada değişen burada da değişir.
  const TAGN = new Set(['yesil', 'beyaz', 'gri', 'sari', 'kirmizi', 'mavi', 'chakra', 'fira', 'rajd', 'bold', 'ince', 'italik', 'altcizgi',
    'cizili', 'buyuk', 'kucuk', 'buyukharf', 'isik', 'vurgu', 'orta', 'sag', 'sol', 'satir', 'enter', 'ok']);
  const TSYN = { kalin: 'bold', italic: 'italik', rajdhani: 'rajd', ortala: 'orta', saga: 'sag', sola: 'sol' };
  const tfold = (t) => t.replace(/İ/g, 'i').replace(/I/g, 'i').toLowerCase().replace(/i\u0307/g, 'i').replace(/ş/g, 's').replace(/ı/g, 'i')
    .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/\s+/g, '');
  // Etiket adı → asıl ad (bilinmiyorsa null): isik1-10, bosluk1-100, p/u + sayı da
  const tcanon = (name) => {
    const f = tfold(name), n = TSYN[f] || f;
    if (TAGN.has(n) || /^isik(?:[1-9]|10)$/.test(n) || /^bosluk\d{1,3}$/.test(n) || /^[pu]\d{1,3}(?:\.\d+)?$/.test(n)) return n;
    return null;
  };
  // Yazımı asıl ada çevirir; ham (<…>) ya da kaçışlı (&lt;…&gt;) biçim olduğu gibi kalır, çeviriyi conv yapar
  const norm = (o) => (o.includes('<') || o.includes('&lt;') ? o.replace(/(<|&lt;)(\/?)[ \u00a0]*([A-Za-zÇĞİÖŞÜçğıöşü][A-Za-z0-9.ÇĞİÖŞÜçğıöşü \u00a0\u0307]{0,14}?)[ \u00a0]*(>|&gt;)/g,
    (m, lt, sl, name, gt) => { const c = tcanon(name); return c && c !== name ? `${lt}${sl}${c}${gt}` : m; }) : o);
  const NAMES = ['yesil', 'beyaz', 'gri', 'sari', 'kirmizi', 'mavi', 'chakra', 'fira', 'rajd', 'bold', 'ince', 'italik', 'altcizgi',
    'cizili', 'buyuk', 'kucuk', 'buyukharf', 'isik', 'isik1', 'isik2', 'isik3', 'isik4', 'isik5', 'isik6', 'isik7', 'isik8', 'isik9',
    'isik10', 'vurgu', 'orta', 'sag', 'sol', 'satir', 'enter', 'Enter', 'ENTER'];
  const AL = [['yeşil', 'yesil'], ['sarı', 'sari'], ['kırmızı', 'kirmizi'], ['rajdhani', 'rajd'], ['kalin', 'bold'], ['kalın', 'bold'],
    ['italic', 'italik'], ['altçizgi', 'altcizgi'], ['çizili', 'cizili'], ['büyük', 'buyuk'], ['küçük', 'kucuk'],
    ['büyükharf', 'buyukharf'], ['ışık', 'isik'], ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => [`ışık${i}`, `isik${i}`]), ['satır', 'satir'], ['sağ', 'sag'], ['ortala', 'orta'], ['sağa', 'sag'], ['sola', 'sol']];
  const rep = (s, a, b) => (s.includes(a) ? s.split(a).join(b) : s);
  const isD = (c) => c >= '0' && c <= '9';

  // Etiketli kod parçaları: sep ile bölünen her parça "kod>" ya da "kod&gt;" ile başlıyorsa mk(kod) yerine geçer (kz-tags)
  const pairs = (o, sep, ok, mk, bad) => {
    if (!o.includes(sep)) return o;
    const parts = o.split(sep); let r = parts[0];
    for (const seg of parts.slice(1)) {
      let done = false;
      for (const term of ['>', '&gt;']) {
        const k = seg.indexOf(term); if (k < 0) continue;
        const c = seg.slice(0, k);
        if (ok(c)) { r += mk(c) + seg.slice(k + term.length); done = true; break; }
      }
      if (!done) r += bad(seg) + seg;
    }
    return r;
  };

  const conv = (h) => {
    let o = norm(String(h ?? ''));
    if (o.includes('&lt;')) NAMES.forEach((t) => { o = rep(rep(o, `&lt;${t}&gt;`, `<${t}>`), `&lt;/${t}&gt;`, `</${t}>`); });
    AL.forEach(([a, b]) => {
      o = rep(o, `<${a}>`, `<${b}>`); o = rep(o, `&lt;${a}&gt;`, `<${b}>`);
      o = rep(o, `</${a}>`, `</${b}>`); o = rep(o, `&lt;/${a}&gt;`, `</${b}>`);
    });
    // <ok></ok>, <ok>N</ok> (1-20): aşağı bakan üçgen (kz-tags ile aynı; boyunu kz.js kzOkFit ölçer)
    if (/ok/i.test(o)) {
      o = o.replace(/<(ok|OK|Ok)>|&lt;(ok|OK|Ok)&gt;/g, '<ok>').replace(/<\/(ok|OK|Ok)>|&lt;\/(ok|OK|Ok)&gt;/g, '</ok>');
      if (o.includes('<ok>')) {
        const parts = o.split('<ok>'); let r = parts[0];
        for (const seg of parts.slice(1)) {
          let tri = "<span class='kz-ok' aria-hidden='true'></span>", rest = seg;
          const k = seg.indexOf('</ok>');
          if (k >= 0) {
            const c = seg.slice(0, k).trim(); rest = seg.slice(k + 5);
            if (c) {
              const c2 = c.replace(/,/g, '.');
              if (/^\d*\.?\d*$/.test(c2) && c2 !== '.' && c.length <= 5) {
                const v = Math.min(20, Math.max(1, +c2));
                tri = `<span class='kz-ok' style='--kz-ok-n:${v}' aria-hidden='true'></span>`;
              } else { tri = '&lt;ok&gt;'; rest = `${seg.slice(0, k)}&lt;/ok&gt;${seg.slice(k + 5)}`; }
            }
          }
          r += tri + rest;
        }
        o = r;
      }
      o = rep(o, '</ok>', '');
    }
    // Hizalama etiketleri blok: iki yanındaki Enter fazladan boş satır açmasın (kz-tags ile aynı)
    o = o.replace(/(?:\r?\n)*(<\/?(?:orta|sag|sol)>)(?:\r?\n)*/g, '$1');
    // <bosluk1>…<bosluk100>: N px boş alan (kz-tags ile aynı)
    if (/bo[sş]luk/.test(o)) {
      o = o.replace(/&lt;(\/?)bo[sş]luk(\d{1,3})&gt;/g, '<$1bosluk$2>').replace(/<(\/?)boşluk(\d{1,3})>/g, '<$1bosluk$2>');
      o = o.replace(/<bosluk(\d{1,3})>(?:<\/bosluk\1>)?/g, (m, n) => (+n >= 1 && +n <= 100 ? `<span class='kz-sp' style='--kz-sp:${+n}' aria-hidden='true'></span>` : m));
      o = o.replace(/<\/bosluk(\d{1,3})>/g, (m, n) => (+n >= 1 && +n <= 100 ? '' : m));
    }
    // <satir> ve <enter>: satır sonu
    ['<satir>', '<enter>', '<Enter>', '<ENTER>'].forEach((x) => { o = rep(o, x, '<br>'); });
    o = rep(rep(o, '</satir>', ''), '</enter>', '');
    // Renk kodu: <#26a343>…</#26a343>. Tarayıcı ham "</#…>"yu yorum (<!--#…-->) yapar: geri çevrilir
    o = o.replace(/<!--(#[0-9a-fA-F]{3,8})-->/g, '</$1>');
    if (o.includes('#')) {
      o = rep(rep(o, '&lt;/#', '</#'), '&lt;#', '<#');
      const hexOk = (c) => /^[0-9a-f]+$/i.test(c) && [3, 4, 6, 8].includes(c.length);
      // Geçersiz kod yazı olarak kalır: kaçışlı (&lt;) yazılır. Ham '<#' tarayıcıda yine '&lt;#' olur; çeviri her seferinde
      // farklı çıkıp değişiklik → çeviri → değişiklik döngüsüne giriyor, editörü donduruyordu (27.09.2026)
      o = pairs(o, '</#', hexOk, () => '</span>', () => '&lt;/#');
      o = pairs(o, '<#', hexOk, (c) => {
        const hx = c.toLowerCase(); let cv = `#${hx}`;
        if (hx.length === 3 || hx.length === 6) cv = `var(--kz-tc-${hx.length === 3 ? hx.replace(/./g, '$&$&') : hx},#${hx})`;
        return `<span style='color:${cv}'>`;
      }, () => '&lt;#');
    }
    // Yazı boyutu: <p12>…</p12> (1-400, ondalık olur); <p>, <path> gibi gerçek etiketlere dokunulmaz
    if (/(<|&lt;|&lt;\/)p\d/.test(o)) {
      o = o.replace(/&lt;(\/?)p(\d)/g, '<$1p$2');
      const szOk = (c) => isD(c[0]) && c.replace(/\d/g, '').replace('.', '') === '' && c.length <= 5 && +c > 0 && +c <= 400;
      o = pairs(o, '</p', szOk, () => '</span>', (seg) => (isD(seg[0]) ? '&lt;/p' : '</p'));
      o = pairs(o, '<p', szOk, (c) => `<span style='font-size:calc(${c}px * var(--kz-dt,1))'>`, (seg) => (isD(seg[0]) ? '&lt;p' : '<p'));
    }
    // Satır aralığı: <u20>…</u20> (1-400 px, ondalık olur) blok; <u>, <ul> gibi gerçek etiketlere dokunulmaz. Etiketin hemen
    // arkasındaki satır sonu atılır (kz-tags ile aynı)
    if (/(<|&lt;|&lt;\/)u\d/.test(o)) {
      o = o.replace(/&lt;(\/?)u(\d)/g, '<$1u$2');
      const uOk = (c) => isD(c[0]) && c.replace(/\d/g, '').replace('.', '') === '' && c.length <= 5 && +c > 0 && +c <= 400;
      o = pairs(o, '</u', uOk, () => '</span>§u', (seg) => (isD(seg[0]) ? '&lt;/u' : '</u'));
      o = pairs(o, '<u', uOk, (c) => `<span class='kz-u' style='--kz-u:${c}'>§u`, (seg) => (isD(seg[0]) ? '&lt;u' : '<u'));
      o = o.replace(/§u(?:\r?\n|<br\s*\/?>|<span class="kz-br"><\/span>)?/g, '');
    }
    return o;
  };

  // Sayfada kalan etiketler (sunucunun çevirmediği bölümler, sonradan eklenen yazılar): yazı düğümündeki "<yesil>" ve
  // tarayıcının ham yazımdan kurduğu öğeler (<Yeşil> → <yeşil>, <satir>, <p16>, <bosluk5>) çevrilir. Etiketsiz sayfada
  // yalnız tarama (birkaç ms); efekt ve başlık animasyonu katmanlarına, form alanlarına dokunulmaz
  const TSKIP = 'script,style,textarea,template,svg,noscript,code,pre,input,select,option,[contenteditable],.kz-dc,.is-gl,[data-kz-notags]';
  // Sunucuda kz-tags'ten geçen bölümler (kz-*, Emsal ürün): yazıları zaten çevrili, yalnız öğe adlarına bakılır (ucuz)
  const kzSec = (s) => s.classList.contains('section-kladiora-product') || !!s.querySelector(':scope > [class*="kz-"]');
  const ODD = /^(?:satir|enter|bosluk\d+|[pu]\d+(?:\.\d+)?|kalin|italic|rajdhani|ortala|saga|sola|ok)$/;
  const fixDom = (root = document.body) => {
    if (!root || root.nodeType !== 1) return;
    const els = [], txt = [];
    const skip = (n) => n.matches(TSKIP);
    // 1) Öğeler: tarayıcının ham yazımdan kurduğu <yeşil>, <satir>, <p16>…
    const ew = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, { acceptNode: (n) => {
      if (skip(n)) return NodeFilter.FILTER_REJECT;
      const ln = n.localName;
      if (/^[a-z][a-z0-9]*(?:-[a-z0-9-]+)?$/.test(ln) ? ODD.test(ln) : ln.length <= 16 && tcanon(ln)) els.push(n);
      return NodeFilter.FILTER_SKIP;
    } });
    while (ew.nextNode());
    // 2) Yazı düğümleri: yalnız sunucunun çevirmediği bölümlerde ve bölüm dışında
    const tw = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, { acceptNode: (n) => {
      if (n.nodeType === 1) return skip(n) || (n.classList.contains('shopify-section') && kzSec(n)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
      if (n.data.includes('<') && /<\/?[ \u00a0]*[#A-Za-zÇĞİÖŞÜçğıöşü]/.test(n.data)) txt.push(n);
      return NodeFilter.FILTER_SKIP;
    } });
    while (tw.nextNode());
    // Öğeler dıştan içe, içindeki yazılarla birlikte yeniden kurulur
    els.filter((e) => !els.some((p) => p !== e && p.contains(e))).forEach((e) => {
      if (!e.isConnected) return;
      const t = document.createElement('template');
      t.innerHTML = conv(e.outerHTML);
      e.replaceWith(t.content);
    });
    txt.forEach((n) => {
      if (!n.isConnected) return;
      const esc = n.data.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const out = conv(esc);
      if (out === esc) return;
      const t = document.createElement('template');
      t.innerHTML = out;
      n.replaceWith(t.content);
    });
    if ((els.length || txt.length) && window.kzOkFit && root.querySelector('.kz-ok')) window.kzOkFit(root);
  };
  // Sekme başlığına (title) biçim girmez: etiket yazısı atılır
  const fixTitle = () => { const t = document.title; if (t && /<\/?[ \u00a0]*[#A-Za-zÇĞİÖŞÜçğıöşü]/.test(t)) document.title = t.replace(/<\/?[^<>]{1,16}>/g, (m) => (tcanon(m.replace(/[<>/#]/g, '')) || /^<\/?#/.test(m) ? '' : m)); };
  const tagHtml = (s) => conv(s);
  // Düz yazıyı (JSON'dan gelen, kullanıcı metni) güvenle HTML'e çevirir: önce kaçışlanır, sonra yalnız etiketler açılır
  const tagText = (s) => conv(String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'));
  window.kzTags = { html: tagHtml, text: tagText, canon: tcanon, fixDom };
  fixTitle(); fixDom();
  document.addEventListener('shopify:section:load', (e) => fixDom(e.target));
  // Dawn sepet ve varyant güncellemeleri sayfaya yeni yazı koyar: bir an sonra yeniden bakılır
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.variantChange].filter(Boolean).forEach((ev) => subscribe(ev, () => setTimeout(() => fixDom(), 120)));
  }

  // Betiği indir ama çalıştırma (sonra aynı adresle <script> eklenince önbellekten çalışır; ek istek yok)
  const pre = (href) => { if (href) document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'preload', as: 'script', href })); };
  const conn = navigator.connection || {};
  const slow = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  const lite = reduce || slow; // hareketi azalt, veri tasarrufu ya da 2G: süs yok
  if (slow) document.documentElement.classList.add('kz-lite');

  // ---------- Görsel duruşu (editör "Görünüm: … (duruş)", snippets/kz-st.liquid → --kz-it, kz-base.css) ----------
  // Döndürülen/ölçeklenen görselin üstündeki noktalar (işaret çizgisi, şema etiketi) görselle gitsin: görselin yerel
  // pikseli (x, y) → ekrandaki yeri (fw) ve tersi (inv, editörde sürükleme). 3B yatırmada perspektif dahil (z = 0
  // düzleminin homografisi). Yalnız çizimde / boyut değişince okunur, karede değil. Dönüşüm yoksa null
  window.kzPose = (el) => {
    const cs = getComputedStyle(el);
    if (!cs.transform || cs.transform === 'none') return null;
    const M = new DOMMatrix(cs.transform);
    const [ox, oy] = cs.transformOrigin.split(' ').map(parseFloat);
    const a = M.m11, b = M.m21, c = M.m41, d = M.m12, e = M.m22, f = M.m42, g = M.m14, h = M.m24, i = M.m44;
    const A = e * i - f * h, B = c * h - b * i, C = b * f - c * e, D = f * g - d * i, E = a * i - c * g, F = c * d - a * f;
    const G = d * h - e * g, H = b * g - a * h, I = a * e - b * d; // tersi: eşlenik matris (ölçeği bölmede sadeleşir)
    const pr = (p, q, r, s1, t, u, v, w, z) => (x, y) => { x -= ox; y -= oy; const k = v * x + w * y + z; return [(p * x + q * y + r) / k + ox, (s1 * x + t * y + u) / k + oy]; };
    return { fw: pr(a, b, c, d, e, f, g, h, i), inv: pr(A, B, C, D, E, F, G, H, I) };
  };
  // Büyütülmüş görselin ekrandaki ölçeği (video çözünürlüğü seçimi; chroma key tuvali kz-ck.js'te aynı değişkenden)
  const isc = (el) => Math.min(3, Math.max(1, parseFloat(getComputedStyle(el).getPropertyValue('--kz-isc')) || 1));

  // ---------- Kare hızı yöneticisi (window.kzFps) ----------
  // Sitedeki bütün JS animasyonları (atmosfer efektleri, başlık animasyonları, işaret çizgileri, Devamını gör) tek bir
  // requestAnimationFrame döngüsünden, ortak hedef kare hızıyla çizilir. Standart 60 kare/sn (Tema ayarları →
  // Kladiora: atmosfer → Kare hızı); ekran 90/120 Hz olsa da 60'ı geçmez (pil). Uyarlanabilir: cihaz kare atlamaya
  // başlarsa önce görüntü kalitesi iner (tuval çözünürlüğü, arka plan bulanıklığı; 60 kare korunur), yetmezse kare
  // hızı 60 → 50 → 40 → 30 → 25'e (ayardaki en düşük değere) iner; cihaz rahatlayınca adım adım geri çıkar.
  // Yargı yalnız durağan pencerede (28.09.2026, ölçüm KARARLAR §8): sayfa içi yumuşak kaydırma, parmakla kaydırma (son
  // olaydan 300 ms), 3D hazırlığı ve efekt dışı uzun görevler sırasında atlanan kareler sayılmaz; önce bunlar "zayıf cihaz"
  // sayılıp geçişin ortasında kalite ve kare hızı iniyor, 4-64 sn düşük kalıyordu. Basamak inişi 2 ardışık kötü saniye ister.
  // Hedef kare hızı ekranın yenileme hızının tam bölenidir (60 Hz'de 40 → 30, 120 Hz'de 40; 60 Hz'de 40 "1-2-1-2" kadansı
  // yapıyordu): kareler eşit aralıklı, hareket düzgün. Aynı hedefe düşen basamaklar tek sayılır.
  // Telefonun kendi ayarı kazanır: güç tasarrufu ekranı 30 Hz'e indirirse site de 30'da çizer; pil %20'nin altındaysa
  // ve şarjda değilse 30'u geçmez. Abone yokken döngü durur: sayfa açılışında 0 iş.
  // Yazma kuyruğu (F.write): kz.js'teki IntersectionObserver geri çağrılarının DOM yazımları (giriş animasyonu, ışıma)
  // düzenden sonra yapılmaz; karenin rAF'ında okumalardan (scrollTo, scrollY) sonra uygulanır. Yoksa her kaydırma
  // karesinde iki stil/düzen hesabı oluyordu (biri zorunlu, scrollY'de). kz-fx.js kullanmaz (ölçümde kötü çıktı, KARARLAR §8).
  // CSS geçişleri ve animasyonları (butonlar, paneller, giriş, nabızlar) yalnız transform/opacity ile, tarayıcının
  // kompozitöründe ekranın kendi hızında oynar; bu yöneticiye gerek duymaz.
  const kzFps = (() => {
    const cfg = window.kzFx || {};
    const hi = Math.min(60, Math.max(15, +cfg.fpsMax || 60));
    const lo = Math.min(hi, Math.max(15, +cfg.fpsMin || 25));
    // Basamaklar: [kare hızı, kalite]. Önce kalite (1 → 0), sonra kare hızı iner
    const steps = [[hi, 1], [hi, 0]];
    [50, 40, 30, 25, 20].forEach((f) => { if (f < hi && f > lo) steps.push([f, 0]); });
    if (lo < hi) steps.push([lo, 0]);
    const subs = new Set(); const lis = new Set();
    const F = { fps: hi, q: 1, hz: 60, frames: 0, step: 0, steps };
    // Belleği ve çekirdeği az cihaz (Android bildirir) 60 karede ama düşük kaliteyle başlar
    let s = (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) ? 1 : 0;
    let bat = 1e3; // pil sınırı
    let raf = 0, last = 0, next = 0, warm = 0, hzI = 1000 / 60;
    const raw = []; let wn = 0, wl = 0, ww = 0, wf = 0, wt = 0; // ölçüm penceresi: kare, atlanan, iş ms, çizilen kare, başlangıç
    let bad = 0, good = 0, holdTo = 0, back = 4000, upAt = -1e9;
    // Meşgul: bu sürede ölçüm penceresi yeniden başlar, yargı verilmez. busy(ms): geçici (kaydırma, uzun görev);
    // hold(true/false): süren iş (yumuşak kaydırma, 3D hazırlığı), sayaçla
    let busyTo = 0, holds = 0;
    F.busy = (ms) => { busyTo = Math.max(busyTo, performance.now() + ms); };
    F.hold = (on) => { holds = Math.max(0, holds + (on ? 1 : -1)); if (!on) F.busy(300); };
    addEventListener('scroll', () => F.busy(300), { passive: true });
    // Efekt dışı uzun görev (3D açılışı, gölgelendirici derleme, düzen): pencere sayılmaz. Efektin kendi işi büyükse sayılır
    try { new PerformanceObserver(() => { if (ww / (wf || 1) < 25) F.busy(300); }).observe({ type: 'longtask' }); } catch (e) { /* desteklenmiyor */ }
    // Ekranın yenileme hızının (ölçülen) f'yi geçmeyen en büyük tam böleni; ekran 30 Hz'e inmişse (güç tasarrufu) 30
    const even = (f) => { const hz = Math.round(1000 / hzI); let c = hz; for (let n = 1; n <= 8 && c > f * 1.06; n++) c = hz / n; return c; };
    const eff = (i) => { const [f, q] = steps[Math.min(i, steps.length - 1)]; return `${even(Math.min(f, bat))}|${q}`; };
    const apply = () => {
      const [f, q] = steps[Math.min(s, steps.length - 1)];
      const cap = even(Math.min(f, bat));
      const ch = F.fps !== cap || F.q !== q;
      F.fps = cap; F.q = q; F.step = s;
      document.documentElement.classList.toggle('kz-q0', !q);
      if (ch) lis.forEach((fn) => fn(F));
    };
    const judge = (t) => {
      // 1 sn'lik pencere: ekranın gerçek yenileme aralığı (en hızlı çeyrek) ve atlanan kare oranı
      const srt = raw.slice().sort((a, b) => a - b); const p = srt[(srt.length / 4) | 0];
      if (p) hzI = Math.min(40, Math.max(6.9, p));
      F.hz = 1000 / hzI;
      const miss = wl / (wn || 1), work = ww / (wf || 1);
      F.miss = miss; F.work = work;
      if (miss > 0.12) { bad++; good = 0; } else { bad = 0; if (miss < 0.03) good++; else good = 0; }
      if (bad >= 2 && s < steps.length - 1) {
        const e0 = eff(s); do { s++; } while (s < steps.length - 1 && eff(s) === e0); // aynı hedefe düşen basamaklar atlanır
        bad = 0; good = 0;
        if (t - upAt < 5000) back = Math.min(64000, back * 2); // az önce çıkılan basamak kaldırmadı: daha geç dene
        holdTo = t + back;
      } else if (s > 0 && good >= 3 && t > holdTo && work < 0.4 * (1000 / even(steps[s - 1][0]))) {
        const e0 = eff(s); do { s--; } while (s > 0 && eff(s) === e0);
        good = 0; upAt = t; holdTo = t + 3000;
      }
      if (t - upAt > 30000) back = 4000;
      apply();
    };
    // Ekranın her karesinde çizilenler (sayfa içi yumuşak kaydırma, Farklar kutusunun büyümesi): uyarlanabilir basamaktan
    // (zayıf cihaz, pil) ve Tema ayarındaki hedeften bağımsız, ekranın kendi yenileme hızında (en çok 60; 120 Hz'de 2'de 1).
    // 40'ta çizilen kaydırma 60 Hz ekranda 3 karenin 2'sinde ilerliyordu (takılma). İşleri çok küçük (bir scrollTo): kare
    // hızı ölçümüne ve kalite kararına katılmaz
    const hiSubs = new Set(); let hiNext = 0, hiT = 0;
    const wq = []; // yazma kuyruğu: karenin sonunda (okumalardan sonra) uygulanır
    const tick = (t) => {
      raf = subs.size || hiSubs.size ? requestAnimationFrame(tick) : 0;
      const d = last ? t - last : 0; last = t;
      if (!d || d > 250) { next = t; warm = t + 800; wn = wl = ww = wf = 0; wt = t; } // ilk kare ya da sekmeden dönüş
      else if (t > warm) {
        raw.push(d); if (raw.length > 90) raw.shift();
        if (holds || t < busyTo) { wn = wl = ww = wf = 0; wt = t; } // meşgul (kaydırma, 3D hazırlığı, uzun görev): pencere yeniden başlar
        else { wn++; if (d > hzI * 1.5) wl++; if (t - wt >= 1000) { judge(t); wn = wl = ww = wf = 0; wt = t; } }
      } else wt = t;
      if (hiSubs.size) {
        const hiv = Math.max(hzI, 1000 / 60);
        if (!hiT || t >= hiNext - hzI * 0.5) {
          hiNext = hiT && hiNext >= t - hiv ? hiNext + hiv : t + hiv;
          const hdt = hiT ? Math.min(100, t - hiT) : 0; hiT = t;
          hiSubs.forEach((fn) => { try { fn(t, hdt); } catch (e) { hiSubs.delete(fn); } });
        }
      }
      if (subs.size && t >= next - hzI * 0.5) { // hedef kare hızı ekrandan düşükse aradaki ekran yenilemeleri atlanır
        const iv = 1000 / F.fps;
        next += iv; if (next < t - iv) next = t + iv;
        const dt = Math.min(100, t - (F.t || t)); F.t = t; F.frames++;
        const w0 = performance.now();
        subs.forEach((fn) => { try { fn(t, dt); } catch (e) { subs.delete(fn); } });
        ww += performance.now() - w0; wf++;
      }
      if (wq.length) wq.splice(0).forEach((fn) => { try { fn(); } catch (e) { /* yazım hatası kuyruğu durdurmaz */ } });
    };
    // DOM yazımını karenin sonuna (okumalardan sonraya) bırak; döngü çalışmıyorsa bir kare için başlar
    F.write = (fn) => { wq.push(fn); if (!raf) { last = 0; F.t = 0; raf = requestAnimationFrame(tick); } };
    let batAsked = false;
    const askBattery = () => {
      if (batAsked || !navigator.getBattery) return; batAsked = true;
      navigator.getBattery().then((b) => {
        const upd = () => { bat = !b.charging && b.level <= 0.2 ? 30 : 1e3; apply(); };
        b.addEventListener('levelchange', upd); b.addEventListener('chargingchange', upd); upd();
      }).catch(() => {});
    };
    // Abone ol: fn(t, dt) her çizilen karede çağrılır; dönen fonksiyon aboneliği bitirir
    F.add = (fn) => { subs.add(fn); askBattery(); if (!raf) { last = 0; F.t = 0; raf = requestAnimationFrame(tick); } return () => subs.delete(fn); };
    // Ekranın her karesinde abone ol (yukarıdaki hiSubs): fn(t, dt), dt ilk karede 0
    F.addHi = (fn) => { if (!hiSubs.size) hiT = 0; hiSubs.add(fn); if (!raf) { last = 0; F.t = 0; raf = requestAnimationFrame(tick); } return () => { hiSubs.delete(fn); if (!hiSubs.size) hiT = 0; }; };
    F.hi = hi;
    // Kare hızı ya da kalite değişince haber ver (tuvaller çözünürlüğünü yeniler)
    F.on = (fn) => { lis.add(fn); return () => lis.delete(fn); };
    // Tuval piksel yoğunluğu: yüksek kalitede efektin kendi sınırı, düşükte 1
    F.dpr = (cap) => Math.min(window.devicePixelRatio || 1, F.q ? cap : 1);
    apply();
    return F;
  })();
  window.kzFps = kzFps;

  // Sayfa kilidi: menü ve paneller üst üste açılabildiği için sayaçla tutulur
  let locks = 0;
  const lock = (on) => {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.body.classList.toggle('kz-lock', locks > 0);
  };

  // ---------- <ok></ok> üçgeni (snippets/kz-tags.liquid): boyu soldaki en yakın karakterin gerçek yüksekliği ----------
  // Soldaki en yakın boşluk olmayan karakter (aynı yazı kutusunda ve satırda; yoksa sağdaki) kendi yazı tipiyle ölçülür (canvas
  // measureText: glifin taban çizgisinin üstü + altı); üçgenin kutusu bu yükseklikte (em, kz-base.css .kz-ok boyutla
  // çarpar) ve karakterin ortasına oturur. Ölçülene kadar CSS yazının büyük harf boyunu kullanır. Ölçüm karede değil:
  // açılışta, yazı tipleri inince, ekran genişliği değişince, alt bar içeriği ve bölüm yeniden çizilince.
  const OKB = 'p,h1,h2,h3,h4,h5,h6,li,dt,dd,td,th,a,button,label,blockquote,figcaption,div';
  // Üçgen flex / grid kutunun (buton, rozet…) doğrudan içindeyse ayrı bir parça olur ve kutunun ortasına dizilir.
  // Şablonlar yazıyı zaten tek satır içi kutuya (.kz-lb) koyar; koymayan yerde burada aynısı yapılır: üçgen ve çevresindeki
  // yazı, etiket ve satır sonları tek .kz-lb'de toplanır, üçgen yazının satırında kalır. İkon ve görsel dışarıda kalır.
  const LBX = /^(DIV|P|UL|OL|LI|DL|SECTION|ARTICLE|ASIDE|HEADER|FOOTER|NAV|FIGURE|TABLE|FORM|H[1-6]|SVG|IMG|VIDEO|PICTURE|CANVAS|IFRAME|BUTTON|INPUT|SELECT|TEXTAREA|TEMPLATE|SCRIPT|STYLE)$/;
  const lbIn = (n) => n.nodeType === 3 || n.nodeType === 8 || (n.nodeType === 1 && !LBX.test(n.tagName) && !n.classList.contains('kz-dc') && !n.querySelector('svg, img, video, picture, canvas, iframe'));
  const lbFix = (ok) => {
    let x = ok;
    for (let i = 0; i < 8 && x.parentElement; i++) {
      const par = x.parentElement;
      if (par.classList.contains('kz-lb')) return; // zaten satır içi kutuda
      if (/flex|grid/.test(getComputedStyle(par).display)) {
        let a = x, b = x;
        while (a.previousSibling && lbIn(a.previousSibling)) a = a.previousSibling;
        while (b.nextSibling && lbIn(b.nextSibling)) b = b.nextSibling;
        const w = document.createElement('span'); w.className = 'kz-lb';
        par.insertBefore(w, a);
        for (let n = a, nx; n; n = nx) { nx = n === b ? null : n.nextSibling; w.appendChild(n); }
        return;
      }
      if (!lbIn(par)) return; // blok öğe: yazı akışı burada, sorun yok
      x = par;
    }
  };
  let okCv = null;
  const okFit = (root = document) => {
    const oks = root.matches?.('.kz-ok') ? [root] : $$('.kz-ok', root);
    if (!oks.length) return;
    okCv = okCv || document.createElement('canvas').getContext('2d');
    if (!okCv) return;
    const lang = document.documentElement.lang || undefined;
    const SKIP = '.kz-dc, script, style, template, [data-kz-co] svg';
    const acc = { acceptNode: (n) => ((n.nodeType === 3 ? n.parentElement : n)?.closest(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT) };
    const isBr = (n) => n.nodeType === 1 && (n.tagName === 'BR' || n.classList.contains('kz-br'));
    // Yön yönünde ilk boşluk olmayan karakter; satır sonunda (Enter) durur: satır başındaki üçgen sağındaki harfe bakar
    const near = (tw, ok, back) => {
      tw.currentNode = ok; let n;
      while ((n = back ? tw.previousNode() : tw.nextNode())) {
        if (isBr(n)) return null;
        if (n.nodeType !== 3) continue;
        const t = back ? n.data.replace(/\s+$/u, '') : n.data.replace(/^\s+/u, '');
        if (t) return { n, ch: back ? [...t].pop() : [...t][0] };
      }
      return null;
    };
    oks.forEach(lbFix);
    const jobs = oks.map((ok) => {
      const box = ok.parentElement?.closest(OKB) || document.body;
      const tw = document.createTreeWalker(box, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, acc);
      const hit = near(tw, ok, true) || near(tw, ok, false);
      let ch = hit ? hit.ch : '';
      const el = hit ? hit.n.parentElement : ok.parentElement || ok;
      const cs = getComputedStyle(el);
      if (cs.textTransform === 'uppercase') ch = ch.toLocaleUpperCase(lang); else if (cs.textTransform === 'lowercase') ch = ch.toLocaleLowerCase(lang);
      // Ö, Ü, İ noktasız sayılır (O, U, I): üçgenin boyu ve konumu harfin gövdesine göre
      ch = { 'Ö': 'O', 'Ü': 'U', 'İ': 'I' }[ch] || ch;
      okCv.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
      let m = okCv.measureText(ch || 'H');
      if (!(m.actualBoundingBoxAscent + m.actualBoundingBoxDescent > 0)) m = okCv.measureText('H');
      const a = m.actualBoundingBoxAscent, d = m.actualBoundingBoxDescent;
      const fs = parseFloat(getComputedStyle(ok).fontSize) || 16;
      const h = `${((a + d) / fs).toFixed(4)}em`, c = `${((a - d) / 2 / fs).toFixed(4)}em`;
      return { ok, h, c };
    });
    jobs.forEach(({ ok, h, c }) => {
      if (ok.style.getPropertyValue('--kz-ok-h') !== h) ok.style.setProperty('--kz-ok-h', h);
      if (ok.style.getPropertyValue('--kz-ok-c') !== c) ok.style.setProperty('--kz-ok-c', c);
    });
  };
  window.kzOkFit = okFit;
  okFit();
  document.fonts?.ready.then(() => okFit());
  document.fonts?.addEventListener?.('loadingdone', () => okFit());
  let okT = 0;
  onWidth(() => { clearTimeout(okT); okT = setTimeout(okFit, 150); });

  // ---------- Buton parlaması (kz-base.css .kz-btn::before): yalnız ekrandaki butonda yanıp söner ----------
  // Süs efekti: ekran dışında durur (.is-glow yoksa animasyon duraklatılmış). Hareketi azalt, veri tasarrufu ve 2G'de
  // CSS yanıp sönmeyi zaten kapatır; ölçek nabzı da aynı sınıfla (.is-glow) oynar. İkisi de kapalıysa izlenmez
  let glowScan = () => {};
  const rcs = getComputedStyle(document.documentElement);
  if (!lite && 'IntersectionObserver' in window && (rcs.getPropertyValue('--kz-bgl-t').trim() || rcs.getPropertyValue('--kz-bsc-t').trim())) {
    const gio = new IntersectionObserver((es) => es.forEach((e) => kzFps.write(() => e.target.classList.toggle('is-glow', e.isIntersecting))), { rootMargin: '40px' });
    glowScan = (root = document) => {
      const els = root.matches?.('.kz-anim') ? [root] : $$('.kz-anim', root);
      els.forEach((b) => { if (!b._kzG) { b._kzG = 1; gio.observe(b); } });
    };
    glowScan();
  }

  // ---------- Dış ışıma filtre alanı: görselin gerçek boyuna göre (ışıma hiçbir yanda kesilmez) ----------
  // SVG filtre alanı görsel kutusunun %'si. Işımanın kenardan uzandığı px (data-kz-gr; yankı halkası data-kz-grr) kutunun o
  // anki eni ve boyuna çevrilir: kısa / dar görselde de ışıma (sabit ve hareketli) kutunun dışına tam uzanır, büyük görselde
  // alan gereğinden büyük olmaz. Açılışta ve boyut değişince (ResizeObserver), karede değil. Hareketi azalt / veri
  // tasarrufunda da (sabit ışıma). kz.js'ten önce Liquid'in %50 payı geçerli
  const glowFit = (root = document) => $$('.kz-glow[data-kz-gid]', root).forEach((w) => {
    const m = $('.kz-media', w), id = w.dataset.kzGid;
    if (!m || w._gf) return;
    w._gf = 1;
    const fit = (es) => {
      const bb = es?.[0]?.borderBoxSize?.[0];
      const W = bb ? bb.inlineSize : m.offsetWidth, H = bb ? bb.blockSize : m.offsetHeight;
      if (!W || !H) return;
      [['', w.dataset.kzGr], ['-g', w.dataset.kzGr], ['-w', w.dataset.kzGr], ['-r', w.dataset.kzGrr]].forEach(([k, r]) => {
        const f = document.getElementById(`kz-glow-${id}${k}`), P = +r || 0;
        if (!f || !P) return;
        const px = (P / W) * 100, py = (P / H) * 100;
        f.setAttribute('x', `${(-px).toFixed(2)}%`); f.setAttribute('y', `${(-py).toFixed(2)}%`);
        f.setAttribute('width', `${(100 + 2 * px).toFixed(2)}%`); f.setAttribute('height', `${(100 + 2 * py).toFixed(2)}%`);
      });
    };
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(m);
  });
  glowFit();

  // ---------- Hareketli dış ışıma (medyanın "Dış ışıma" → "Hareketli ışıma", snippets/kz-glow.liquid) ----------
  // Görselin arkasına ışımalı kopyaları konur (.kz-gx): yalnız ışıma filtresiyle (…-g; yankı halkası …-r); hareket CSS'te
  // (kz-base.css "Hareketli ışıma": süzülme, ışık turu, sinyal yankısı; yalnız transform/opacity, filtre her karede
  // yeniden çizilmez). Kopya görselle aynı adres/srcset: önbellekten, ek istek yok. Chroma key'li durağan görselde
  // kopyalar, anahtarlanmış tuvalin 2D kopyaları (kz-ck.js her durağan çizimde _ckDrawn'u, çizimden hemen sonra
  // çağırır). Video ve GIF'te yok. Ekran dışında durur (.is-ga); hareketi azalt, veri tasarrufu ve 2G'de kurulmaz: sabit
  // ışıma kalır (kz.js çalışmazsa da). Boyuta bağlı değerler (ışık turu kabı, yankı ölçeği) ResizeObserver'dan, karede değil
  let initGa = () => {};
  if (!lite && 'IntersectionObserver' in window) {
    // Sayfa içi kaydırma üstünden geçerken hareketli ışıma başlamaz (29.09.2026): geçiş bitince yeniden gözlenir; sönme hemen
    const gaIO = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting && window.kzGliding) { const m = e.target; addEventListener('kz:glided', () => { gaIO.unobserve(m); gaIO.observe(m); }, { once: true }); return; }
      kzFps.write(() => e.target.classList.toggle('is-ga', e.isIntersecting));
    }), { rootMargin: '40px' });
    // Işık turu maskesi: n yumuşak dalga (sin² profil), her biri iki dalga arası mesafenin w'si kadar
    const waveMask = (n, w) => {
      const S = 360 / n, L = S * Math.min(0.95, Math.max(0.05, w)), st = [];
      for (let j = 0; j <= 12; j++) { const f = j / 12; st.push(`rgba(0,0,0,${(Math.sin(Math.PI * f) ** 2).toFixed(3)}) ${(L * f).toFixed(2)}deg`); }
      return `repeating-conic-gradient(from 0deg, ${st.join(', ')}, transparent ${S.toFixed(3)}deg)`;
    };
    initGa = (root = document) => $$('.kz-glow[data-kz-ga]', root).map((w) => {
      const m = $('.kz-media', w);
      if (!m || m._ga || m.classList.contains('kz-vid') || m.hasAttribute('data-kz-gif')) return null;
      const cs = getComputedStyle(m), num = (k, d) => { const v = parseFloat(cs.getPropertyValue(k)); return Number.isFinite(v) ? v : d; };
      return { w, m, n: Math.round(Math.min(4, Math.max(1, num('--kz-ga-n', 2)))), gw: num('--kz-ga-w', 0.4), p: num('--kz-ga-p', 24), dd: num('--kz-ga-d', 40) };
    }).forEach((J) => {
      if (!J) return;
      const { w, m, n, gw, p, dd } = J;
      const ty = w.dataset.kzGa || 'orbit';
      let mk;
      if (m.hasAttribute('data-kz-ck')) {
        const cvs = [];
        mk = () => { const c = document.createElement('canvas'); cvs.push([c, c.getContext('2d')]); return c; };
        m._ckDrawn = (cv) => cvs.forEach(([g, ctx]) => {
          if (g.width !== cv.width || g.height !== cv.height) { g.width = cv.width; g.height = cv.height; } else ctx.clearRect(0, 0, g.width, g.height);
          ctx.drawImage(cv, 0, 0);
        });
      } else {
        const img = $(':scope > img', m);
        if (!img) return;
        mk = () => { const g = img.cloneNode(false); g.removeAttribute('fetchpriority'); g.removeAttribute('id'); g.alt = ''; return g; };
      }
      const gx = (cls) => { const g = mk(); g.className = cls ? `kz-gx ${cls}` : 'kz-gx'; g.setAttribute('aria-hidden', 'true'); return g; };
      const box = (cls, ...k) => { const d = document.createElement('div'); d.className = cls; d.setAttribute('aria-hidden', 'true'); d.append(...k); return d; };
      const add = [];
      if (ty === 'wave') add.push(gx('kz-ga'), box('kz-gw', box('kz-gw__i', gx())));
      else if (ty === 'echo') {
        add.push(gx('kz-ga'));
        for (let k = 0; k < n; k++) { const r = gx('kz-ge'); r.style.setProperty('--k', k); add.push(r); }
      } else add.push(box('kz-gm', gx()));
      m._ga = 1;
      m.prepend(...add); m.classList.add('has-ga');
      m._ckRedo?.(); // motor önce yüklendiyse son görüntü yeniden çizilir (tuval çizimden sonra okunamaz)
      if (ty === 'wave') m.style.setProperty('--kz-gw-m', waveMask(n, gw));
      if (ty !== 'orbit' && 'ResizeObserver' in window) {
        new ResizeObserver((es) => {
          const bb = es[0]?.borderBoxSize?.[0];
          const W = bb ? bb.inlineSize : m.offsetWidth, H = bb ? bb.blockSize : m.offsetHeight;
          if (!W || !H) return;
          if (ty === 'wave') {
            // Dönen maske kabı, ışımanın çevrel çemberini her açıda örter
            m.style.setProperty('--kz-mw', `${W}px`); m.style.setProperty('--kz-mh', `${H}px`);
            m.style.setProperty('--kz-gw-d', `${Math.ceil(2 * Math.hypot(W / 2 + p + 6, H / 2 + p + 6)) + 2}px`);
          } else {
            // Halka kenardan dd px dışa: kısa ve uzun kenarda aynı mesafe
            m.style.setProperty('--kz-ge-sx', (1 + (2 * dd) / W).toFixed(4)); m.style.setProperty('--kz-ge-sy', (1 + (2 * dd) / H).toFixed(4));
          }
        }).observe(m);
      }
      gaIO.observe(m);
    });
    initGa();
  }

  // ---------- Şema: görsel döndürülmüş/ölçeklenmişse (duruş) etiket noktaları görselle gider ----------
  // Yalnız duruşu değişmiş şemada (satır içi --kz-it); boyut değişince yeniden (ResizeObserver, karede değil)
  const initDia = (root = document) => $$('.kz-dia', root).forEach((d) => {
    if (d._kzP || !d.style.getPropertyValue('--kz-it') || !('ResizeObserver' in window)) return;
    const img = $(':scope > .kz-dia__img', d), pins = $$(':scope > .kz-dia__pin', d);
    if (!img || !pins.length) return;
    d._kzP = 1;
    pins.forEach((p) => { p._x = parseFloat(p.style.getPropertyValue('--x')) || 0; p._y = parseFloat(p.style.getPropertyValue('--y')) || 0; });
    new ResizeObserver(() => {
      const ps = window.kzPose(img), w = d.clientWidth, h = d.clientHeight, ol = img.offsetLeft, ot = img.offsetTop;
      pins.forEach((p) => {
        let [x, y] = [(p._x / 100) * w - ol, (p._y / 100) * h - ot];
        if (ps) [x, y] = ps.fw(x, y);
        p.style.setProperty('--x', `${(x + ol).toFixed(1)}px`); p.style.setProperty('--y', `${(y + ot).toFixed(1)}px`);
      });
    }).observe(d);
  });
  initDia();

  // ---------- Üst bar: logo ↔ güven maddeleri, sağdan sola ----------
  const rot = $('[data-kz-rot]');
  if (rot && !reduce) {
    const items = [...rot.children];
    const ms = (+rot.dataset.interval || 5) * 1000;
    let i = 0;
    if (items.length > 1) setInterval(() => {
      const cur = items[i];
      i = (i + 1) % items.length;
      const nxt = items[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      nxt.classList.remove('is-out'); nxt.classList.add('is-on');
      setTimeout(() => cur.classList.remove('is-out'), 600);
    }, ms);
  }

  // ---------- Menü: aç / X / Escape / arka plan / sola kaydırma ----------
  // Açılış: hidden kalkar, bir kare sonra .is-open (CSS kayma + solma, aynı süre); kapanış: .is-open kalkar, geçiş bitince
  // hidden (--kz-mn-d ile aynı süre). Durum .is-open'da. Menüdeki bir bağlantıya basınca da kapanır (sayfa içi gidişte).
  // Telefonda paneli sola kaydırmak kapatır. Eski işaretlemede (panelsiz) de çalışır
  const menu = $('[data-kz-menu]');
  const opener = $('[data-kz-menu-open]');
  let menuT = 0;
  const menuOpen = () => !!menu && !menu.hidden && menu.classList.contains('is-open');
  const setMenu = (open) => {
    if (!menu || open === menuOpen()) return;
    clearTimeout(menuT);
    if (open) {
      menu.hidden = false;
      void menu.offsetWidth; // görünür hali çizilsin, geçiş buradan başlasın
      menu.classList.add('is-open');
      lock(true);
      opener?.setAttribute('aria-expanded', 'true');
      (menu.querySelector('.kz-menu__x') || menu.querySelector('button, a'))?.focus({ preventScroll: true });
    } else {
      menu.classList.remove('is-open');
      lock(false);
      opener?.setAttribute('aria-expanded', 'false');
      menuT = setTimeout(() => { if (!menu.classList.contains('is-open')) { menu.hidden = true; menuDd.forEach((b) => ddSet(b, false)); } }, reduce || !menu.querySelector('.kz-menu__panel') ? 0 : 280); // --kz-mn-d (kz-base.css) + pay
      opener?.focus({ preventScroll: true });
    }
  };
  opener?.addEventListener('click', () => setMenu(true));
  // Modeller açılır listesi (kz-header): basınca ürünler aşağı açılır, menü kapanınca toplanır
  const menuDd = menu ? [...menu.querySelectorAll('[data-kz-menu-dd]')] : [];
  const ddSet = (b, o) => { const l = document.getElementById(b.getAttribute('aria-controls')); if (!l) return; b.setAttribute('aria-expanded', String(o)); l.hidden = !o; };
  menuDd.forEach((b) => b.addEventListener('click', () => ddSet(b, b.getAttribute('aria-expanded') !== 'true')));
  menu?.querySelectorAll('[data-kz-menu-close]').forEach((x) => x.addEventListener('click', () => setMenu(false)));
  menu?.addEventListener('click', (e) => { if (e.target === menu || e.target.closest('a[href]')) setMenu(false); });
  const mPanel = menu?.querySelector('.kz-menu__panel');
  if (mPanel) {
    let sx = 0, sy = 0, on = false;
    mPanel.addEventListener('touchstart', (e) => { const t = e.touches[0]; sx = t.clientX; sy = t.clientY; on = e.touches.length === 1; }, { passive: true });
    mPanel.addEventListener('touchend', (e) => {
      if (!on) return; on = false;
      const t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (dx < -60 && Math.abs(dx) > Math.abs(dy) * 1.5) setMenu(false);
    }, { passive: true });
  }

  // ---------- Alttan açılan paneller (model seçimi, Taksit Tablosu) ----------
  const stack = [];
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  // ---------- Taksit Tablosu (snippets/kz-inst-sheet): seçilen taksit sepete (kullanıcı isteği 28.10.2026) ----------
  // Satıra basınca seçilir (yeşil); tablonun altındaki sepete ekle seçimi sessionStorage'a yazar (kzInstPick: taksit
  // sayısı, Tek çekim 1), sepet sayfası (kz-cart.js) açılınca o satırı seçer. Ana sayfada buton bir /cart/add formu
  // (kz-inst-buy); Modeller sayfasında kutu boş gelir (data-kz-inst-clone), panel ilk açılınca kartın kendi Sepete
  // Ekle'si kopyalanır (aynı yazı, ikon, satır içi görünüm), basınca kartınki çalışır (ön sipariş, tek gönderim kilidi)
  const instSave = (sh) => {
    const on = sh && $('.kz-inst__row.is-on', sh);
    try { if (on) sessionStorage.setItem('kzInstPick', JSON.stringify({ n: +on.dataset.n || 1, at: Date.now() })); else sessionStorage.removeItem('kzInstPick'); } catch (e) { /* gizli sekme: seçim taşınmaz */ }
  };
  // Her basışta sepete eklenin çevresindeki çerçeve 500 ms'de bir kez yanıp söner (kz-base .kz-inst__buy.is-flash::after;
  // yeniden başlatmak için sınıf çıkarılıp
  // bir düzen okumasıyla geri konur: yalnız dokunuşta, karede değil)
  const instFlash = (el) => {
    if (!el) return;
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  };
  const instPick = (row) => {
    $$('.kz-inst__row[data-n]', row.closest('.kz-inst')).forEach((r) => { const on = r === row; r.classList.toggle('is-on', on); r.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    instFlash(row.closest('[data-kz-sheet]') && $('.kz-inst__buy', row.closest('[data-kz-sheet]')));
  };
  document.addEventListener('animationend', (e) => { if (e.animationName === 'kz-inst-flash') e.target.classList.remove('is-flash'); });
  const instClone = (sh, from) => {
    const box = $('[data-kz-inst-clone]', sh);
    if (!box || box.firstChild) return;
    const src = from?.closest?.('li, article')?.querySelector('.kz-lu__atc:not([disabled])');
    if (!src) { box.closest('.kz-inst__buy')?.setAttribute('hidden', ''); return; }
    const b = src.cloneNode(true);
    if (b.tagName === 'BUTTON') b.type = 'button';
    b.removeAttribute('name'); b.removeAttribute('aria-busy'); b.classList.remove('kz-over', 'is-busy');
    b.setAttribute('data-kz-inst-go', '');
    b._kzSrc = src;
    box.append(b);
  };
  document.addEventListener('click', (e) => {
    const r = e.target.closest?.('.kz-inst__row[data-n]');
    if (r) { instPick(r); return; }
    const g = e.target.closest?.('[data-kz-inst-go]');
    if (!g) return;
    instSave(g.closest('[data-kz-sheet]'));
    if (g.tagName !== 'A') { g.setAttribute('aria-busy', 'true'); g._kzSrc?.click(); } // bağlantı (seçenekli ürün) kendisi gider
  });
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches?.('.kz-inst__row[data-n]')) { e.preventDefault(); instPick(e.target); }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest?.('[data-kz-inst-f]');
    if (!f) return;
    // Tek gönderim: art arda basış sepete iki ürün koymasın (geri tuşuyla dönülünce pageshow sıfırlar)
    if (f._kzSent) { e.preventDefault(); return; }
    f._kzSent = true;
    $('button', f)?.setAttribute('aria-busy', 'true');
    instSave(f.closest('[data-kz-sheet]'));
  });
  addEventListener('pageshow', () => {
    $$('[data-kz-inst-f]').forEach((f) => { f._kzSent = false; $('button', f)?.removeAttribute('aria-busy'); });
    $$('[data-kz-inst-go]').forEach((g) => g.removeAttribute('aria-busy'));
  });
  const openSheet = (id, from) => {
    const sh = document.getElementById(id);
    if (!sh || sh.classList.contains('is-open')) return false;
    sh._from = from || document.activeElement;
    sh.classList.add('is-open');
    sh.removeAttribute('inert');
    $$('img[data-kz-src]', sh).forEach((im) => { im.src = im.dataset.kzSrc; im.removeAttribute('data-kz-src'); }); // panel logosu ilk açılışta iner
    instClone(sh, sh._from);
    lock(true);
    stack.push(sh);
    const panel = $('.kz-sheet__panel', sh);
    panel.scrollTop = 0;
    const msg = $('[data-kz-msg]', sh);
    if (msg) msg.textContent = '';
    setTimeout(() => panel.focus({ preventScroll: true }), 60);
    return true;
  };
  const closeSheet = (sh) => {
    if (!sh || !sh.classList.contains('is-open')) return;
    sh.classList.remove('is-open');
    sh.setAttribute('inert', '');
    lock(false);
    stack.splice(stack.indexOf(sh), 1);
    sh._from?.focus?.({ preventScroll: true });
  };
  $$('[data-kz-sheet]').forEach((sh) => sh.setAttribute('inert', ''));

  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-kz-open]');
    if (o) { e.preventDefault(); openSheet(o.dataset.kzOpen, o); return; }
    const c = e.target.closest('[data-kz-close]');
    if (c) {
      closeSheet(c.closest('[data-kz-sheet]'));
      if (c.tagName !== 'A') e.preventDefault(); // link ise (ör. #kz-alt) kaydırma devam eder
    }
  });

  // ---------- Sayfa içi bağlantılar (BAŞLA, İncele, #kz-alt…): ışınlama yerine yumuşak kaydırma ----------
  // Yavaş başlar, ortada hızlanır, yavaş durur (easeInOutCubic). Süre mesafeye göre 500-1200 ms. Kare hızı
  // yöneticisinin her kare yolundan (kzFps.addHi: ekranın yenileme hızında, en çok 60; zayıf cihaz basamağından ve
  // Tema ayarındaki hedeften bağımsız), zamana bağlı çizilir; hedef bir kez ölçülür (ilk karede: kapanan panel kaydırmayı
  // geri verdikten sonra), sonda bir kez düzeltilir. Kullanıcı dokunur/kaydırırsa durur. Hareketi azalt açıksa doğrudan
  // atlar. Geçiş boyunca kare hızı yargıcı ölçmez (kzFps.hold): geçişin takılması "zayıf cihaz" sayılmaz.
  // done: yalnız kayma sona varınca (kullanıcı kesmezse) çağrılır; "Ara durak" (data-kz-via) ikinci kaymayı buradan başlatır
  let stopGlide = null, stopVia = null;
  const glideTo = (el, done) => {
    stopGlide?.(); stopVia?.();
    if (reduce) { el.scrollIntoView({ block: 'start' }); done?.(); return; }
    const goal = () => {
      const mt = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      const max = document.documentElement.scrollHeight - innerHeight;
      return Math.max(0, Math.min(max, el.getBoundingClientRect().top + scrollY - mt));
    };
    const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - (-2 * x + 2) ** 3 / 2);
    let y0 = 0, d = 0, T = 0, t = 0, ready = false;
    const cancel = () => stopGlide?.();
    const off = kzFps.addHi((now, dt) => {
      if (!ready) {
        ready = true; y0 = scrollY; d = goal() - y0;
        if (Math.abs(d) < 2) { cancel(); done?.(); return; }
        T = Math.min(1200, Math.max(500, 350 + Math.abs(d) * 0.3));
        return;
      }
      t = Math.min(T, t + dt);
      scrollTo(0, y0 + d * ease(t / T));
      if (t >= T) { cancel(); const g = goal(); if (Math.abs(g - scrollY) > 1) scrollTo(0, g); done?.(); }
    });
    const evs = ['wheel', 'touchstart', 'keydown'];
    stopGlide = () => { off(); evs.forEach((ev) => removeEventListener(ev, cancel)); stopGlide = null; window.kzGliding = false; kzFps.hold(false); dispatchEvent(new Event('kz:glided')); };
    window.kzGliding = true; kzFps.hold(true); dispatchEvent(new Event('kz:glide'));
    evs.forEach((ev) => addEventListener(ev, cancel, { passive: true }));
  };
  window.kzGlide = glideTo;
  // Ara durak (öğe butonu "Ara durak", 26.10.2026): önce v'ye kayar, ms bekler (bölüm bu sırada normal gösterilir:
  // belirme animasyonları kz:glided'de başlar), sonra el'e. Beklerken dokunma / tekerlek / tuş ikinci kaymayı iptal eder.
  // Zamanlayıcı kare çizmez, yalnız ikinci kaymayı başlatır (kayma yine kzFps.addHi karelerinde)
  const glideVia = (v, el, ms) => glideTo(v, () => {
    const evs = ['wheel', 'touchstart', 'keydown'];
    const id = setTimeout(() => { stopVia?.(); glideTo(el); }, ms);
    stopVia = () => { clearTimeout(id); evs.forEach((ev) => removeEventListener(ev, stopVia)); stopVia = null; };
    evs.forEach((ev) => addEventListener(ev, stopVia, { passive: true }));
  });
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    // "Butona basınca git" (editör): bölüm türü; modüller sayfadaki sırasıyla (mod1 = yukarıdan ilk "Kladiora modül")
    const go = a.dataset.kzGo;
    if (go) {
      e.preventDefault();
      const SEL = { hero: '.kz-hero', reviews: '#kz-reviews', models: '#kz-models', specs: '#kz-specs', '3d': '#kz-3d', alt: '#kz-alt', footer: '.kz-foot' };
      const find = (k) => { const m = /^mod(\d+)$/.exec(k); return m ? $$('section.kz-module')[+m[1] - 1] : SEL[k] && $(SEL[k]); };
      const el = find(go);
      const v = a.dataset.kzVia && find(a.dataset.kzVia);
      if (el && v) glideVia(v, el, Math.max(0, +a.dataset.kzViaMs || 0));
      else if (el) glideTo(el);
      return;
    }
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.search !== location.search || u.hash.length < 2) return;
    let el = null;
    try { el = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (err) { return; }
    if (!el) return;
    e.preventDefault();
    glideTo(el);
  });

  addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (stack.length) closeSheet(stack[stack.length - 1]);
      else if (menuOpen()) setMenu(false);
      return;
    }
    if (e.key === 'Tab' && stack.length) {
      const panel = $('.kz-sheet__panel', stack[stack.length - 1]);
      const f = $$(FOCUSABLE, panel).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ---------- Model seçim paneli: tek varyantlı ürün sepete eklenir, sepete gidilir ----------
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('#kz-buy [data-kz-add]');
    if (!a) return;
    const sh = a.closest('[data-kz-sheet]');
    const msg = $('[data-kz-msg]', sh);
    if (a.hasAttribute('data-kz-missing')) {
      e.preventDefault();
      msg.textContent = design
        ? 'Bu model için ürün seçilmedi: tema editörü → Kladiora modeller → Model kartı → Ürün.'
        : 'Bu model yakında satışta.';
      return;
    }
    const id = a.dataset.kzAdd;
    if (!id) return; // varyantlı ürün: ürün sayfasına gider
    e.preventDefault();
    const row = a.closest('.kz-row');
    row.classList.add('is-busy');
    msg.textContent = 'Sepete ekleniyor…';
    try {
      const r = await fetch(sh.dataset.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'Sepete eklenemedi.');
      location.href = sh.dataset.cartUrl;
    } catch (err) {
      row.classList.remove('is-busy');
      msg.textContent = `${err.message} Tekrar dene ya da modelin sayfasına git.`;
    }
  });

  // ---------- Yorum ve güven (sections/kz-proof.liquid): yorum gösterici + "Kaydırmaya devam et" ----------
  // Karta dokununca tam ekran pencere: büyük fotoğraf (kartın <template>'inden; yalnız açılınca iner), yıldız + isim,
  // Doğrulanmış, yorumun tamamı (kartın kendi parçalarının kopyası: etiketler ve görünüm ayarları aynı). Önceki /
  // sonraki (oklar, klavye okları, yana kaydırma), kapat (X, zemin, Escape, telefonun geri hareketi). Pencere açılınca
  // body'ye taşınır (bölümün katmanından çıkar: üst bar ve alt barın üstünde), kapanınca yerine döner. Olay
  // delegasyonuyla: editörde bölüm yeniden çizilince de çalışır
  const pv = { el: null, home: null, list: [], i: 0, pushed: false, from: null };
  const pvShow = (i, dir) => {
    const r = pv.list[i]; if (!r) return;
    pv.i = i;
    // Geçiş: sonraki sağdan, önceki soldan kayarak gelir (kz-base.css .is-to-n / .is-to-p; animasyon yeniden başlar)
    pv.el.classList.remove('is-to-n', 'is-to-p');
    if (dir) { void pv.el.offsetWidth; pv.el.classList.add(dir > 0 ? 'is-to-n' : 'is-to-p'); }
    const img = $('[data-kz-pv-img]', pv.el), b = $('[data-kz-pv-b]', pv.el), tp = $('template[data-kz-pf-big]', r);
    img.replaceChildren(tp ? tp.content.cloneNode(true) : document.createTextNode(''));
    const row = document.createElement('div'); row.className = 'kz-pf__top';
    ['.kz-pf__s', '.kz-pf__n'].forEach((q) => { const n = $(q, r); if (n) row.appendChild(n.cloneNode(true)); });
    const v = $('.kz-pf__v', r), t = $('.kz-pf__t', r);
    const tc = t && t.cloneNode(true);
    if (tc && t._kzFull != null) { tc.innerHTML = t._kzFull; tc.classList.remove('is-cut'); } // pencerede yorumun tamamı
    b.replaceChildren(row, ...[v, tc].filter(Boolean).map((n) => (n === tc ? n : n.cloneNode(true))));
    $('[data-kz-pv-go="-1"]', pv.el).hidden = i === 0;
    $('[data-kz-pv-go="1"]', pv.el).hidden = i === pv.list.length - 1;
    $('.kz-pv__card', pv.el).scrollTop = 0;
  };
  const pvClose = (fromBack) => {
    const el = pv.el; if (!el || el.hidden) return;
    el.classList.remove('is-on'); lock(false); window.kzPvOpen = false;
    if (pv.pushed && !fromBack) history.back();
    pv.pushed = false; pv.el = null;
    setTimeout(() => { el.hidden = true; pv.home?.appendChild(el); pv.from?.focus?.({ preventScroll: true }); }, reduce ? 0 : 220);
  };
  document.addEventListener('click', (e) => {
    const nx = e.target.closest('[data-kz-pf-next]');
    if (nx) {
      // Bir sonraki bölüm (Kladiora bölümü ya da Shopify bölümü); "Bölüme gidiş" payı glideTo'da (scroll-margin)
      const sh = nx.closest('.shopify-section')?.nextElementSibling;
      const to = sh && (sh.querySelector('.kz-sec') || sh);
      if (to) glideTo(to);
      return;
    }
    const op = e.target.closest('[data-kz-pf-open]');
    if (op) {
      const sec = op.closest('.kz-pf'), el = sec && sec.parentElement.querySelector('[data-kz-pv]');
      if (!el || pv.el) return;
      pv.el = el; pv.home = el.parentElement; pv.from = op;
      pv.list = $$('[data-kz-pf]', sec);
      pvShow(pv.list.indexOf(op.closest('[data-kz-pf]')));
      document.body.appendChild(el); el.hidden = false; void el.offsetWidth;
      el.classList.add('is-on'); lock(true); window.kzPvOpen = true; // atmosfer efektleri durur (kz-fx.js)
      try { history.pushState({ kzpv: 1 }, ''); pv.pushed = true; } catch (err) { pv.pushed = false; }
      $('.kz-pv__x', el)?.focus({ preventScroll: true });
      return;
    }
    if (!pv.el || !pv.el.contains(e.target)) return;
    const go = e.target.closest('[data-kz-pv-go]');
    if (go) { const d = Number(go.dataset.kzPvGo); pvShow(pv.i + d, d); return; }
    if (e.target.closest('[data-kz-pv-x]')) pvClose(false);
  });
  addEventListener('keydown', (e) => {
    if (!pv.el) return;
    if (e.key === 'Escape') pvClose(false);
    else if (e.key === 'ArrowRight' && pv.i < pv.list.length - 1) pvShow(pv.i + 1, 1);
    else if (e.key === 'ArrowLeft' && pv.i > 0) pvShow(pv.i - 1, -1);
  });
  addEventListener('popstate', () => { if (pv.el) pvClose(true); });
  // Kartta sığmayan yorum (kullanıcı isteği): sona yeşil "…"; kesilen yerin sonundaki boşluk ve "." görünmez. Tarayıcının
  // satır kesmesi (-webkit-line-clamp) "…"dan önceki karakteri seçtirmez: kesme burada. Yorumun 6 satıra (CSS'teki
  // sınır) sığan en uzun başı ikili aramayla bulunur (etiketler korunur: Range ile kesilir), sondaki boşluk / nokta atılır,
  // paragrafın yeşiliyle "…" eklenir. Tamamı t._kzFull'da (pencere onu gösterir). Açılışta, yazı tipleri inince, ekran
  // genişliği değişince ve bölüm yeniden çizilince (kare döngüsü yok). JS yoksa CSS'in yeşil "…"ı kalır
  const pfCut = (root = document) => $$('.kz-pf__t', root).forEach((t) => {
    if (t._kzFull == null) t._kzFull = t.innerHTML;
    t.innerHTML = t._kzFull; t.classList.remove('is-cut');
    if (t.scrollHeight <= t.clientHeight + 1) return; // sığıyor
    const cs = getComputedStyle(t), lines = parseInt(cs.webkitLineClamp, 10) || 6;
    const max = lines * (parseFloat(cs.lineHeight) || 23) + 1;
    t.classList.add('is-cut');
    const src = document.createElement('div'); src.innerHTML = t._kzFull;
    const nodes = []; const tw = document.createTreeWalker(src, NodeFilter.SHOW_TEXT); while (tw.nextNode()) nodes.push(tw.currentNode);
    const all = nodes.map((n) => n.nodeValue).join('');
    const build = (k) => {
      const c = src.cloneNode(true), cn = []; const w = document.createTreeWalker(c, NodeFilter.SHOW_TEXT); while (w.nextNode()) cn.push(w.currentNode);
      let left = k, i = 0;
      for (; i < cn.length && left > cn[i].nodeValue.length; i++) left -= cn[i].nodeValue.length;
      if (i < cn.length) { const r = document.createRange(); r.setStart(cn[i], left); r.setEndAfter(c.lastChild); r.deleteContents(); }
      t.innerHTML = c.innerHTML; t.append('…');
    };
    let lo = 0, hi = all.length;
    while (lo < hi) { const m = Math.ceil((lo + hi) / 2); build(m); if (t.scrollHeight <= max) lo = m; else hi = m - 1; }
    let k = lo; while (k > 0 && /[\s.]/.test(all[k - 1])) k--;
    build(k);
  });
  pfCut(); document.fonts?.ready.then(() => pfCut()); onWidth(() => pfCut());
  document.addEventListener('shopify:section:load', (e) => pfCut(e.target));
  {
    let sx = 0, sy = 0, on = false;
    document.addEventListener('touchstart', (e) => { if (!pv.el || !e.target.closest?.('.kz-pv__card')) return; const t = e.touches[0]; sx = t.clientX; sy = t.clientY; on = e.touches.length === 1; }, { passive: true });
    document.addEventListener('touchend', (e) => {
      if (!on || !pv.el) return; on = false;
      const t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { const d = dx < 0 ? 1 : -1, j = pv.i + d; if (j >= 0 && j < pv.list.length) pvShow(j, d); }
    }, { passive: true });
  }

  // ---------- 3D penceresi: Sepete Ekle (kz-3d.liquid; ürün snippets/kz-3d-atc.liquid: Aion Z Pro) ----------
  // Varyant kodu varsa sepete eklenir ve sepete gidilir; yoksa ya da eklenemezse ürünün sayfasına
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-kz-3d-atc]');
    if (!b || b.classList.contains('is-busy')) return;
    const id = b.dataset.pv, url = b.dataset.pu, t = $('[data-kz-3d-atc-t]', b), lb = t.textContent;
    if (!id) { if (url) location.href = url; return; }
    b.classList.add('is-busy'); t.textContent = 'Ekleniyor…';
    try {
      const r = await fetch(b.dataset.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error();
      location.href = b.dataset.cartUrl;
    } catch (err) {
      t.textContent = 'Eklenemedi';
      setTimeout(() => { if (url) location.href = url; else { t.textContent = lb; b.classList.remove('is-busy'); } }, 1200);
    }
  });

  // ---------- Alt bar (landing; telefon ve bilgisayar) ----------
  // Hangi bölümlerde görüneceği Tema ayarları → Kladiora: alt bar (data-on). Geçerli bölüm ekranın %40 çizgisindeki
  // bölümdür; işaretliyse bar görünür, işaretsiz bir bölüm ekranın ortasını (%15-85) kaplıyorsa gizlenir (hero: üst barın
  // altına girene kadar). Bölümden bölüme bar yerinde kalır, yalnız içerik yumuşak değişir: bölümün "Alt bar: …"
  // blokları (<template data-kz-dock-c>, snippets/kz-dock-c.liquid) ya da standart içerik (bölüm adı + "İncele" →
  // modellere kaydırır, modeller geçilince "Satın al" → model seçim paneli).
  const dock = $('[data-kz-dock]');
  // Hiçbir bölümde açık değilse (Tema ayarları → Kladiora: alt bar) hiçbir dinleyici ve ölçüm kurulmaz (29.09.2026):
  // kapalı bar her kaydırmada, her araç çubuğu açılıp kapanışında ve sayfa boyu değişiminde ölçülüyordu (KARARLAR §8)
  if (dock && (dock.dataset.on || '').split(',').some(Boolean)) {
    const btn = $('[data-kz-dock-btn]', dock);
    const nameEl = $('[data-kz-dock-name]', dock);
    const inner = $('.kz-dock__in', dock);
    const slot = $('[data-kz-dock-slot]', dock);
    const hero = $('[data-kz-hero]');
    const models = $('[data-kz-models]');
    const on = new Set((dock.dataset.on || '').split(',').filter(Boolean));
    let mode = '';
    let label = '';
    const setLabel = (t) => {
      if (!t || t === label) return;
      label = t;
      nameEl.classList.add('is-swap');
      // Ad editördeki metin etiketlerini (<yesil> vb.) taşıyabilir: HTML olarak basılır
      setTimeout(() => { nameEl.innerHTML = tagHtml(t); nameEl.classList.remove('is-swap'); }, reduce ? 0 : 180);
    };
    // Bölümler ve anahtarları (tema ayarındaki kutular; modüller sayfadaki sırasıyla mod1, mod2…)
    let secs = [];
    const scan = () => {
      secs = [];
      const add = (el, k) => { if (el) secs.push({ el, k, w: el.closest('.shopify-section') || el }); };
      add(hero, 'hero');
      $$('section.kz-module').forEach((m, i) => add(m, `mod${i + 1}`));
      add($('#kz-reviews'), 'reviews'); add(models, 'models'); add($('#kz-specs'), 'specs');
      add($('#kz-3d'), '3d'); add($('#kz-alt'), 'alt'); add($('.kz-foot'), 'footer');
    };
    // Bölüm, ad ve buton dikdörtgenleri sayfa koordinatında bir kez ölçülür (tarama, sayfa boyu değişince, yazı tipleri
    // inince, pencere boyu, kaydırma sonu); kaydırma karesinde yalnız scrollY ile hesaplanır: karede düzen okuması yok.
    // Önce her karede ≥ 21 getBoundingClientRect + belge çapında sorgu vardı (28.09.2026, ölçüm KARARLAR §8)
    let rects = [], names = [], btns = [], mB = -1, VH = innerHeight, dockH = 0;
    const measure = () => {
      const sy = scrollY; VH = innerHeight; dockH = dock.offsetHeight;
      const doc = (el) => { const r = el.getBoundingClientRect(); return { t: r.top + sy, b: r.bottom + sy, h: r.height }; };
      rects = secs.map((x) => ({ x, ...doc(x.w), tpl: $('template[data-kz-dock-c]', x.w) }));
      mB = models ? doc(models).b : -1;
      names = $$('[data-kz-name]').filter((el) => el.dataset.kzName).map((el) => ({ n: el.dataset.kzName, ...doc(el) }));
      btns = $$('.kz-sec .kz-btn, .kz-sec .kz-btn2, .kz-hero .kz-btn, .kz-hero .kz-btn2').map(doc);
    };
    scan(); measure();
    // Hero üst barın altına girince geçilmiş sayılır. Eşik üst barın gerçek yüksekliği (--kz-bar-h): sayfa içi
    // kaydırma (hero butonu → modül) bölümü tam üst barın altına getirir, hero'nun alt kenarı orada durur
    let barH = 0, yielded = false, cur = null, src;
    // Alt barın kapladığı şeritte (ekranın altı) sayfanın görünen bir butonu var mı (önbellekteki dikdörtgenlerle)
    const covered = () => {
      const sy = scrollY, top = sy + VH - dockH;
      return btns.some((b) => b.h > 0 && b.b > top && b.t < sy + VH);
    };
    const readBar = () => { barH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kz-bar-h')) || 40; };
    readBar();
    // İçerik: bölümün alt bar blokları varsa onlar, yoksa standart içerik. Bar açıksa yumuşak geçiş
    let swapT = 0;
    const fill = (tpl) => {
      if (tpl === src) return;
      src = tpl;
      const put = () => {
        if (tpl) { slot.replaceChildren(tpl.content.cloneNode(true)); okFit(slot); glowScan(slot); } else slot.replaceChildren();
        dock.classList.toggle('is-custom', !!tpl);
        inner.classList.remove('is-swap');
      };
      clearTimeout(swapT);
      if (!dock.classList.contains('is-on') || reduce) { put(); return; }
      inner.classList.add('is-swap'); swapT = setTimeout(put, 180);
    };
    const update = () => {
      const sy = scrollY, vh = VH, y = sy + vh * 0.4;
      // Geçerli bölüm (%40 çizgisi); bölümler arası boşlukta öncekini tut
      const hit = rects.find((r) => r.t <= y && r.b > y);
      if (hit) cur = hit;
      // İşaretsiz bölüm ekranın ortasını kaplıyorsa gizle; hero üst barın altına girene kadar sayılır
      const block = rects.some((r) => {
        if (on.has(r.x.k)) return false;
        const t = r.t - sy, b = r.b - sy;
        return r.x.k === 'hero' ? b > barH + 2 && t < vh : t < vh * 0.85 && b > vh * 0.15;
      });
      let afterModels = false;
      if (models) afterModels = mB - sy <= vh * 0.15;
      // Sayfadaki bir buton alt barın altında kalıyorsa bar ona yer verir (kısa ekran: kaydırma bitince buton alt
      // barın altına düşebilir); buton barın üstüne çıkınca bar geri gelir. Kaydırma sürerken karar değişmez
      if (yielded && !covered()) yielded = false;
      const show = !!cur && on.has(cur.x.k) && !block && !yielded && !window.kzGliding;
      if (cur) fill(cur.tpl);
      dock.classList.toggle('is-on', show);
      const m = afterModels ? 'buy' : 'look';
      if (m !== mode) {
        mode = m;
        btn.innerHTML = `<span class="kz-lb">${m === 'buy' ? btn.dataset.labelB : btn.dataset.labelA}</span>`;
        okFit(btn);
        btn.setAttribute('aria-haspopup', m === 'buy' ? 'dialog' : 'false');
      }
      const nm = names.find((n) => n.t <= y && n.b > y);
      setLabel(nm ? nm.n : label || nameEl.dataset.default);
    };
    btn.addEventListener('click', () => {
      if (mode === 'buy') {
        if (!openSheet('kz-buy', btn)) location.href = dock.dataset.buyUrl;
      } else if (models) {
        glideTo(models);
      }
    });
    // Alt bar bloklarındaki "Model seçim panelini aç" butonu (bölüme giden butonlar sayfa içi kaydırmayla gider)
    dock.addEventListener('click', (e) => {
      const b = e.target.closest('[data-kz-dock-buy]');
      if (b && !openSheet('kz-buy', b)) location.href = dock.dataset.buyUrl;
    });
    let raf = 0, idleT = 0;
    const idle = () => { measure(); yielded = covered(); update(); }; // kaydırma durunca: bir ölçüm, bir karar
    addEventListener('scroll', () => {
      if (window.kzGliding) return; // sayfa içi yumuşak kaydırmada bar gizli (kz:glide), bitince idle (kz:glided): karede ölçüm yok
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); });
      clearTimeout(idleT); idleT = setTimeout(idle, 150); // kaydırma durunca bir kez
    }, { passive: true });
    addEventListener('kz:glide', () => { clearTimeout(idleT); dock.classList.remove('is-on'); });
    addEventListener('kz:glided', idle);
    // Yalnız boy değişince (araç çubuğu) dikdörtgenler aynı (sayfa koordinatı): yalnız görünen boy; genişlikte hepsi
    addEventListener('resize', () => { VH = innerHeight; update(); }, { passive: true });
    onWidth(() => { readBar(); measure(); update(); });
    // Sayfa boyu değişince (görsel indi, Devamını gör, yazı tipi) dikdörtgenler yeniden: düzenden sonra, boyamadan önce
    if ('ResizeObserver' in window) new ResizeObserver(() => { measure(); update(); }).observe(document.body);
    document.fonts?.ready.then(() => { measure(); update(); });
    // Tema editörü: bölüm yeniden çizilince bölüm listesi ve alt bar içeriği yenilenir
    document.addEventListener('shopify:section:load', () => { scan(); measure(); src = undefined; update(); });
    document.addEventListener('shopify:section:unload', () => setTimeout(() => { scan(); measure(); src = undefined; update(); }, 0));
    update();
  }

  // ---------- Giriş animasyonu: yalnızca ekranın altında kalanlar gizlenir, görünür içerik kaybolmaz ----------
  let initReveal = () => {};
  if (!reduce && 'IntersectionObserver' in window) {
    // Sınıf yazımı karenin sonunda (kzFps.write): kaydırma karesinde ikinci stil/düzen hesabı yok; bir kare (≤ 16 ms) geç
    // Sayfa içi kaydırma (buton) üstünden geçip giderken belirme başlamaz (29.09.2026, uygulama içi tarayıcı kasması;
    // KARARLAR §8): geçiş bitince yeniden gözlenir, o an ekrandakiler belirir, geçilenler geri dönülünce (başlık
    // animasyonu gibi, kz:glided)
    const later = (ob, el) => addEventListener('kz:glided', () => ob.observe(el), { once: true });
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      if (window.kzGliding) { later(io, e.target); return; }
      kzFps.write(() => e.target.classList.remove('is-pre'));
    // Gizliyken öğe 24 px aşağıda durur (kz-base.css .kz-rv.is-pre): pay +24 px, yani öğenin asıl yeri ekrana girdiği an
    // belirir. Önce -%8'di: ekranın en altındaki öğe (ör. kısa ekranda bölümün son butonu) görünür yerdeyken gizli kalıyordu
    }), { rootMargin: '0px 0px 24px 0px' });
    // Erken belirme (data-kz-rv-at="head", ör. Farkları gör butonu, 28.09.2026 kullanıcı isteği): öğe kendisi değil,
    // bölümün başlığı ekrana girince belirir; ziyaretçi öğeye kadar kaydırmadan öğe hazır olur. Başlık zaten
    // ekrandaysa öğe hiç gizlenmez
    const trig = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      // Geçişte başlık geçilip gidildiyse bekleyen öğeler kendileri ekrana girince de belirir (hangisi önce gelirse)
      if (window.kzGliding) { trig.unobserve(e.target); later(trig, e.target); (e.target._kzRv || []).forEach((x) => later(io, x)); return; }
      const xs = e.target._kzRv || [];
      e.target._kzRv = null; trig.unobserve(e.target);
      kzFps.write(() => xs.forEach((x) => x.classList.remove('is-pre')));
    }), { rootMargin: '0px 0px 24px 0px' });
    initReveal = (root) => {
      const vh = innerHeight;
      const rows = $$('.kz-rv', root).map((el) => {
        if (el.closest('[data-kz-in]')?.dataset.kzIn === 'none') return null;
        if (el.getBoundingClientRect().top <= vh) return null;
        if (el.dataset.kzRvAt === 'head') {
          const sec = el.closest('section'), t = sec && ($('h1, h2, h3', sec) || sec);
          if (!t || t.getBoundingClientRect().top <= vh) return null;
          return { el, t };
        }
        return { el };
      });
      rows.forEach((r) => { if (!r) return; r.el.classList.add('is-pre'); if (r.t) { (r.t._kzRv ||= []).push(r.el); trig.observe(r.t); } else io.observe(r.el); });
    };
    initReveal(document);
  }

  // ---------- Video: en uygun çözünürlük, geç yükleme, ekrandayken oynatma ----------
  // Poster görseli sayfayla gelir (LCP). Video dosyası sayfa yüklendikten sonra ve yalnızca
  // ekrana yaklaşınca indirilir. Veri tasarrufu açıksa ya da bağlantı 2G ise yalnız poster kalır.
  const pickSrc = (list, box, dmax = 2) => {
    list = list.filter((s) => s.u).sort((a, b) => a.h - b.h);
    if (!list.length) return null;
    let cap = Infinity;
    if (conn.effectiveType === '3g' || (conn.downlink && conn.downlink < 1.5)) cap = 480;
    else if (conn.downlink && conn.downlink < 5) cap = 720;
    const pool = list.filter((s) => !s.h || s.h <= cap);
    const use = pool.length ? pool : [list[0]];
    const need = box.clientHeight * Math.min(devicePixelRatio || 1, dmax) * isc(box);
    return (use.find((s) => s.h >= need) || use[use.length - 1]).u;
  };
  let initVideos = () => {};
  if (!reduce && !slow && 'IntersectionObserver' in window) {
    const start = (box) => {
      if (box._v) return;
      let list = [];
      try { list = JSON.parse(box.dataset.srcs || '[]'); } catch (err) { list = []; }
      const src = pickSrc(list, box);
      if (!src) return;
      const v = $('video', box);
      box._v = v;
      v.addEventListener('playing', () => box.classList.add('is-playing'), { once: true });
      v.preload = 'auto';
      v.src = src;
    };
    const play = new IntersectionObserver((es) => es.forEach((e) => {
      const box = e.target;
      if (e.isIntersecting) { start(box); box._v?.play().catch(() => {}); } else box._v?.pause();
    }), { threshold: 0.2 });
    const near = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { start(e.target); near.unobserve(e.target); }
    }), { rootMargin: '400px 0px' });
    initVideos = (root) => $$('[data-kz-video]', root).forEach((box) => {
      if (box._vinit) return; box._vinit = true;
      if (!box.hasAttribute('data-eager')) near.observe(box);
      play.observe(box);
    });
    afterLoad(() => initVideos(document));
  }

  // ---------- GIF oynatıcı (dokununca oynayan video, fotoğraf galerisi) ----------
  // Dosya fetch ile iner, omggif (assets/kz-gif.js, yalnız gerekince) ile çözülür; ilk kare hemen çizilir. Kareler kzFps'ten
  // GIF'in kendi kare süreleriyle, zamana bağlı ilerler. Chroma key açıksa kareler kz-ck.js'e (m._ckRaw), değilse tuvale
  // (.kz-tv__cv). play(): döngü (dokununca video); play({ once: true, onEnd }): son karenin süresi dolunca durur, onEnd
  // çağrılır (galeri). Kutu başına bir kez çözülür (m._gp); ilk kare çizilince m._gf.
  let gifLib = null;
  const loadGifLib = () => gifLib || (gifLib = window.KzGifReader ? Promise.resolve() : new Promise((ok, no) => {
    const sc = document.createElement('script'); sc.src = window.kzAssets.gif; sc.onload = ok; sc.onerror = no; document.head.appendChild(sc);
  }));
  // Chroma key motoru bu kutuyu hazırlayana kadar bekle (en çok 5 sn; olmazsa anahtarsız çizilir)
  const ckReady = (m) => new Promise((ok) => {
    if (!m.hasAttribute('data-kz-ck')) return ok();
    let n = 0; const chk = () => (m._ckRaw || m.classList.contains('is-ck-fail') || ++n > 50 ? ok() : setTimeout(chk, 100)); chk();
  });
  const gifPlay = (m) => m._gp || (m._gp = (async () => {
    await loadGifLib();
    const bytes = new Uint8Array(await (await fetch(m.dataset.gif)).arrayBuffer());
    await ckReady(m);
    const g = new window.KzGifReader(bytes);
    const w = g.width, h = g.height, n = g.numFrames();
    const buf = new Uint8Array(w * h * 4);
    let cv = null, ctx = null, img = null;
    const paint = () => {
      if (m._ckRaw && !m.classList.contains('is-ck-fail')) { m._ckRaw(buf, w, h); return; }
      if (!cv) {
        cv = document.createElement('canvas'); cv.className = 'kz-tv__cv'; cv.width = w; cv.height = h; cv.setAttribute('aria-hidden', 'true');
        m.appendChild(cv); ctx = cv.getContext('2d'); img = new ImageData(new Uint8ClampedArray(buf.buffer), w, h);
      }
      ctx.putImageData(img, 0, 0);
    };
    let i = 0, prev = null, info = null, acc = 0, stop = null, once = false, onEnd = null;
    const blit = (k) => {
      if (k === 0) { buf.fill(0); prev = null; }
      if (prev && prev.disposal === 2) {
        for (let y = prev.y; y < prev.y + prev.height; y++) buf.fill(0, (y * w + prev.x) * 4, (y * w + prev.x + prev.width) * 4);
      }
      const f = g.frameInfo(k); g.decodeAndBlitFrameRGBA(k, buf); prev = f; info = f;
    };
    const dly = () => Math.max(20, (info.delay || 10) * 10);
    blit(0); paint(); m.classList.add('is-f0'); m._gf = 1;
    return {
      n,
      restart() { i = 0; acc = 0; blit(0); paint(); },
      play(o = {}) {
        once = !!o.once; onEnd = o.onEnd || null;
        if (stop) return;
        stop = kzFps.add((t, dt) => {
          acc += dt; let ch = false, guard = 0;
          while (acc >= dly()) {
            if (once && i === n - 1) {
              // Son kare süresini doldurdu: son karede dur, haber ver
              if (ch) paint();
              stop?.(); stop = null; const f = onEnd; onEnd = null; f?.();
              return;
            }
            acc -= dly(); i = (i + 1) % n; blit(i); ch = true;
            if (++guard > 8) { acc = 0; break; }
          }
          if (ch) paint();
        });
      },
      pause() { stop?.(); stop = null; },
    };
  })().catch((err) => { m._gp = null; throw err; }));

  // ---------- Dokununca oynayan video (snippets/kz-tapvid.liquid) ----------
  // İlk kare görseli sayfayla gelir. Dokununca (görsel ya da oynat düğmesi) video/GIF ilk kareden başlar, döngüyle
  // oynar; yeniden dokununca durur (ayar kapalı değilse), ekrandan çıkınca durur. Dosya: hızlı bağlantıda sayfa
  // yüklendikten sonra ekrana yaklaşınca, değilse dokununca iner. Dokunarak açıldığı için kalite piksel yoğunluğu 3'e
  // kadar seçilir (bağlantı sınırı pickSrc'de). GIF: omggif ile çözülür, kareler kzFps'ten zamana bağlı ilerler;
  // chroma key açıksa kareler kz-ck.js'e (box._ckRaw), değilse tuvale çizilir. İlk kare görseli yoksa GIF'in ilk karesi.
  let initTv = () => {};
  {
    const fastNet = !slow && (!conn.effectiveType || conn.effectiveType === '4g') && (!conn.downlink || conn.downlink >= 5);
    const vidLoad = (m) => {
      if (m._v) return m._v;
      let list = [];
      try { list = JSON.parse(m.dataset.srcs || '[]'); } catch (err) { list = []; }
      const src = pickSrc(list, m, 3);
      const v = $('video', m);
      if (!src || !v) return null;
      v.addEventListener('playing', () => m.classList.add('is-playing'));
      v.preload = 'auto'; v.src = src; m._v = v;
      return v;
    };
    const pause = (tv) => {
      const m = $('.kz-tv__m', tv);
      tv.classList.remove('is-on', 'is-wait');
      m._v?.pause(); m._gp?.then((p) => p.pause()).catch(() => {});
    };
    const play = async (tv) => {
      const m = $('.kz-tv__m', tv);
      tv.classList.add('is-on');
      const first = !tv._started; tv._started = true;
      if (m.dataset.srcs) {
        const v = vidLoad(m); if (!v) { pause(tv); return; }
        if (first) { try { v.currentTime = 0; } catch (err) { /* henüz yüklenmedi: zaten baştan */ } }
        if (v.readyState < 3) { tv.classList.add('is-wait'); v.addEventListener('playing', () => tv.classList.remove('is-wait'), { once: true }); }
        v.play().catch(() => pause(tv));
      } else if (m.dataset.gif) {
        tv.classList.add('is-wait');
        let p = null;
        try { p = await gifPlay(m); } catch (err) { p = null; }
        tv.classList.remove('is-wait');
        if (!p || !tv.classList.contains('is-on')) { if (!p) pause(tv); return; }
        if (first) p.restart();
        p.play();
      }
    };
    const onScreen = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting && e.target.classList.contains('is-on')) pause(e.target);
    }), { threshold: 0 }) : null;
    const near = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      near.unobserve(e.target);
      const tv = e.target, m = $('.kz-tv__m', tv);
      if (m.dataset.srcs) { if (fastNet) vidLoad(m); }
      else if (m.dataset.gif && (fastNet || (!slow && !$('.kz-vid__poster', m)))) gifPlay(m).catch(() => {});
    }), { rootMargin: '400px 0px' }) : null;
    initTv = (root) => $$('[data-kz-tv]', root).forEach((tv) => {
      if (tv._tv) return; tv._tv = true;
      $('.kz-tv__hit', tv).addEventListener('click', () => {
        if (tv.classList.contains('is-on')) { if (!tv.hasAttribute('data-nopause')) pause(tv); } else play(tv);
      });
      onScreen?.observe(tv);
      if (near) afterLoad(() => near.observe(tv));
    });
    initTv(document);
  }

  // ---------- Model kartları (sections/kz-models.liquid): kaydırmalı şerit, oklar, sayfa çizgileri ----------
  // Ekrandaki kart (.is-on, yeşil çerçeve) ve çizgi kaydırmaya göre; ilk kartta yalnız "sonraki", sonda yalnız "önceki"
  // ok. Kartlar sığıyorsa (bilgisayar) oklar gizli. Ölçüm karede değil: kaydırma olayında yalnız scrollLeft okunur
  const initModels = (root = document) => $$('[data-kz-mw]', root).forEach((w) => {
    if (w._kzM) return;
    const sc = $('[data-kz-ms]', w); const cards = sc ? $$('.kz-pc', sc) : [];
    if (cards.length < 2) return;
    w._kzM = 1;
    const dots = $$('.kz-models__dot', w), pv = $('.kz-models__ar--p', w), nx = $('.kz-models__ar--n', w);
    let step = 1, max = 0, cur = -1;
    const measure = () => { step = (cards[1].offsetLeft - cards[0].offsetLeft) || 1; max = sc.scrollWidth - sc.clientWidth; };
    const set = () => {
      const x = sc.scrollLeft;
      const i = max <= 2 ? 0 : x >= max - 2 ? cards.length - 1 : Math.min(cards.length - 1, Math.round(x / step));
      if (pv) pv.hidden = max <= 2 || x <= 2;
      if (nx) nx.hidden = max <= 2 || x >= max - 2;
      if (i === cur) return;
      cur = i;
      cards.forEach((c, k) => c.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    };
    [pv, nx].forEach((b) => b?.addEventListener('click', () => sc.scrollBy({ left: +b.dataset.d * step, behavior: reduce ? 'auto' : 'smooth' })));
    sc.addEventListener('scroll', set, { passive: true });
    onWidth(() => { measure(); set(); });
    measure(); set();
    // İkinci modeli bir kez göster (ana sayfa Kladiora modeller, data-peek "bekleme,süre,açık,kayma"; kullanıcı isteği
    // 31.10.2026): şerit kaydırılabiliyorsa (telefon) bölüm ekrana girince bekleme kadar sonra kartlar bir adım sola kayar
    // (kayma süresi, ease), ikinci model görünür, süre dolunca aynı hızla geri döner (süre = kayma + bekleme + dönüş).
    // Yalnız translate (yoksa transform) geçişi, satır içi; zamanlayıcılar yalnız başlatır, kare çizmez; gözlemci DOM'a
    // yazmaz. Sayfada bir kez. Başlangıç kaydırma sessizliğinde (kzQuiet: parmak ekrandayken / sayfa kayarken beklenir,
    // en çok 2,5 sn; uygulama içi tarayıcıda sürekli kaydırırken de olsun). Düzeltme (31.10.2026): önce şeride her
    // dokunuş (sayfayı aşağı kaydırırken parmağın kartlara değmesi) özelliği iptal ediyordu, telefonda / Instagram'da hiç
    // olmuyordu; artık yalnız şerit yana kaydırılmışsa olmaz, kayarken dokunulursa hemen geri döner. Hareketi azalt,
    // veri tasarrufu, 2G: yok
    const pk = (w.dataset.peek || '').split(',');
    if (pk[2] === 'true' && !lite && 'IntersectionObserver' in window) {
      const wait = Math.max(0, +pk[0] || 0), dur = Math.max(200, +pk[1] || 1250), sl = Math.max(50, +pk[3] || 375);
      const prop = window.CSS?.supports?.('translate', '1px') ? 'translate' : 'transform';
      const val = (x) => (!x ? '' : prop === 'translate' ? `${x}px 0` : `translateX(${x}px)`);
      let t = 0, t2 = 0, done = false, vis = false, on = false;
      const clean = () => { clearTimeout(t2); t2 = 0; on = false; cards.forEach((c) => { c.style.transition = ''; c.style[prop] = ''; }); };
      const back = () => { clearTimeout(t2); cards.forEach((c) => { c.style[prop] = ''; }); t2 = setTimeout(clean, sl + 40); };
      const end = () => { done = true; clearTimeout(t); t = 0; io.disconnect(); };
      const play = () => {
        if (done) return;
        if (!vis) return; // bu arada ekrandan çıktı: yeniden girince
        measure();
        const d = Math.min(step, max);
        end();
        if (max <= 2 || sc.scrollLeft > 2 || d <= 0) return;
        on = true;
        cards.forEach((c) => { c.style.transition = `${prop} ${sl}ms ease-in-out`; });
        void sc.offsetWidth; // geçişin başlangıç hali
        cards.forEach((c) => { c.style[prop] = val(-d); });
        t2 = setTimeout(back, Math.max(sl, dur - sl));
      };
      const arm = () => { t = 0; if (done) return; if (window.kzQuiet) window.kzQuiet(play, 150, 4000, 2500); else play(); };
      const io = new IntersectionObserver((es) => {
        vis = es[es.length - 1].isIntersecting;
        if (vis) { if (!t && !done) t = setTimeout(arm, wait); } else { clearTimeout(t); t = 0; }
      }, { threshold: 0.5 });
      io.observe(sc);
      sc.addEventListener('scroll', () => { if (sc.scrollLeft > 2 && !on) end(); }, { passive: true }); // ziyaretçi kendisi kaydırdı
      sc.addEventListener('touchstart', () => { if (on) { end(); back(); } }, { passive: true }); // kayarken dokundu: hemen geri
    }
  });
  initModels();

  // ---------- Fotoğraf galerisi (snippets/kz-gal.liquid) ----------
  // Sıralar üst üste durur, yerinde yumuşak geçişle değişir (fade: gelen .is-on, giden .is-out; yalnız opaklık, CSS).
  // Fotoğraf "Fotoğraf süresi" (data-ms; 0 = kendiliğinden geçmez) kadar durur. GIF / video (data-t g / v): geçiş bitince
  // ilk karesinde "Başlama gecikmesi" (data-pre ms) bekler, baştan bir kez oynar, bitince son karesinde "Bittikten sonra
  // bekleme" (data-post ms) durur, sonra sıradakine geçer; "Fotoğraf süresi" 0 ise ya da tek sıra varsa geçmez, aynı
  // beklemelerle yeniden oynar. Video oynatılamıyorsa (hareketi azalt, veri tasarrufu / 2G, dosya yok, hata, 10 sn içinde
  // başlamadı) kapağı fotoğraf gibi durur; GIF hareketi azalt açıkken ilk karesinde fotoğraf gibi durur.
  // Açılışta yalnız ilk sıranın fotoğrafı / kapağı (diğerlerinin adresi data-src'de). Sayfa yüklendikten sonra galeri
  // ekrana ~1 ekran kala komşu sıralar hazırlanır (veri tasarrufu / 2G'de yalnız sıradaki): fotoğraf / kapak, video dosyası
  // (pickSrc), GIF (omggif, gifPlay; büyük olduğu için 2 sıra önceden) ve chroma key açıksa o sıranın anahtarlaması
  // (kz-ck.js, sıra başına tuval; ancak gerekince). Sıradaki görseli inmeden geçilmez (en çok 4 sn); GIF inmediyse ilk
  // kare görseliyle gelir, inince oynar. Galeri ekran dışında, sekme
  // gizliyken ve parmak üstündeyken bekler; GIF / video da durur, dönünce kaldığı yerden sürer. Zamanlayıcılar (setTimeout)
  // yalnız geçişi başlatır, kare çizmez; GIF kareleri kzFps'ten. Parmakla (ya da fareyle) kaydırınca önceki / sonraki.
  let initGal = () => {};
  {
    const IO = 'IntersectionObserver' in window;
    const all = new Set();
    // Görseli indir: adresi data-src / data-srcset'ten al, lazy'yi kaldır
    const eager = (s) => {
      if (s) $$('img', s).forEach((im) => {
        if (im.loading === 'lazy') im.loading = 'eager';
        if (im.dataset.srcset) { im.srcset = im.dataset.srcset; im.removeAttribute('data-srcset'); }
        if (im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); }
      });
    };
    const near = IO ? new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      near.unobserve(e.target); e.target._gal?.warm();
    }), { rootMargin: '100% 0px' }) : null;
    const seen = IO ? new IntersectionObserver((es) => es.forEach((e) => {
      const G = e.target._gal; if (!G) return;
      G.vis = e.isIntersecting; G.arm();
    }), { threshold: 0 }) : null;
    document.addEventListener('visibilitychange', () => all.forEach((G) => G.arm()));
    const vidOn = !reduce && !slow; // video yerine kapak: hareketi azalt, veri tasarrufu, 2G
    initGal = (root) => $$('[data-kz-gal]', root).forEach((g) => {
      if (g._gal) return;
      const vp = $('.kz-gal__vp', g);
      const S = $$('.kz-gal__s', g); const n = S.length;
      if (!vp || !n) return;
      const M = S.map((s) => $('.kz-gal__m', s) || s);
      const T = S.map((s) => s.dataset.t || 'p');
      // Videonun dosya listesi var mı (dosyayı indirmeden bakılır)
      const VS = M.map((m, k) => { if (T[k] !== 'v') return false; try { return JSON.parse(m.dataset.srcs || '[]').some((x) => x.u); } catch (err) { return false; } });
      const ms = Math.max(0, +g.dataset.ms || 0), sp = reduce ? 0 : +g.dataset.sp || 600;
      const pre = Math.max(0, +g.dataset.pre || 0), post = Math.max(0, +g.dataset.post || 0);
      const ckc = g.dataset.ckc || '';
      // ph: '' (yeni geldi) · wait (fotoğraf gibi bekliyor) · pre (başlama gecikmesi) · play (oynuyor) · post (bitti, bekliyor)
      let i = 0, tmr = 0, busy = 0, hold = false, ready = false, ph = '', run = 0, guard = 0;
      const G = { vis: !IO };
      g._gal = G; all.add(G);
      const vid = (k) => {
        const m = M[k];
        if (T[k] !== 'v' || !vidOn || m._vbad) return null;
        if (m._v) return m._v;
        let list = [];
        try { list = JSON.parse(m.dataset.srcs || '[]'); } catch (err) { list = []; }
        const src = pickSrc(list, m), v = $('video', m);
        if (!src || !v) { m._vbad = 1; return null; }
        v.loop = false;
        v.addEventListener('playing', () => m.classList.add('is-playing'));
        v.addEventListener('error', () => { m._vbad = 1; if (M[i] === m) fallback(); });
        v.preload = 'auto'; v.src = src; m._v = v;
        return v;
      };
      // Hareketli oynayacak mı: video (oynatılabiliyorsa), GIF (hareketi azalt kapalıysa); değilse fotoğraf gibi durur
      const live = (k) => (T[k] === 'v' ? vidOn && VS[k] && !M[k]._vbad : T[k] === 'g' ? !reduce && !M[k]._gbad : false);
      // Sırayı hazırla: fotoğraf / kapak adresi, chroma key (görsel adresi verildikten sonra), video dosyası, GIF
      const prep = (k) => {
        k = (k + n) % n; const s = S[k], m = M[k];
        if (s._prep) return; s._prep = 1;
        eager(s);
        if (ckc && m.classList.contains('kz-media') && !m.hasAttribute('data-kz-ck') && !m.hasAttribute('data-kz-ck-no')) {
          m.dataset.kzCk = ckc;
          if (T[k] === 'g') m.setAttribute('data-kz-ck-wait', '');
          initCk(s);
        }
        if (T[k] === 'v') vid(k);
        // GIF: dosya iner ve çözülür (ilk karesi kapak görselinde zaten var); hareketi azalt açıkken yalnız kapak
        if (T[k] === 'g' && (!reduce || !$('img', m))) gifPlay(m).catch(() => { m._gbad = 1; });
      };
      // Komşu sıralar hazırlanır; GIF'ler (büyük dosya) 2 sıra önceden inmeye başlar (veri tasarrufu / 2G'de 1 sıra)
      const want = () => {
        if (!ready) return;
        (slow ? [i, i + 1] : [i - 1, i, i + 1]).forEach(prep);
        if (!slow && T[(i + 2) % n] === 'g') prep(i + 2);
      };
      const mark = () => S.forEach((s, j) => s.setAttribute('aria-hidden', j === i ? 'false' : 'true'));
      const stopM = (k) => { M[k]._v?.pause(); M[k]._gp?.then((p) => p.pause(), () => {}); };
      // Gelen sıra ilk karesinden başlasın (video başa sarılır, GIF ilk karesine döner)
      const first = (k) => {
        const v = M[k]._v;
        if (v) { v.pause(); try { v.currentTime = 0; } catch (err) { /* henüz yüklenmedi: zaten başta */ } }
        M[k]._gp?.then((p) => { p.pause(); p.restart(); }, () => {});
      };
      const clr = () => { clearTimeout(tmr); tmr = 0; clearTimeout(guard); guard = 0; };
      const on = () => G.vis && !document.hidden && !hold && g.isConnected;
      // Oynatılamayan medya: kapağı / ilk karesi fotoğraf gibi durur
      const fallback = () => {
        if (ph !== 'play' && ph !== 'pre') return;
        run++; stopM(i); clr(); ph = 'wait';
        if (ms && n > 1 && on()) tmr = setTimeout(tick, ms);
      };
      // İçerik bitti: son karesinde bekle, sonra sıradakine (ya da yeniden oynat)
      const ended = (tok) => {
        if (tok !== run) return;
        clr(); ph = 'post';
        if (on()) tmr = setTimeout(after, post);
      };
      const after = () => {
        tmr = 0;
        if (ms && n > 1) { tick(); return; }
        ph = ''; first(i); G.arm();
      };
      // Başlama gecikmesi doldu: baştan bir kez oynat
      const start = () => {
        tmr = 0;
        const k = i, m = M[k], tok = ++run; ph = 'play';
        if (T[k] === 'v') {
          const v = vid(k); if (!v) { fallback(); return; }
          m._got = false;
          v.addEventListener('playing', () => { if (tok === run) { m._got = true; vguard(v, tok); } }, { once: true });
          v.onended = () => ended(tok);
          try { v.currentTime = 0; } catch (err) { /* zaten başta */ }
          v.play().catch(() => { if (tok === run) { m._vbad = 1; fallback(); } });
          // 10 sn içinde başlamazsa kapağı fotoğraf gibi dursun
          clearTimeout(guard);
          guard = setTimeout(() => { if (tok === run && !m._got) { m._vbad = 1; fallback(); } }, 10000);
          return;
        }
        gifPlay(m).then((p) => {
          if (tok !== run || ph !== 'play') return;
          p.restart(); if (on()) p.play({ once: true, onEnd: () => ended(tok) });
        }, () => { m._gbad = 1; if (tok === run) fallback(); });
      };
      // Video takılıp bitmezse (ağ): kalan süresi + 8 sn sonra bitmiş say
      const vguard = (v, tok) => {
        clearTimeout(guard); guard = 0;
        if (isFinite(v.duration) && v.duration > 0) guard = setTimeout(() => ended(tok), (v.duration - v.currentTime) * 1000 + 8000);
      };
      // Görünürlükten dönünce oynamakta olan medya kaldığı yerden sürer
      const resume = (k) => {
        const tok = run;
        if (T[k] === 'v') { const v = M[k]._v; v?.play().then(() => { if (tok === run) vguard(v, tok); }, () => {}); return; }
        M[k]._gp?.then((p) => { if (tok === run && ph === 'play' && on()) p.play({ once: true, onEnd: () => ended(tok) }); }, () => {});
      };
      G.arm = () => {
        clearTimeout(tmr); tmr = 0;
        if (!g.isConnected) { all.delete(G); stopM(i); return; }
        if (!G.vis || document.hidden) { clearTimeout(guard); guard = 0; stopM(i); return; }
        if (hold || busy) return;
        const k = i;
        if (live(k)) {
          if (!ready) return; // dosyalar sayfa yüklendikten sonra iner: warm yeniden çağırır
          if (ph === 'play') {
            // Video hiç başlamadan ekrandan çıktıysa baştan dene; başladıysa kaldığı yerden
            if (T[k] === 'v' && !M[k]._got) { ph = 'pre'; tmr = setTimeout(start, 0); } else resume(k);
            return;
          }
          if (ph === 'post') { tmr = setTimeout(after, post); return; }
          ph = 'pre'; tmr = setTimeout(start, pre);
          return;
        }
        ph = 'wait';
        if (ms && n > 1) tmr = setTimeout(tick, ms);
      };
      // Sıradaki hazır mı: fotoğraf / video kapağı / GIF ilk kare görseli indi mi (en çok 4 sn). GIF'in kendisi beklenmez:
      // inmediyse ilk karesiyle gelir, inince oynar. İlk kare görseli yoksa GIF çözülene kadar (en çok 8 sn)
      const whenReady = (k, cb) => {
        const m = M[k]; let fin = false, t = 0;
        const f = () => { if (fin) return; fin = true; clearTimeout(t); cb(); };
        const im = $('img', m);
        if (T[k] === 'g' && !im && !m._gbad) { t = setTimeout(f, 8000); gifPlay(m).then(f, f); return; }
        if (im && im.getAttribute('src') && !im.complete) {
          im.addEventListener('load', f, { once: true }); im.addEventListener('error', f, { once: true }); t = setTimeout(f, 4000);
          return;
        }
        f();
      };
      const tick = () => {
        tmr = 0;
        const k = (i + 1) % n, was = i; prep(k);
        whenReady(k, () => { if (i === was && !tmr && !busy && on()) go(1); });
      };
      const done = () => {
        clearTimeout(busy); busy = 0;
        S.forEach((s) => s.classList.remove('is-out'));
        G.arm();
      };
      const go = (d) => {
        clr(); clearTimeout(busy); busy = 0;
        run++; ph = '';
        const wk = i; i = (i + d + n) % n;
        stopM(wk); // giden son karesinde durur, geçişte öyle söner
        mark(); want(); first(i);
        S.forEach((s) => s.classList.remove('is-out'));
        if (wk !== i) { S[wk].classList.remove('is-on'); S[wk].classList.add('is-out'); }
        S[i].classList.add('is-on');
        busy = setTimeout(done, sp + 80);
      };
      G.warm = () => { ready = true; want(); if (ph === '' || (ph === 'wait' && live(i))) G.arm(); };
      // Parmakla (ya da fareyle) kaydırma: genişliğin %15'i (en çok 60 px) geçilirse önceki / sonraki. Dikey kaydırma
      // tarayıcıda kalır (touch-action: pan-y)
      let pid = null, x0 = 0, dx = 0, w = 1, kx = 1;
      vp.addEventListener('pointerdown', (e) => {
        if (n < 2 || pid !== null || (e.pointerType === 'mouse' && e.button)) return;
        pid = e.pointerId; x0 = e.clientX; dx = 0;
        w = vp.clientWidth || 1; kx = vp.getBoundingClientRect().width / w || 1; // ata küçültülmüşse (Tam sayfaya ayarla)
        hold = true; clearTimeout(tmr); tmr = 0;
        try { vp.setPointerCapture(pid); } catch (err) { /* eski tarayıcı */ }
      });
      vp.addEventListener('pointermove', (e) => { if (e.pointerId === pid) dx = (e.clientX - x0) / kx; });
      const up = (e) => {
        if (e.pointerId !== pid) return;
        pid = null; hold = false;
        if (e.type === 'pointerup' && Math.abs(dx) > Math.min(60, w * 0.15)) { ready = true; go(dx < 0 ? 1 : -1); return; }
        G.arm();
      };
      vp.addEventListener('pointerup', up); vp.addEventListener('pointercancel', up);
      vp.addEventListener('dragstart', (e) => e.preventDefault());
      mark();
      seen?.observe(g);
      if (near) afterLoad(() => near.observe(g)); else { G.warm(); G.arm(); }
      // Galerideki bütün GIF'ler, galerinin bölümüne 2 bölüm kala (sayfa yüklendikten sonra) inmeye başlar: sayfada
      // galeriden 2 önceki bölüm ekrana girince ya da geçilmişse. Önünde 2 bölüm yoksa sayfa yüklenince. Veri tasarrufu /
      // 2G'de yalnız sıra yaklaşınca (want)
      if (!slow && T.includes('g')) afterLoad(() => {
        const gifs = () => T.forEach((t, k) => { if (t === 'g') prep(k); });
        const sec = g.closest('.shopify-section');
        let tg = sec;
        for (let c = 0; c < 2 && tg?.previousElementSibling?.matches('.shopify-section:not(.kz-go-sec)'); c++) tg = tg.previousElementSibling;
        if (!IO || !tg || tg === sec) { gifs(); return; }
        const io = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return; // henüz aşağıda
          io.disconnect(); gifs();
        });
        io.observe(tg);
      });
    });
    initGal(document);
  }

  // ---------- Atmosfer efektleri (snippets/kz-fx.liquid) ----------
  // Motor assets/kz-fx.js: sayfa yüklendikten sonra ve yalnız sayfada efekt varsa iner (açılışta 0 KB).
  // Alt alta aynı efekti kullanan bölümleri (en fazla 12) tek kesintisiz alan olarak çizer.
  // Tema editöründe bölüm eklenince/değişince/silinince/taşınınca alanlar yeniden kurulur.
  let initFx = () => {};
  let stopFx = () => {};
  if (!lite && 'IntersectionObserver' in window && 'ResizeObserver' in window && window.kzAssets?.fx) {
    initFx = () => {
      if (!$('[data-kz-fx]')) return;
      if (window.kzFxRebuild) { window.kzFxRebuild(); return; }
      if (initFx.loading) return; initFx.loading = true;
      // Kaydırma sessizliğinde (29.09.2026): motorun çalıştırılması ve tuvallerin kurulması parmakla kaydırmanın karelerine binmesin
      // Dosya yine sayfa yüklenince iner (preload: aynı istek), yalnız çalıştırılması bekler
      afterLoad(() => { pre(window.kzAssets.fx); quiet(() => { const s = document.createElement('script'); s.src = window.kzAssets.fx; document.head.appendChild(s); }); });
    };
    stopFx = () => setTimeout(() => window.kzFxRebuild?.(), 0);
    document.addEventListener('shopify:section:reorder', () => window.kzFxRebuild?.());
    initFx();
  }

  // ---------- Başlık animasyonları: bölüm başlıkları ekrana girince bir kez; tür bölüm ayarından ----------
  // Harfler başlığın üstündeki ayrı bir katmanda, ölçülen yerlerinde oynar; asıl metin kıpırdamaz (CLS yok).
  // Türler: decode (şifre çözme) · type (terminal yazımı) · scan (tarama çizgisi) · binary (ikili kod, rastgele sıra)
  // · center (ortadan, hex) · drop (düşen harfler) · flicker (sinyal titremesi) · glitch · random (her açılışta biri)
  let initDecode = () => {};
  if (window.kzFx?.on && window.kzFx?.decode && !lite && 'IntersectionObserver' in window) {
    const MODES = ['decode', 'type', 'scan', 'binary', 'center', 'drop', 'flicker', 'glitch'];
    const rnd = (G) => G[(Math.random() * G.length) | 0];
    const build = (h, D) => {
      const hr = h.getBoundingClientRect(); const layer = document.createElement('span');
      const k = (h.offsetWidth && hr.width / h.offsetWidth) || 1; // ata küçültülmüşse (Tam sayfaya ayarla) ölçüler geri çevrilir
      layer.className = 'kz-dc'; layer.setAttribute('aria-hidden', 'true'); layer.style.setProperty('--kz-dcd', `${D}ms`);
      const chars = []; const rg = document.createRange();
      const tw = document.createTreeWalker(h, NodeFilter.SHOW_TEXT); let node;
      while ((node = tw.nextNode())) {
        const em = !!node.parentElement.closest('em');
        // Metin etiketi (<yesil>, <rajd>, <bold>…) içindeki harfler kendi yazı tipi ve rengiyle oynar (ölçüm karede değil, bir kez)
        let st = '';
        if (node.parentElement !== h) {
          const cs = getComputedStyle(node.parentElement);
          st = `font:${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily};color:${cs.color};text-transform:${cs.textTransform};text-shadow:${cs.textShadow};`;
        }
        for (let i = 0; i < node.length; i++) {
          const ch = node.data[i]; if (/\s/.test(ch)) continue;
          rg.setStart(node, i); rg.setEnd(node, i + 1); const r = rg.getBoundingClientRect(); if (!r.width) continue;
          const el = document.createElement('i'); el.textContent = ch; if (em) el.className = 'em';
          const c = { el, ch, x: (r.left - hr.left) / k, y: (r.top - hr.top) / k, w: r.width / k, h: r.height / k };
          el.style.cssText = `${st}left:${c.x.toFixed(1)}px;top:${c.y.toFixed(1)}px;line-height:${c.h.toFixed(1)}px`;
          layer.appendChild(el); chars.push(c);
        }
      }
      return chars.length ? { layer, chars, w: hr.width / k } : null;
    };
    // Süre bölüm ayarından (50-800 ms, varsayılan 760)
    const run = (h, mode, D = 760) => {
      if (mode === 'random' || !MODES.includes(mode)) mode = MODES[(Math.random() * MODES.length) | 0];
      const b = build(h, D); if (!b) return;
      // Ölçüm burada (gözlemci geri çağrısında düzen temiz; katman belgeye bağlı değil), belgeye yazım karenin sonunda
      // (kzFps.write, 29.09.2026: harf ölçümleri karenin içinde zorunlu düzen hesabı yaptırmasın)
      kzFps.write(() => mount(h, b, mode, D));
    };
    const mount = (h, b, mode, D) => {
      const { layer, chars } = b; const n = chars.length;
      layer.classList.add(`kz-dc--${mode}`);
      h.appendChild(layer); h.classList.add('is-dc');
      const end = (ms) => setTimeout(() => { h.classList.remove('is-dc'); layer.remove(); }, ms);
      // Karakter karıştırma: her harf kendi zamanında (ts[i]) doğru harfe oturur. Kare hızı yöneticisiyle her karede
      // (60 kare/sn) çizilir; her harf kendi aralığıyla (30-80 ms) değişir, harfler farklı karelerde değiştiği için
      // karıştırma akıcı görünür ama tek tek okunabilir kalır
      const scramble = (G, ts) => {
        const t0 = performance.now(); const nx = chars.map(() => 0);
        const stop = kzFps.add((now) => {
          const t = now - t0;
          chars.forEach((c, i) => {
            if (t >= ts[i]) { if (!c.ok) { c.ok = 1; c.el.textContent = c.ch; } return; }
            if (t >= nx[i]) { c.el.textContent = rnd(G); nx[i] = t + 30 + Math.random() * 50; }
          });
          if (t >= D) { stop(); end(0); }
        });
      };
      const delays = (f) => chars.forEach((c, i) => { c.el.style.animationDelay = `${f(c, i) | 0}ms`; });
      switch (mode) {
        case 'binary': scramble('01', chars.map(() => Math.random() * D)); break;
        case 'center': {
          const mid = b.w / 2; const far = Math.max(...chars.map((c) => Math.abs(c.x + c.w / 2 - mid))) || 1;
          scramble('0123456789ABCDEF', chars.map((c) => (Math.abs(c.x + c.w / 2 - mid) / far) * D));
          break;
        }
        case 'type': {
          // Harfler tek tek yazılır, yeşil blok imleç yazının önünde ilerler, sonunda iki kez yanıp söner
          const cur = document.createElement('b'); cur.className = 'kz-dc__cur'; layer.appendChild(cur);
          chars.forEach((c) => { c.el.style.visibility = 'hidden'; });
          const at = (c, right) => { cur.style.cssText = `left:${(right ? c.x + c.w : c.x).toFixed(1)}px;top:${(c.y + c.h * 0.12).toFixed(1)}px;height:${(c.h * 0.76).toFixed(1)}px`; };
          at(chars[0], false);
          // Harfler karelere hizalı yazılır (kare hızı yöneticisi)
          const t0 = performance.now(); let shown = 0;
          const stop = kzFps.add((now) => {
            const k = Math.min(n, Math.floor(((now - t0) / (D * 0.85)) * n));
            for (; shown < k; shown++) chars[shown].el.style.visibility = '';
            if (shown) at(chars[shown - 1], true);
            if (shown >= n) stop();
          });
          end(D + 450);
          break;
        }
        case 'scan': {
          // Yeşil tarama çizgisi satır satır soldan sağa, sabit hızla geçer; her harf çizgi sol kenarına vardığı karede
          // parlayarak belirir. Çizgi ve harfler aynı saatten (kare hızı yöneticisi, zamana bağlı): her kare hızında çizgi
          // hep son açılan harfin üstünde (27.09.2026; önce çizgi CSS geçişiyle, harfler kendi gecikmeleriyle ayrı
          // ilerliyordu: yazı öne kaçıyordu, çok satırlı başlıkta çizgi bütün satırları birlikte tarıyordu)
          const rows = [];
          chars.forEach((c) => {
            let r = rows.find((q) => Math.abs(q.y + q.h / 2 - (c.y + c.h / 2)) < c.h / 2);
            if (!r) { r = { y: c.y, h: c.h, a: c.x, z: c.x + c.w, cs: [] }; rows.push(r); }
            r.y = Math.min(r.y, c.y); r.h = Math.max(r.h, c.h); r.a = Math.min(r.a, c.x); r.z = Math.max(r.z, c.x + c.w); r.cs.push(c);
          });
          rows.sort((p, q) => p.y - q.y);
          let L = 0; rows.forEach((r) => { r.cs.sort((p, q) => p.x - q.x); r.s0 = L; L += Math.max(1, r.z - r.a); });
          const line = document.createElement('b'); line.className = 'kz-dc__scan'; layer.appendChild(line);
          const T = D * 0.85; let ri = -1, ci = 0; const t0 = performance.now();
          const stop = kzFps.add((now) => {
            const s = Math.min(1, Math.max(0, (now - t0) / T)) * L; // karenin zamanı başlangıçtan biraz önce olabilir
            while (ri < rows.length - 1 && s >= rows[ri + 1].s0) { ri++; ci = 0; const r = rows[ri]; line.style.top = `${(r.y - r.h * 0.08).toFixed(1)}px`; line.style.height = `${(r.h * 1.16).toFixed(1)}px`; }
            // Önceki satırlarda kalan harfler (kare atlandıysa) de açılır
            for (let k = 0; k < ri; k++) rows[k].cs.forEach((c) => { if (!c.on) { c.on = 1; c.el.classList.add('on'); } });
            const r = rows[ri], x = r.a + (s - r.s0);
            for (; ci < r.cs.length && r.cs[ci].x <= x + 0.5; ci++) { r.cs[ci].on = 1; r.cs[ci].el.classList.add('on'); }
            line.style.transform = `translate3d(${x.toFixed(1)}px,0,0)`;
            if (s >= L) { stop(); r.cs.forEach((c) => { if (!c.on) { c.on = 1; c.el.classList.add('on'); } }); line.style.opacity = '0'; }
          });
          end(D + 300);
          break;
        }
        case 'drop': delays((c, i) => (i / n) * D * 0.6); end(D + 50); break;
        case 'flicker': delays(() => Math.random() * D * 0.6); end(D + 50); break;
        case 'glitch': end(D + 50); break;
        default: scramble('01<>/#$%&*ABCDEF', chars.map((c, i) => (i / n) * D));
      }
    };
    // Sayfa içi yumuşak kaydırma (buton geçişi) sürerken başlamaz: geçiş bitince yeniden izlenir, başlık hâlâ ekrandaysa
    // oynar (28.09.2026; harf ölçümleri ve harf kutuları geçişin karelerine biniyordu). Geçiş bitince ölçülmez, gözlemciye
    // bırakılır: arka arkaya iki geçişte (ikinci buton) ikincinin ortasına düşmez (29.09.2026)
    const start = (h) => {
      if (!window.kzGliding) { run(h, h._dc, h._ms); return; }
      addEventListener('kz:glided', () => dcIO.observe(h), { once: true });
    };
    const dcIO = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { dcIO.unobserve(e.target); start(e.target); } }), { rootMargin: '0px 0px -20% 0px' });
    // Bölüm ayarı "Başlık animasyonu": seçili bölümlerin başlıkları (hero dahil) ekrana girince bir kez
    initDecode = (root) => {
      const q = '[data-kz-dc]:not([data-kz-dc="none"]):not([data-kz-dc=""])';
      const secs = root.matches?.(q) ? [root] : $$(q, root);
      secs.forEach((sec) => $$('.kz-h, .kz-hero__t', sec).forEach((h) => { h._dc = sec.dataset.kzDc; h._ms = Math.min(800, Math.max(50, +sec.dataset.kzDcms || 760)); dcIO.observe(h); }));
    };
    afterLoad(() => quiet(() => initDecode(document)));
  }

  // ---------- Chroma key: yalnızca sayfada açık bir medya varsa motoru yükle ----------
  // Motor (assets/kz-ck.js) anahtarlı bir medya ekrana ~1 ekran kala iner (ilk ekrandaki medya için hemen: gözlemci
  // ilk karede haber verir); sayfada anahtarlı medya yoksa hiç inmez. Galerinin sonraki sıraları da buradan geçer
  const initCk = (root) => {
    if (!window.kzAssets) return;
    if (window.kzCkInit) { if ($('[data-kz-ck]', root) || root.matches?.('[data-kz-ck]')) window.kzCkInit(root); return; }
    const list = root.matches?.('[data-kz-ck]') ? [root] : $$('[data-kz-ck]', root);
    if (!list.length) return;
    const load = () => {
      if (initCk.loading) return; initCk.loading = true;
      const s2 = document.createElement('script'); s2.src = window.kzAssets.ck; s2.async = true; document.head.appendChild(s2);
    };
    if (!('IntersectionObserver' in window)) { load(); return; }
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '100% 0px' });
    list.forEach((el) => io.observe(el));
  };
  initCk(document);

  // ---------- İşaret çizgileri (modülün "İşaret çizgisi" blokları) ----------
  // Motor (assets/kz-co.js) yalnızca sayfada çizgi varsa ve sayfa yüklendikten sonra iner: açılışta 0 KB.
  // Animasyonlu çizgiler motor gelene kadar gizli (is-pre); motor inemezse gizlilik kalkar.
  const initCo = (root) => {
    const cos = $$('[data-kz-co]', root);
    if (!cos.length || !window.kzAssets?.co) return;
    if (!lite) cos.forEach((c) => { if (c.dataset.anim !== 'none') c.classList.add('is-pre'); });
    if (window.kzCoInit) { window.kzCoInit(root); return; }
    if (initCo.loading) return; initCo.loading = true;
    // Kaydırma sessizliğinde çalışır, dosya ise sayfa yüklenince iner (preload); yazılar gizli beklediği için en geç 3 sn
    afterLoad(() => {
      pre(window.kzAssets.co);
      quiet(() => {
        const s = document.createElement('script'); s.src = window.kzAssets.co;
        s.onerror = () => $$('.kz-co.is-pre').forEach((c) => c.classList.remove('is-pre'));
        document.head.appendChild(s);
      }, 300, 4000, 3000);
    });
  };
  initCo(document);

  // ---------- 3D görüntüleyici (Flipper yapısı): sayfa yüklendikten sonra bölüme ~1 ekran kala, yavaş bağlantıda dokununca ----------
  const MV = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js'; // Google CDN, sürüm sabit, 1 yıl önbellek
  const addScript = (src) => new Promise((ok, no) => { const s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = no; document.head.appendChild(s); });
  // Işık ortamı: Kladiora stüdyo tarayıcıda üretilir (assets/kz-studio.js, yalnız burada iner); özel HDR adresine #.hdr eklenir
  // çünkü model-viewer HDR'ı adresin sonundaki .hdr'dan tanır, Shopify adresleri ise ?v=… ile biter
  let studioUrl = null;
  const envOf = (d) => {
    if (d.env === 'studio') {
      if (studioUrl) return Promise.resolve(studioUrl);
      const main = () => (window.kzStudio ? Promise.resolve() : addScript(window.kzAssets.studio)).then(() => (studioUrl = window.kzStudio()));
      if (!glbWorker()) return main();
      return glbRun({ t: 'studio' }).then((r) => (studioUrl = URL.createObjectURL(new Blob(r.hdr, { type: 'application/octet-stream' })) + '#.hdr')).catch(main);
    }
    if (d.env === 'custom' && d.envUrl) {
      const u = d.envUrl;
      return Promise.resolve(/\.hdr$/i.test(u.split(/[?#]/)[0]) && !/\.hdr$/i.test(u) ? `${u}#.hdr` : u);
    }
    return Promise.resolve(d.env === 'neutral' ? 'neutral' : 'legacy');
  };
  // Malzeme blokları: dosyadaki malzeme adıyla (kasa, kasa__2 … ya da * = hepsi) eşleşen malzemenin ışığa tepkisi.
  // [metaliklik, pürüzlülük, saydamlık]; yalnız temel PBR değerleri: her GLB'de çalışır, ek uzantı gerekmez
  // paracord: örgü dokusu ve kabartma kz-glb.js'te; burada mat plastik iplik değerleri
  // led: kendi ışığını verir (renk = bloğun rengi, yoksa marka yeşili); animasyon yok (KARARLAR §4)
  const MAT = { petg: [0, 0.65], plastic: [0, 0.25], rubber: [0, 0.85], fabric: [0, 0.95], metal: [1, 0.15], brushed: [1, 0.45], glass: [0, 0.05, 0.35], led: [0, 0.3], paracord: [0, 0.88], carbon: [0, 0.65], keep: null }; // karbon: parlaklığı mat PETG ile aynı (29.09.2026)
  const nm = (x) => (x || '').trim().toLowerCase();
  // Ad eşleşmesi: aynı ad ya da sonunda numaralı devamı (kasa2, kasa_3, kasa.001, kasa-4, kasa 5, kasa__2) aynı parçadır
  // Hatalı eki ("Yüzey düzelt" bloğu; varsayılan _hatali) malzemeyi değiştirmez: kasa_hatali = kasa, kasa2_hatali = kasa2
  const untag = (mn, tags) => {
    const c = String(tags ?? '').split(',').concat('_hatali').map((t) => nm(t).replace(/ı/g, 'i').replace(/^[ _.-]+/, '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).filter(Boolean);
    const m = new RegExp(`(^|[ _.-])(${c.join('|')})([ _.-]?\\d+)?$`).exec(mn.replace(/ı/g, 'i'));
    return m && m.index > 0 ? mn.slice(0, m.index) : mn;
  };
  const isOf = (mn, n) => !!n && (mn === n || mn.startsWith(`${n}__`) || (mn.startsWith(n) && /^[ _.-]?\d+$/.test(mn.slice(n.length))));
  const linRgb = (h) => { const v = parseInt((h || '#00ff88').slice(1), 16); return [v >> 16, (v >> 8) & 255, v & 255].map((x) => { x /= 255; return x <= 0.04045 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4; }); };
  // Adı hiçbir bloğa uymayan (işaretlenmemiş) parçalar kasa bloğunun ayarını alır ("Model düzeltme" → Adı eşleşmeyen
  // parçalar). Ekran ve otomatik cam kapak (kz_cam) hariç: onları kz-glb.js ayarlar
  const applyMats = (mv, list, prep = {}) => {
    const mats = mv.model?.materials || [];
    const hit = new Set();
    mv._ledM = new Map(); // LED malzemeleri → [ışık rengi (doğrusal), zemin rengi]: LED Aç / Kapat bununla söndürür (kz-3dv.js led)
    const put = (m, b) => {
      const p = m.pbrMetallicRoughness, pre = MAT[b.p];
      if (pre) { p.setMetallicFactor(pre[0]); p.setRoughnessFactor(pre[1]); }
      if (b.m != null) p.setMetallicFactor(b.m);
      if (b.r != null) p.setRoughnessFactor(b.r);
      if (b.c) p.setBaseColorFactor(b.c);
      // Cam: hazırlanmış modelde gerçek geçirgenlik kz-glb.js'te (saydamlık oradan); hazırlanamadıysa ya da zayıf cihazda
      // hafif cam: yarı saydam, saydamlık ayarından
      if (pre && pre[2] != null && !prep._tr) { m.setAlphaMode('BLEND'); const f = p.baseColorFactor; p.setBaseColorFactor([f[0], f[1], f[2], b.t != null ? Math.max(0.12, 1 - b.t * 0.85) : pre[2]]); }
      if (b.p === 'led') { m.setEmissiveFactor(linRgb(b.c)); m.setEmissiveStrength?.(b.g?.k ?? 3); mv._ledM.set(m, [linRgb(b.c), [...p.baseColorFactor]]); } // kendi parlaklığı (çekirdek)
    };
    // Her malzemeye tek blok: önce * (hepsi), sonra en uygun blok: tam aynı ad, yoksa numarasız adı (kasa2 → kasa;
    // "kasa2" diye ayrı blok varsa o kazanır)
    const star = list.find((b) => nm(b.n) === '*');
    mats.forEach((m) => {
      const m0 = nm(m.name), mn = untag(m0, prep.yd?.tag);
      if (m0 === 'kz_yd') return; // Yüzey düzelt kontrol katmanı (kz-glb.js)
      const b = list.find((x) => nm(x.n) === m0) || list.find((x) => nm(x.n) === mn) || list.filter((x) => nm(x.n) !== '*' && isOf(mn, nm(x.n))).sort((x, y) => nm(y.n).length - nm(x.n).length)[0];
      if (star) { put(m, star); hit.add(m); }
      if (b) { put(m, b); hit.add(m); }
    });
    const kasa = (prep.o || 'kasa') === 'kasa' && list.find((b) => nm(b.n) === 'kasa');
    if (kasa) {
      const skip = [nm(prep.scr?.n) || 'ekran', 'kz_cam', 'kz_yd'];
      mats.forEach((m) => { if (!hit.has(m) && !skip.some((n) => isOf(untag(nm(m.name), prep.yd?.tag), n))) put(m, kasa); });
    }
  };
  // LED parlaması için: malzeme adı → o malzemenin LED bloğu (applyMats'la aynı eşleşme; "Işık parlaması" kapalıysa yok)
  const ledOf = (list, prep = {}) => (name) => {
    const m0 = nm(name), mn = untag(m0, prep.yd?.tag);
    const b = list.find((x) => nm(x.n) === m0) || list.find((x) => nm(x.n) === mn) || list.filter((x) => nm(x.n) !== '*' && isOf(mn, nm(x.n))).sort((x, y) => nm(y.n).length - nm(x.n).length)[0];
    return b && b.p === 'led' && b.g?.on !== false ? { c: b.c || '#00ff88', pw: b.g?.pw ?? 1, sp: b.g?.sp ?? 1 } : null;
  };
  // Model hazırlama (assets/kz-glb.js, yalnız burada iner): siyah köşe rengi, yumuşatma, ekran görüntüsü, cam kapak.
  // Ekran görüntüsünün boyu cihaza ve bağlantıya göre: yavaş bağlantı 600, telefon 1200, büyük ekran 2400 (düşük kalitede en çok 1200).
  // Hazırlanamazsa (Draco, okunamayan dosya) dosya olduğu gibi gösterilir
  // Model hazırlığı Web Worker'da (28.09.2026): assets/kz-glb.js aynı dosya (worker'da self.window = self), Shopify CDN
  // başka kökende olduğu için worker kodu blob'dan, dosyalar importScripts ile. Ana iş parçacığı kaydırma / geçiş
  // sırasında bloklanmaz (önce 0,5-1 sn'lik hazırlık geçişi 20 kare/sn'ye düşürüyordu). Stüdyo ışık ortamı (kz-studio.js)
  // da worker'da üretilir. Worker ya da OffscreenCanvas yoksa, hata verirse: eskisi gibi ana iş parçacığında
  let glbW = null, glbWId = 0; const glbWJobs = new Map();
  const glbWorker = () => {
    if (glbW !== null) return glbW;
    try {
      if (!window.Worker || !window.OffscreenCanvas || !window.kzAssets?.glb) return (glbW = false);
      const code = 'self.window=self;let ok=false;self.onmessage=async(e)=>{const m=e.data;try{'
        + 'if(m.t==="studio"){if(!self.kzStudio)importScripts(m.studio);postMessage({id:m.id,hdr:self.kzStudio(true)});return;}'
        + 'if(!ok){importScripts(m.glb);ok=true;}'
        + 'const buf=await self.kzGlb(m.url,m.cfg,{raw:true,tex:m.tex,meshopt:()=>{if(!self.MeshoptDecoder)importScripts(m.meshopt);},progress:(p)=>postMessage({id:m.id,p})});'
        + 'postMessage({id:m.id,blob:new Blob([buf],{type:"model/gltf-binary"})});}catch(x){postMessage({id:m.id,err:String(x&&x.message||x)});}};';
      glbW = new Worker(URL.createObjectURL(new Blob([code], { type: 'text/javascript' })));
      // İş bitince 30 sn boşta kalırsa worker kapatılır (bellek); model değiştirince yeniden kurulur (dosyalar önbellekten)
      const w = glbW; let offT = 0;
      const done = () => { clearTimeout(offT); if (!glbWJobs.size) offT = setTimeout(() => { if (glbW === w && !glbWJobs.size) { w.terminate(); glbW = null; } }, 30000); };
      w.onmessage = (e) => { const j = glbWJobs.get(e.data.id); if (!j) return; if (e.data.p !== undefined) { j.prog(e.data.p); return; } glbWJobs.delete(e.data.id); if (e.data.err) j.no(new Error(e.data.err)); else j.ok(e.data); done(); };
      w.onerror = () => { glbWJobs.forEach((j) => j.no(new Error('worker'))); glbWJobs.clear(); w.terminate(); if (glbW === w) glbW = false; }; // bir daha denenmez: ana iş parçacığı
    } catch (e) { glbW = false; }
    return glbW;
  };
  const glbRun = (msg, prog = () => {}, transfer = []) => new Promise((ok, no) => {
    const w = glbWorker(); if (!w) { no(new Error('worker yok')); return; }
    const id = ++glbWId; glbWJobs.set(id, { ok, no, prog });
    const abs = (u) => { try { return u == null ? u : new URL(u, location.href).href; } catch (e) { return u; } }; // blob worker'da göreli adres çözülmez
    const cfg = msg.cfg?.scr?.src ? { ...msg.cfg, scr: { ...msg.cfg.scr, src: abs(msg.cfg.scr.src) } } : msg.cfg; // ekran görüntüsü adresi de
    w.postMessage({ ...msg, cfg, url: abs(msg.url), id, glb: abs(window.kzAssets.glb), meshopt: abs(window.kzAssets.meshopt), studio: abs(window.kzAssets.studio) }, transfer);
  });
  const prepGlb = (box, d, prep, prog) => {
    if (!window.kzAssets?.glb) return Promise.resolve(d.glb);
    prep.lq = !kzFps.q; // zayıf cihaz: cam geçirgenliği yok (ek çizim turu)
    // "Gerçek hayat kalitesi 4K" bloğu ekliyse ve cihaz güçlüyse yuvarlak kenarlar inceltilir (kz-glb.js subTable)
    prep.sub = box.hasAttribute('data-hq') && !!kzFps.q;
    const s = prep.scr;
    if (s?.img) {
      const need = box.clientWidth * Math.min(window.devicePixelRatio || 1, 2) * 0.8;
      const low = slow || conn.effectiveType === '3g' || (conn.downlink && conn.downlink < 1.5);
      const k = low || need <= 600 ? 600 : need <= 1200 || !kzFps.q ? 1200 : 2400;
      s.src = s.img[k];
      // MP4 ekranın boyu (29.09.2026; tools/video-hazirla 3d/): bilgisayar 1080, telefon 720, zayıf cihaz ve yavaş
      // bağlantı 540 (30 kare/sn); < 5 Mbit/sn en çok 720; hareketi azalt / veri tasarrufu / 2G: yok (yalnız ilk kare)
      const vk = lite ? 0 : low || !kzFps.q ? 540 : need <= 800 || (conn.downlink && conn.downlink < 5) ? 720 : 1080;
      const pv = (v) => (v && vk ? v[vk] || v[720] || v[540] || null : null);
      // GIF ve MP4 ekranların açısı ayrı olabilir (ra, "GIF ve MP4 ekranların açısı"); gömülen 1. ekran kendi türüne göre
      s.ri ??= s.r; const ra = s.ra ?? s.ri;
      s.vv = pv(s.vid); s.r = s.gif || s.vid ? ra : s.ri;
      // Model başına 5 ekran (29.09.2026): bütün ekranlar aynı boyda (geçişte netlik değişmez); 1. ekran s.src ile
      // gömülür. ms: görüntüler, mg: GIF'ler, mv: videolar (yoksa null), mr: açılar, mn: adlar (ad alanında)
      if (Array.isArray(s.menu)) {
        const ok = s.menu.filter((m) => m && (m[k] || m[1200]));
        s.ms = ok.map((m) => m[k] || m[1200]); s.mg = ok.map((m) => m.gif || null); s.mv = ok.map((m) => pv(m.v));
        s.mr = ok.map((m) => (m.gif || m.v ? ra : s.ri)); s.mn = ok.map((m, i) => m.n || `${i + 1}. ekran`);
      }
    }
    // Ekran görüntüsüne chroma key: motor (assets/kz-ck.js) yalnız bu modelin ekranında açıksa iner
    const ck = s?.ck && !window.kzCk && window.kzAssets.ck ? (prepGlb.ck ||= addScript(window.kzAssets.ck).catch(() => null)) : null;
    if (ck) initCk.loading = true; // sayfadaki anahtarlı medya ikinci kez indirmesin
    return Promise.all([window.kzGlb ? null : addScript(window.kzAssets.glb), ck])
      .then(async () => {
        if (glbWorker()) {
          try {
            const tex = s?.src && s.ck ? await window.kzGlbTex(s) : null; // chroma key'li ekran görüntüsü burada (motor DOM ister), JPEG olarak worker'a; yoksa worker kendi büker
            const r = await glbRun({ url: d.glb, cfg: prep, tex }, prog, tex ? [tex.buffer] : []);
            // Blob worker'da kurulur (29.09.2026): hazırlanan ~10 MB model ana iş parçacığında kopyalanmaz (kaydırmanın ortasına düşüyordu)
            return URL.createObjectURL(r.blob || new Blob([r.buf], { type: 'model/gltf-binary' }));
          } catch (e) { console.warn('Kladiora 3D: worker hazırlayamadı, ana iş parçacığında hazırlanıyor.', e); }
        }
        return window.kzGlb(d.glb, prep, { progress: prog, meshopt: () => (window.MeshoptDecoder ? null : addScript(window.kzAssets.meshopt)) });
      })
      .catch((e) => { console.warn('Kladiora 3D: model hazırlanamadı, dosya olduğu gibi gösteriliyor.', e); return d.glb; });
  };
  // Bilgisayardaki "sürükle" ipucu (model-viewer) modeli 5 sn'lik turlarla sonsuza dek kıpırdatıyor, 3D her karede
  // çiziliyordu: iki tur oynar, turun durgun anında (model ilk açısında) kapanır (KARARLAR §8 Masaüstü yükü)
  const hint = (mv) => {
    const el = mv.shadowRoot?.querySelector('.interaction-prompt');
    if (!el || mv.getAttribute('interaction-prompt') !== 'auto') return;
    const mo = new MutationObserver(() => {
      if (!el.classList.contains('visible')) return;
      mo.disconnect();
      setTimeout(() => mv.setAttribute('interaction-prompt', 'none'), 9200); // 2 tur × 5 sn; turun %84'ü durgun
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  };
  const load3d = (box) => {
    if (box._on) return; box._on = true;
    box.classList.add('is-loading');
    // Hazırlık boyunca kare hızı yargıcı ölçmez (kzFps.hold); bitince (hazır, hata) bırakılır, bir kez
    if (!box._hold) { box._hold = 1; kzFps.hold(true); }
    const rel = () => { if (box._hold) { box._hold = 0; kzFps.hold(false); } };
    const bar = $('.kz-3d__bar', box);
    // model-viewer'a poster verilmez: temadaki önizleme görseli (gerekirse chroma key'li) model hazır olana dek ortada durur
    const mv = document.createElement('model-viewer');
    const d = box.dataset;
    // touch-action pan-y: telefonda dikey kaydırma sayfayı kaydırır (ziyaretçi 600 px'lik kutuda takılmaz), yatay kaydırma modeli döndürür
    // Yakınlaşma sınırları (en yakın / en uzak) editörden: 3D bölümü → "En çok yakınlaşma", "En çok uzaklaşma"
    const at = { alt: '3D model', 'camera-controls': '', 'touch-action': 'pan-y', 'interaction-prompt': 'auto',
      'shadow-intensity': d.shadow || '0', 'shadow-softness': '1', exposure: d.exposure || '0.53',
      'camera-orbit': d.orbit || '0deg 75deg 105%', 'min-camera-orbit': `auto auto ${d.zmin || 35}%`, 'max-camera-orbit': `auto auto ${d.zmax || 250}%`, loading: 'eager', reveal: 'auto' };
    // Başlangıç duruşu (ilk modelinki): model yüklenmeden verilir; sonradan değiştirmek model-viewer'da çerçeveyi bozar.
    // Duruşu farklı modeller ve ekranda eğim, model açılınca modelin kendi dönüşüyle verilir (kz-3dv.js)
    if (d.orient) at.orientation = d.orient;
    // Telefonda kare alanda sayfadaki model görünmez: kendi kendine dönmez (her karede boşuna çizim), pencerede zaten durur
    if (box.hasAttribute('data-rotate') && !(box.hasAttribute('data-sq') && matchMedia('(pointer: coarse), (max-width: 749px)').matches)) {
      at['auto-rotate'] = '';
      // Sayfa içi yumuşak kaydırma (buton geçişi) sürerken kendi kendine dönme durur, bitince sürer (28.09.2026): dönen model
      // her karede yeniden çiziliyor (4K'da çok geçişli), geçişin ekran kartı yükünü büyütüyordu. Pencere açıkken dokunulmaz
      addEventListener('kz:glide', () => { if (!window.kz3dfsOpen && mv.hasAttribute('auto-rotate')) { mv.removeAttribute('auto-rotate'); mv._glideRot = true; } });
      addEventListener('kz:glided', () => { if (mv._glideRot) { mv._glideRot = false; if (!window.kz3dfsOpen) mv.setAttribute('auto-rotate', ''); } });
    }
    // Telefonda model sayfada dönmez (parmak sayfayı kaydırır, çakışma yok); dokununca tam ekran pencerede açılır
    const touch = matchMedia('(pointer: coarse)').matches;
    // Telefonda kare alan ("Telefonda sayfadaki 3D alanı" → Kare; dokunmatik ya da dar ekran): model sayfada görünmez
    // (arkada iner), yalnız tam ekran pencerede. Dar ekranda fareyle de (editörün telefon önizlemesi) pencere açılır
    const sqm = box.hasAttribute('data-sq') && matchMedia('(pointer: coarse), (max-width: 749px)').matches;
    if (touch) { box.classList.add('is-touch'); delete at['camera-controls']; at['interaction-prompt'] = 'none'; }
    // AR: iPhone'da Quick Look için USDZ'yi model-viewer GLB'den kendisi üretir
    if (box.hasAttribute('data-ar')) at.ar = '';
    Object.entries(at).forEach(([k, v]) => mv.setAttribute(k, v));
    // Boş slot model-viewer'ın kendi üst yükleme çizgisini gizler (Flipper da böyle yapıyor); bizim ince yeşil çizgimiz altta
    const slot = document.createElement('span'); slot.slot = 'progress-bar'; mv.appendChild(slot);
    // Yükleme çizgisi: dosyanın inmesi %0-85 (kz-glb.js), model-viewer'ın açması %85-100
    let barV = 0, prepped = false;
    const setBar = (v) => { if (bar && v > barV) { barV = v; bar.style.transform = `scaleX(${v})`; } };
    mv.addEventListener('progress', (e) => setBar(prepped ? 0.85 + 0.15 * e.detail.totalProgress : e.detail.totalProgress));
    let mats = [], prep = {};
    try { mats = JSON.parse(d.mats || '[]'); } catch (e) { /* bozuk blok verisi: malzemeler dosyadaki gibi kalır */ }
    try { prep = JSON.parse(d.prep || '{}'); } catch (e) { /* bozuk blok verisi: model olduğu gibi */ }
    // Ekran görüntüsü model başına ("Model adı ve görseli" bloğu → Ekran; prep.si: GLB adresi → görsel, açı, karışım
    // modu, opaklık, chroma key). Ekran bloğunun öbür ayarları (parça adı, köşeler, parlaklık, cam) hepsine ortak.
    // Görseli olmayan modelin ekranı kapalı ekran rengi
    const preps = new Map();
    const prepFor = (url) => {
      if (preps.has(url)) return preps.get(url);
      const si = (prep.si && Object.prototype.hasOwnProperty.call(prep.si, url) ? prep.si[url] : null) || {};
      const p = prep.scr ? { ...prep, scr: { ...prep.scr, img: si.img || null, gif: si.gif || null, vid: si.img && si.vid ? si.vid : null, r: si.r || 0, ra: si.ra ?? null, spd: si.spd || 1, bm: si.bm || 'normal', op: si.op ?? 100, ck: si.img && si.ck ? si.ck : null, menu: si.img && si.menu ? si.menu : null } } : prep;
      preps.set(url, p); return p;
    };
    // Sahnenin pozlaması (model-viewer: Parlaklık × neutral ton eşlemede nötr/eski ışıkta 1,3): ekranın ortamdan aldığı
    // pay bununla, kendi ışığı pozlamasız (kz-glb.js kzGlbScreen)
    let ex = 1;
    // Malzemeler ve başlangıç görünümü modelin ilk karesinden önce ('before-render'): model-viewer 'load'u model sahneye
    // girdikten 2 kare sonra atıyor; 'load'da uygulanınca model değiştirirken ~50 ms dosyadaki (ayarsız) haliyle görünüyordu
    let setFor = null;
    const setUp = () => {
      if (setFor === mv.src) return; setFor = mv.src;
      try { applyMats(mv, mats, prep); } catch (e) { /* malzeme ayarı modeli bozmaz */ }
      try { window.kzGlbScreen?.(mv, prepFor(d.glb), ex); } catch (e) { /* ekran dosyadaki gibi kalır */ }
      // "Gerçek hayat kalitesi 4K" bloğu varsa (assets/kz-3dv.js hq): süper örnekleme, doku süzmesi, bant giderme
      if (d.hq !== undefined) try { window.kz3dv?.hq?.(mv); } catch (e) { /* olağan kalitede kalır */ }
      box._cam?.reset(true); // seçilen modelin başlangıç görünümü (assets/kz-3dv.js)
      glowUp();
      ledSync(box);
    };
    // LED ışık parlaması (assets/kz-3dv.js glow): her model için bir kez; model değişince eskisi kaldırılır
    let glowFor = null;
    const glowUp = () => {
      if (glowFor === mv.src || !window.kz3dv?.glow || !mats.some((b) => b.p === 'led')) return;
      mv._glow?.clear(); mv._glow = null;
      // 3D bölümü → LED ışığı: 2 boyutlu hale ya da 3 boyutlu (havaya ve yüzeylere yayılan) ışık
      const lo = { mode: d.led === '3d' ? '3d' : '2d', op: parseFloat(d.ledO ?? 1), surf: parseFloat(d.ledS ?? 1), vol: parseFloat(d.ledV ?? 1), ex };
      try { mv._glow = window.kz3dv.glow(mv, ledOf(mats, prep), lo); } catch (e) { mv._glow = null; }
      if (mv._glow) glowFor = mv.src;
    };
    mv.addEventListener('before-render', setUp);
    mv.addEventListener('load', () => {
      if (!mv._hint) { mv._hint = true; hint(mv); }
      setUp(); // 'before-render' gelmediyse
      glowUp(); // sahne 'before-render'da henüz hazır değildiyse
      ledSync(box);
      // Ekran görüntüsü GIF ise oynar (kz-glb.js); hareketi azalt ve veri tasarrufu/2G'de yalnız ilk kare. Birden çok
      // ekranda o an seçili ekranın GIF'i (box._scrI)
      box._gif?.(); box._gif = null;
      const pp = prepFor(d.glb), sc0 = pp.scr;
      box._scrI = 0;
      box._gifOn = () => {
        if (box._gif || !sc0?.src || lite) return;
        const i = box._scrI || 0, m = !!sc0.ms, v = (m ? sc0.mv?.[i] : sc0.vv) || null, g = (m ? sc0.mg?.[i] : sc0.gif) || null;
        const o = { lq: !kzFps.q, spd: sc0.spd || 1, r: m ? sc0.mr?.[i] : sc0.r }; // hız ve açı ("Hareketli ekranlar")
        if (v && window.kzGlbVid) box._gif = window.kzGlbVid(mv, pp, { ...o, src: v });
        else if (g && window.kzGlbGif) box._gif = window.kzGlbGif(mv, pp, { ...o, gif: g, reader: () => addScript(window.kzAssets.gif) });
      };
      // Telefonda kare alanda model sayfada görünmez: GIF yalnız pencere açıkken oynar (görünmeyen modeli boşuna çizmesin)
      if (!sqm || window.kz3dfsOpen) box._gifOn();
      // Model başına 5 ekran ("Model adı ve görseli" bloğu → Ekranlar): 2 ve daha fazla ekranı olan modelde ad alanı;
      // 1. ekran gömülü, öbürleri boşta iner (veri tasarrufu / 2G'de yalnız istenince). Model her açılışta 1. ekranla başlar
      box._menu?.stop(); box._menu = null;
      if (sc0?.ms?.length > 1 && window.kzGlbMenu) {
        const M = box._menu = window.kzGlbMenu(mv, pp); M.names = sc0.mn || [];
        if (!slow) quiet(() => { if (box._menu === M) M.preload(); }, 300, 3000);
      }
      menuUi(box);
      box.classList.add('is-ready'); rel(); kzFps.busy(1500); // ilk kareler (gölgelendirici derleme) de meşgul; sonra yargı serbest
      // Oynat'a model inmeden basıldıysa (telefonda kare alan): hazır olunca tam ekran pencere açılır
      if (box._fsWant) { box._fsWant = false; box.classList.remove('is-want'); box._fsShow?.(); }
      mv.classList.remove('is-swap'); $$('[data-kz-3d-th].is-busy').forEach((t) => t.classList.remove('is-busy'));
    });
    // Model değiştirme (kutucuklar): hazırlanan model saklanır, aynı modele dönüş anında olur
    const cache = new Map();
    box._mv = mv;
    box._swap = (url) => {
      box._menu?.stop(); box._menu = null; menuUi(box);
      mv.classList.add('is-swap');
      const got = cache.get(url) || prepGlb(box, { glb: url }, prepFor(url), () => {});
      cache.set(url, got);
      Promise.resolve(got).then((src) => { if (box.dataset.glb === url) mv.setAttribute('src', src); });
    };
    mv.addEventListener('error', () => { box.classList.remove('is-loading', 'is-auto', 'is-want'); box._fsWant = false; box._on = false; rel(); mv.remove(); showErr(box); });
    // Görünüm denetimi (başlangıç açısı, Sıfırla, telefonda iki parmak): assets/kz-3dv.js, yalnız 3D yüklenirken iner
    const v3d = window.kz3dv || !window.kzAssets?.v3d ? null : addScript(window.kzAssets.v3d).catch(() => null);
    // Telefonda kare alan (29.09.2026, uygulama içi tarayıcı kasması; KARARLAR §8): model sayfada görünmez. İndirme ve
    // hazırlık (worker) bölüme yaklaşınca yine arkada; model-viewer'ın açılışı (modülün çalışması, ayrıştırma, ilk çizim:
    // ana iş parçacığında 100-400 ms'lik bloklar) ise oynata basınca ya da alan ekrandayken ziyaretçi 1,2 sn hiç dokunmayıp
    // kaydırmayınca. Önce buton geçişinden sonra kaydırmanın ortasına düşüyordu. Modül dosyası önceden indirilir (çalıştırılmaz)
    let gate = null; box._pd = 0;
    if (sqm && !box._fsWant) {
      gate = new Promise((res) => { box._go = () => { box._go = null; res(); }; });
      if (!load3d.pre) { load3d.pre = 1; document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'modulepreload', href: MV })); }
      box._warm = () => { if (box._wq || !box._go || !box._pd) return; box._wq = 1; quiet(() => { box._wq = 0; if (box._go && box.classList.contains('is-vis')) box._go(); }, 1200, Infinity); };
    }
    const mvMod = gate ? null : import(MV); // bilgisayar ve uzun alan: eskisi gibi hazırlıkla aynı anda
    Promise.all([envOf(d).catch(() => 'legacy'), prepGlb(box, d, prepFor(d.glb), (p) => setBar(p * 0.85)), v3d, mvMod]).then(async ([env, src]) => {
      if (gate) {
        rel(); box._pd = 1; // beklerken kare hızı yargıcı ölçer; ısınma yalnız hazırlık bitince (modül kaydırmaya düşmesin)
        if (box.classList.contains('is-vis')) box._warm();
        await gate;
        await new Promise((r) => quiet(r, box._fsWant ? 60 : 250)); // modül de sessiz anda (oynata basıldıysa parmak kalkınca)
        if (!box._hold) { box._hold = 1; kzFps.hold(true); }
        await import(MV);
      }
      if (window.kz3dv && !box._cam) box._cam = window.kz3dv.cam(box, mv);
      prepped = src !== d.glb; cache.set(d.glb, src); prep._tr = prepped && kzFps.q; // zayıf cihazda cam geçirgenliği yok
      // AR: iPhone'da Quick Look için USDZ'yi model-viewer sahneden kendisi üretir. Hazırlanmış model tarayıcıda
      // üretildiği için (blob) Android Scene Viewer açamaz: orada WebXR kullanılır
      if (box.hasAttribute('data-ar')) mv.setAttribute('ar-modes', prepped ? 'webxr quick-look' : 'webxr scene-viewer quick-look');
      // meshopt ile sıkıştırılmış modeller için çözücü temadan (Shopify CDN) gelir; Draco'yu model-viewer kendisi çeker
      const MVE = customElements.get('model-viewer');
      // (Hazırlanmış model çözülmüş halde gelir: çözücü gerekmez)
      if (MVE && !prepped && window.kzAssets?.meshopt && !MVE.meshoptDecoderLocation) MVE.meshoptDecoderLocation = window.kzAssets.meshopt;
      // model-viewer kare hızını korumak için çözünürlüğü kendisi düşürür; zayıf cihazda (düşük kalite) daha da inebilir
      if (MVE && !load3d.fps) { load3d.fps = true; const ms = () => { MVE.minimumRenderScale = kzFps.q ? 0.5 : 0.25; }; ms(); kzFps.on(ms); }
      mv.setAttribute('environment-image', env);
      ex = (parseFloat(d.exposure) || 0.53) * (env === 'neutral' || env === 'legacy' ? 1.3 : 1);
      // Modelin açılması (three.js ayrıştırma, gölgelendirici derleme) da kaydırma sessizliğinde: geçişin ortasına denk gelmez
      const open = () => { mv.setAttribute('src', src); box.appendChild(mv); if (touch || sqm) full3d(box, mv); };
      if (box._fsWant) quiet(open, 60); else quiet(open, 250, 6000); // oynata basıldıysa hemen (ziyaretçi bekliyor; parmak kalkınca)
    }).catch(() => { box.classList.remove('is-loading', 'is-auto', 'is-want'); box._fsWant = false; box._on = false; rel(); showErr(box); });
  };
  // Ekran adı alanı ‹ ad › (kutuda ve pencerede; init3d'de bir kez toplanır: pencere açılınca body'ye taşınır). Yalnız
  // 2 ve daha fazla ekranı olan model açıkken görünür; sondan başa döner
  const menuUi = (box) => {
    const M = box._menu, on = !!M && M.n > 1;
    (box._mui || []).forEach((u) => {
      u.hidden = !on;
      const n = $('[data-kz-3dm-n]', u);
      if (on && n) n.innerHTML = tagHtml(M.names?.[M.i] || `${M.i + 1}. ekran`); // metin etiketleri çalışır
    });
  };
  // LED Aç / Kapat (29.09.2026): düğme yalnız açık modelde LED varken; söndürme / yakma kz-3dv.js led (yalnız 3D
  // yüklenirken iner). Seçim model değişince korunur: model açılırken ilk karesinden önce uygulanır
  const ledSync = (box) => {
    const has = !!box._mv?._ledM?.size;
    box.classList.toggle('has-led', has); box._fs?.classList.toggle('has-led', has);
    if (has) window.kz3dv?.led?.(box);
  };
  // Tam ekran 3D penceresi (telefon): kısa fade ile açılır, model içeri taşınır (yeniden yüklenmez), orada döndürülür ve
  // yakınlaştırılır; sayfa arkada kilitli. Çıkış (sağ üst ve sağ alt), Escape ya da telefonun geri hareketi kapatır; model yerine döner
  const full3d = (box, mv) => {
    const sqPage = box.hasAttribute('data-sq') && matchMedia('(pointer: coarse), (max-width: 749px)').matches;
    const fs = box._fs || $('[data-kz-3dfs]', box.closest('section'));
    if (!fs) return;
    const xs = $$('[data-kz-3dfs-close]', fs), home = fs.parentElement, stage = $('[data-kz-3dfs-stage]', fs) || fs;
    let open = false, pushed = false, spinning = false, zoomed = false;
    // Hareketler model-viewer'ın değil bizim (kz-3dv.js): iki parmakla çevirme ve yakınlaştırma.
    // Dosya inmediyse model-viewer'ın kendi hareketleri (döndürme, sıkıştırarak yakınlaştırma)
    box._cam?.touch(stage, () => open);
    const mx = parseFloat(box.dataset.fsx) || 0, my = parseFloat(box.dataset.fsy) || 0;
    const place = () => {
      if (!mx && !my) return;
      if (!window.kz3dv?.shift?.(mv, mx / (stage.clientWidth || innerWidth), my / (stage.clientHeight || innerHeight))) fs.classList.add('is-cssmove');
    };
    addEventListener('resize', () => { if (open) { place(); tight(); } }); // oran alanın boyuna göre (telefon döndürülünce)
    // Alt sıra (Sıfırla, LED, Çıkış) dar ekrana sığmazsa LED düğmesi yalnız ikon (yazı küçülmez; adı aria-label'da).
    // Açılışta ve döndürmede bir kez ölçülür, uzun yazıyla (LED Kapat / LED Aç)
    const bar = $('.kz-3dfs__bar', fs), lb = bar && $('[data-kz-3d-led]', bar);
    const tight = () => {
      if (!lb) return;
      // Yazılar metin etiketleriyle (innerHTML, kzTags): <bold> vb. kaybolmaz; erişilebilir ad düz yazı
      const t = $('[data-kz-3d-led-t]', lb), cur = t.innerHTML, on = lb.dataset.on || '', off = lb.dataset.off || '';
      bar.classList.remove('is-tight'); t.innerHTML = tagHtml(on.length >= off.length ? on : off);
      const over = bar.scrollWidth > bar.clientWidth + 1;
      t.innerHTML = cur; bar.classList.toggle('is-tight', over);
      if (over) lb.setAttribute('aria-label', t.textContent); else lb.removeAttribute('aria-label');
    };
    const show = () => {
      if (open || !box.classList.contains('is-ready')) return;
      open = true; fs._from = document.activeElement;
      document.body.appendChild(fs); // bölümün katmanından çıkar: üst bar ve WhatsApp düğmesinin de üstünde
      fs.hidden = false; stage.appendChild(mv);
      tight();
      // Hareketli zemin (3D bölümü → Arka plan): pencerenin alanı hemen ölçülür; sayfadaki kutununki pencere açıkken durur
      window.kz3dfsOpen = true; window.kzFxRefresh?.(fs);
      box._gifOn?.(); // ekran GIF'i (kare alanda yalnız pencerede oynar)
      // Pencerede kendi kendine dönme durur (ziyaretçi döndürüyor); kapanınca geri gelir
      spinning = mv.hasAttribute('auto-rotate'); mv.removeAttribute('auto-rotate');
      if (!box._cam) { mv.setAttribute('camera-controls', ''); mv.setAttribute('touch-action', 'none'); }
      // Yakınlık / uzaklık (Z, px; 3D bölümü → "Telefonda 3D penceresi: modelin yeri"): CSS translateZ gibi, perspektif
      // pencerenin odak uzaklığı f (sahne yüksekliği ve görüş açısından): model f / (f − z) kat büyür; kamera uzaklığı ve
      // yakınlaşma sınırları (f − z) / f ile çarpılır (kz-3dv.js zoom). Model kendi merkezinde döner, öbür ayarlar aynı
      const z = parseFloat(box.dataset.fsz) || 0;
      if (z && box._cam?.zoom) {
        const f = (stage.clientHeight || innerHeight) / 2 / Math.tan(((mv.getFieldOfView?.() || 30) * Math.PI) / 360);
        box._cam.zoom(Math.min(3, Math.max(0.2, (f - z) / f))); zoomed = true;
      }
      // Modelin yeri (Yatay / Dikey kaydırma, px): tuval pencereyi kaplar, model kameranın görüntü merkeziyle kayar
      // (kz-3dv.js shift; LED ışıması kenarda kesilmez); olmazsa eskisi gibi CSS kaydırma
      place();
      // Üst ve alt kenarda yumuşak kaybolma: tuvalin içinde (kz-3dv.js); olmazsa CSS maskesi
      if (mv._fade === undefined) mv._fade = window.kz3dv?.fade?.(mv) || null;
      if (mv._fade) mv._fade.on(true); else fs.classList.add('is-cssfade');
      lock(true);
      requestAnimationFrame(() => requestAnimationFrame(() => fs.classList.add('is-on')));
      try { history.pushState({ kz3d: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
      xs[0]?.focus({ preventScroll: true });
    };
    const hide = (fromBack) => {
      if (!open) return;
      open = false;
      fs.classList.remove('is-on');
      if (pushed && !fromBack) history.back();
      pushed = false;
      setTimeout(() => {
        if (spinning || mv._glideRot) { mv._glideRot = false; mv.setAttribute('auto-rotate', ''); } // geçişte durdurulmuşsa da (kz:glide) döner
        // Sayfadaki görünüm hep modelin başlangıç açısından (pencerenin Z çarpanı kalkar)
        if (zoomed) { box._cam?.zoom(1); zoomed = false; }
        if (mx || my) { window.kz3dv?.shift?.(mv, 0, 0); fs.classList.remove('is-cssmove'); }
        if (box._cam) box._cam.reset(true); else { mv.removeAttribute('camera-controls'); mv.cameraOrbit = box.dataset.orbit; mv.jumpCameraToGoal?.(); }
        mv._fade?.on(false);
        box.appendChild(mv); fs.hidden = true; home.appendChild(fs); lock(false);
        window.kz3dfsOpen = false;
        if (sqPage) { box._gif?.(); box._gif = null; } // kare alanda model sayfada görünmez: GIF durur
        fs._from?.focus?.({ preventScroll: true });
      }, reduce ? 0 : 250);
    };
    box.addEventListener('click', show);
    box._fsShow = show; // oynat butonu (kare alan) ve "3D modeli göster" (model inince açılır)
    xs.forEach((x) => x.addEventListener('click', () => hide(false)));
    addEventListener('popstate', () => hide(true));
    addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(false); });
  };
  const showErr = (box) => {
    if ($('.kz-3d__err', box)) return;
    const p = document.createElement('p'); p.className = 'kz-3d__err'; p.textContent = '3D model yüklenemedi. Tekrar dene.'; box.appendChild(p);
  };
  // Model çekmecelerini kapat (hepsi). Açıkken dışarı dokunmak yalnız kapatır (arkadaki 3D alanı pencereyi açmasın)
  const ddShut = () => $$('.kz-3dd.is-open').forEach((d) => { d.classList.remove('is-open'); $('[data-kz-3dd-btn]', d)?.setAttribute('aria-expanded', 'false'); });
  document.addEventListener('click', (e) => {
    const open = $$('.kz-3dd.is-open');
    if (!open.length || open.some((d) => d.contains(e.target))) return;
    e.preventDefault(); e.stopPropagation(); ddShut();
  }, true);
  addEventListener('keydown', (e) => { if (e.key === 'Escape') ddShut(); });
  const init3d = (root) => $$('[data-kz-3d]', root).forEach((box) => {
    if (box._3dinit) return; box._3dinit = true;
    // Bölüm dosyası eski kalırsa (Shopify eskisini tutarsa: kutuda data-sq / data-sq-off yok) yine 1:1: telefonda kare
    // alan, oynat halkası ve "Tıkla ve Kullan"; bilgisayarda kare alan (iki ayarın varsayılanı Yeni (1:1))
    if (!box.hasAttribute('data-sq') && !box.hasAttribute('data-sq-off')) {
      box.setAttribute('data-sq', ''); box.setAttribute('data-sqd', ''); // bilgisayarda da 1:1 (varsayılan Yeni)
      if (!$('[data-kz-3d-play]', box)) box.insertAdjacentHTML('beforeend', '<button class="kz-3d__play" type="button" data-kz-3d-play aria-label="3D modeli aç"><span class="kz-3d__pr" aria-hidden="true"></span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.2v13.6L19 12z" fill="currentColor"/></svg></button><span class="kz-3d__cta" aria-hidden="true">Tıkla ve Kullan</span>');
    }
    // Model kutucukları (sayfada ve pencerede aynı seçim). Model henüz inmediyse seçilen model iner
    const sec = box.closest('section');
    const ths = $$('[data-kz-3d-th]', sec);
    ths.forEach((t) => t.addEventListener('click', () => {
      const was = $('[data-kz-3d-th].is-on', sec)?.dataset.i;
      ths.forEach((x) => { const on = x.dataset.i === t.dataset.i; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      box._th = t; // başlangıç görünümü bu kutucuktan (model açılınca uygulanır, Sıfırla buna döner)
      if (box.dataset.glb === t.dataset.glb) { if (was !== t.dataset.i) box._cam?.reset(false); return; }
      box.dataset.glb = t.dataset.glb;
      if (box._swap) { ths.forEach((x) => { if (x.dataset.i === t.dataset.i) x.classList.add('is-busy'); }); box._swap(t.dataset.glb); } else if (!box._on) load3d(box);
    }));
    // Model çekmecesi (kz-3dd, sayfada ve pencerede): buton yukarı açar; satır seçilince kapanır, buton seçili modelin adını
    // (buton yazısı sabit değilse) ve görselini alır. Dışarı dokunmak ve Escape kapatır (aşağıda, belge düzeyinde)
    const dds = $$('[data-kz-3dd]', sec);
    dds.forEach((d) => {
      const b = $('[data-kz-3dd-btn]', d);
      b?.addEventListener('click', (e) => {
        e.stopPropagation();
        const on = !d.classList.contains('is-open');
        ddShut();
        d.classList.toggle('is-open', on); b.setAttribute('aria-expanded', on);
      });
    });
    ths.forEach((t) => t.addEventListener('click', () => {
      if (!dds.length || !t.matches('.kz-3dd__row')) return;
      dds.forEach((d) => {
        const b = $('[data-kz-3dd-btn]', d), lb = $('.kz-3dd__lb', b), bi = $('.kz-3dd__bi', b);
        if (lb && !b.hasAttribute('data-fixed')) lb.innerHTML = $('.kz-3dd__n', t).innerHTML;
        if (bi) bi.innerHTML = $('.kz-3dd__img', t).innerHTML;
      });
      ddShut();
    }));
    // Telefonda kare alan ("Telefonda sayfadaki 3D alanı" → Kare, 29.09.2026): ortadaki oynat tam ekran 3D penceresini
    // açar; model henüz inmediyse hemen iner (kaydırma sessizliği beklenmez: ziyaretçi istedi), hazır olunca açılır.
    // "3D modeli göster" (Dokununca / veri tasarrufu) de aynı: model inince pencere açılır. Oynat halkasının nabzı
    // yalnız alan ekrandayken (is-vis); hareketi azalt / veri tasarrufunda yok (CSS)
    const sq = box.hasAttribute('data-sq') && matchMedia('(pointer: coarse), (max-width: 749px)').matches;
    const want = () => {
      if (box._fsShow && box.classList.contains('is-ready')) { box._fsShow(); return; }
      box._fsWant = true; box.classList.add('is-want');
      if (!box._on) { $('.kz-3d__err', box)?.remove(); load3d(box); } else box._go?.();
    };
    $('[data-kz-3d-play]', box)?.addEventListener('click', (e) => { e.stopPropagation(); want(); });
    // Kare alanın herhangi bir yerine dokunmak da (model henüz açılmadıysa; açıldıysa full3d'nin kendi dokunuşu)
    if (sq) box.addEventListener('click', () => { if (!box.classList.contains('is-ready')) want(); });
    // Alan ekrandan çıkınca oynata basılmış ama henüz açılmamış pencere açılmaz (ziyaretçi kaydırıp gittiyse sayfanın
    // ortasında birden açılıp sayfayı kilitliyordu); model inmeye devam eder, sonraki basışta anında açılır. Ekrana gelince
    // bekleyen açılış boşta ısınır (load3d box._warm)
    if (sq && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => {
      const v = e.isIntersecting;
      kzFps.write(() => {
        box.classList.toggle('is-vis', v);
        if (!v && box._fsWant && !box.classList.contains('is-ready')) { box._fsWant = false; box.classList.remove('is-want'); }
        if (v) box._warm?.();
      });
    }).observe(box);
    $('[data-kz-3d-go]', box)?.addEventListener('click', (e) => { if (sq) { e.stopPropagation(); want(); return; } $('.kz-3d__err', box)?.remove(); load3d(box); });
    // Ekran adı alanı: ‹ › ile önceki / sonraki ekran, sondan başa; görüntü anında ekrana (kz-glb.js kzGlbMenu), GIF ise
    // ardından oynar. Tıklama kutuya geçmez (telefonda kutuya dokunmak pencereyi açar)
    box._fs = $('[data-kz-3dfs]', sec);
    box._mui = $$('[data-kz-3dm]', sec);
    box._mui.forEach((u) => $$('[data-kz-3dm-go]', u).forEach((b) => b.addEventListener('click', (e) => {
      e.stopPropagation();
      const M = box._menu; if (!M) return;
      const i = (M.i + +b.getAttribute('data-kz-3dm-go') + M.n) % M.n;
      box._gif?.(); box._gif = null; box._scrI = i;
      M.go(i).then(() => { if (box._menu === M && box._scrI === i) box._gifOn?.(); });
      menuUi(box);
    })));
    // LED Aç / Kapat (kutuda ve pencerede): yazı duruma göre (data-on: yanarken, data-off: sönükken)
    const leds = $$('[data-kz-3d-led]', sec);
    box._lk = box._lt = 1;
    leds.forEach((b) => b.addEventListener('click', (e) => {
      e.stopPropagation();
      box._lt = box._lt > 0 ? 0 : 1;
      leds.forEach((x) => { x.classList.toggle('is-off', !box._lt); const t = $('[data-kz-3d-led-t]', x), v = box._lt ? x.dataset.on : x.dataset.off; if (t) t.innerHTML = tagHtml(v); if (x.hasAttribute('aria-label')) x.setAttribute('aria-label', t ? t.textContent : v); });
      window.kz3dv?.led?.(box, true);
    }));
    // Sıfırla (kutuda ve pencerede): kamera ve çevirme modelin başlangıç görünümüne, kısa animasyonla
    $$('[data-kz-3d-reset]', sec).forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); box._cam?.reset(false); }));
    // Bölüme yaklaşınca yükleme: sayfa açılışında değil, load + boşta kalma sonrası, bölüme ~1 ekran kala.
    // "Yalnız hızlı bağlantıda" şartı: 4G ve ≥ 3 Mbps (bağlantı bilgisi vermeyen tarayıcılarda, ör. iOS Safari, hızlı sayılır).
    // Veri tasarrufu / 2G'de asla: buton görünür, dokununca iner. is-auto butonu gizler (Flipper'da buton yok).
    const mode = box.dataset.load || 'near';
    const fast = (!conn.effectiveType || conn.effectiveType === '4g') && (!conn.downlink || conn.downlink >= 3);
    if (mode !== 'tap' && !slow && (mode === 'near' || fast) && 'IntersectionObserver' in window) {
      box.classList.add('is-auto');
      // Yükleme kaydırma sessizliğinde (quiet: kaydırma ve dokunma bitince; takılı sayfa içi kaydırmayı kutu ekrandaysa
      // 1,5 sn, ~1 ekran uzaktaysa 6 sn sonra aşar)
      afterLoad(() => new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); quiet(() => load3d(box), 300, e.boundingClientRect.top < innerHeight ? 1500 : 6000); } }, { rootMargin: '100% 0px' }).observe(box));
    }
  });
  init3d(document);

  // ---------- "Tam sayfaya ayarla": telefonda uzun içeriği ekrana sığdır ----------
  // Bölüm CSS'le tam ekran yüksekliğinde (kz-base.css). İçerik ekrandan uzunsa ve "Ekrana sığdır" seçiliyse içerik
  // öğeleri aynı oranda küçültülür (scale, en az 0,5; bölümün iç boşlukları ve öğe araları sabit kalır). Ölçüm karede
  // değil: açılışta, yazı tipleri inince ve ekran yüksekliği değişince (döndürme) bir kez.
  let initFp = () => {};
  if ('ResizeObserver' in window) {
    const mq = matchMedia('(max-width: 749px)');
    // Ekran yüksekliği ölçer (100svh). div değil: Dawn boş div'leri gizliyor (div:empty)
    const probe = document.createElement('i');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'display:block;position:fixed;top:0;left:0;width:0;height:var(--kz-vh,100svh);visibility:hidden;pointer-events:none'; // --kz-vh: araç çubuğunda değişmez (kz-head)
    document.body.appendChild(probe);
    const fit = (sec) => {
      const wrap = sec.querySelector(':scope > .kz-wrap'); if (!wrap) return;
      const kids = [...wrap.children];
      kids.forEach((c) => { if (c.dataset.kzFpz) { c.style.scale = ''; c.style.transformOrigin = ''; c.style.marginBottom = ''; delete c.dataset.kzFpz; } });
      if (!mq.matches) return;
      const items = kids.filter((c) => c.offsetParent !== null && !c.matches('.kz-3dfs') && !/absolute|fixed/.test(getComputedStyle(c).position));
      if (!items.length) return;
      const body = items.reduce((t, c) => t + c.offsetHeight, 0);
      const fixed = sec.offsetHeight - body; // iç boşluklar + öğe araları (içerik uzunken bölüm doğal boyunda)
      const avail = probe.offsetHeight - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kz-bar-h')) || 0);
      const room = avail - fixed;
      if (body <= room || room <= 0) return;
      // Her öğe üst ortadan aynı oranda küçülür (scale: düzeni bozmaz, yeniden akış yok); küçülen yükseklik alt
      // kenar boşluğuyla geri alınır, böylece bölüm gerçekten kısalır ve alttaki bölümler yukarı çıkar
      const z = Math.max(0.5, room / body);
      items.forEach((c) => {
        const mb = parseFloat(getComputedStyle(c).marginBottom) || 0;
        c.dataset.kzFpz = '1';
        c.style.scale = z.toFixed(4);
        c.style.transformOrigin = 'top center';
        c.style.marginBottom = `${(mb - (1 - z) * c.offsetHeight).toFixed(2)}px`;
      });
    };
    const all = () => $$('[data-kz-fp-fit]').forEach(fit);
    initFp = (root) => { (root.matches?.('[data-kz-fp-fit]') ? [root] : $$('[data-kz-fp-fit]', root)).forEach(fit); };
    all();
    document.fonts?.ready.then(all);
    let lastH = probe.offsetHeight;
    new ResizeObserver(() => { const h = probe.offsetHeight; if (h !== lastH) { lastH = h; all(); } }).observe(probe);
    mq.addEventListener?.('change', all);
  }

  // ---------- Tema editörü: yeniden çizilen bölümü baştan başlat ----------
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target;
    okFit(root); glowScan(root); glowFit(root); initGa(root); initDia(root); initModels(root); initFp(root); initTv(root); initGal(root); initReveal(root); initFx(root); initDecode(root); initVideos(root); initCk(root); init3d(root); initCo(root); initDd(root);
    $$('[data-kz-sheet]', root).forEach((sh) => { if (!sh.classList.contains('is-open')) sh.setAttribute('inert', ''); });
  });
  // Sayfa yenilemeden yeniden çizilen içerik (sepet formu, assets/kz-cart.js): yalnız içerik başlatıcıları. Atmosfer
  // efekti, 3D, video gibi bölüm motorları kurulmaz (initFx kökü değil bütün sayfayı yeniden kurar; adet başına kurulmasın)
  window.kzInit = (root) => { window.kzTags?.fixDom(root); okFit(root); glowScan(root); glowFit(root); initReveal(root); };
  document.addEventListener('shopify:section:unload', (e) => stopFx(e.target));
  // Tema editörü: "Farklar (açılır buton)" bloğu seçilince açılış animasyonu oynar (ayar değişince bölüm yeniden çizilir,
  // blok yeniden seçilir: yeni ayarla yeniden oynar); fark satırı seçilince kutu anında açılır. Bırakılınca sayfa
  // ayarındaki haline döner
  // Tema editörü: "Model çekmecesi" ya da bir "3D model" bloğu seçilince model çekmecesi açılır, bırakılınca kapanır
  document.addEventListener('shopify:block:select', (e) => { const d = e.target.closest?.('[data-kz-3dd]'); if (d) { d.classList.add('is-open'); $('[data-kz-3dd-btn]', d)?.setAttribute('aria-expanded', 'true'); } });
  document.addEventListener('shopify:block:deselect', (e) => { if (e.target.closest?.('[data-kz-3dd]')) ddShut(); });
  document.addEventListener('shopify:block:select', (e) => {
    const d = e.target.closest?.('.kz-dd');
    if (!d) return;
    d._kzO ??= d.open;
    if (e.target === d && d._dd) d._dd.show(); else if (!d.open) d.open = true;
  });
  document.addEventListener('shopify:block:deselect', (e) => { const d = e.target.closest?.('.kz-dd'); if (d && d._kzO !== undefined) { d.classList.remove('is-in', 'is-out'); d.open = d._kzO; delete d._kzO; } });

  // ---------- Teknik özellikler: "Devamını gör" ----------
  // Açılış efekti (editörden, süre T): şifre çözme + glitch. Her grup konumuna göre yukarıdan aşağıya sırayla
  // kırpılıp kayarak belirir (CSS kz-gl); karakterler rastgele işaretlerden çözülür, çözülme de yukarıdan aşağıya ilerler.
  // Toplam süre T: son karakter T'de oturur. Hareketi azalt / veri tasarrufu / atmosfer kapalıyken efekt yok.
  // dl: başlama gecikmesi (Farklar açılır kutusu, ms); Devamını gör'de 0. Dönen: bitir() (yazıyı hemen asıl haline
  // getirir; kutu kapanırken ya da yeniden açılırken)
  // Genişlik korunur (28.09.2026, kullanıcı isteği: Farklar kutusu açılırken yatayda genişleyip daralıyordu, bir değer
  // ara karelerde iki satıra iniyordu). Yalnız harf ve rakamlar karışır; boşluk ve noktalama yerinde kalır, işaretler
  // de satır bölmeyen türden (harf/rakam sınıfı: "-", "/", "|", "!" yok): satırın bölünebileceği yerler aynı. Her metin
  // parçasının karışık hali, yazının kendi yazı tipinde (tuvalde) ölçülerek hiçbir karede asıl halinden geniş olmaz
  // (asıl haldeki harf çifti aralıkları da hesaba katılır, 0,3 px pay); olmazsa o karede asıl hali yazılır. Böylece
  // satırlar kırılmaz, içeriğe göre genişleyen kutu oynamaz
  const GL = '01<>#$%&*ABCDEFHKMNPRSTUVWXZ23456789=+ijlIftr@~^_mw';
  const GLRE = /[\p{L}\p{N}]/u;
  const glW = new Map();
  let glC = null;
  const glyphs = (el) => {
    const cs = getComputedStyle(el), tt = cs.textTransform;
    const tf = (c) => (tt === 'uppercase' ? c.toUpperCase() : tt === 'lowercase' ? c.toLowerCase() : c);
    const font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`, key = font + tt;
    glC ||= document.createElement('canvas').getContext('2d');
    if (!glW.has(key)) { glC.font = font; glW.set(key, { w: [...GL].map((g) => glC.measureText(tf(g)).width), m: new Map() }); }
    const g = glW.get(key);
    const wOf = (ch) => { if (!g.m.has(ch)) { glC.font = font; g.m.set(ch, glC.measureText(tf(ch)).width); } return g.m.get(ch); };
    // Metnin tamamının genişliği ile harflerin toplamı arasındaki fark: asıl haldeki harf çifti aralıkları (çoğunlukla eksi)
    const kern = (str) => { glC.font = font; return glC.measureText(tf(str)).width - [...str].reduce((t, ch) => t + wOf(ch), 0); };
    return { wOf, kern, gw: g.w };
  };
  const moreFx = (list, items, T, dl = 0) => {
    const top0 = items[0].getBoundingClientRect().top;
    const span = Math.max(1, items[items.length - 1].getBoundingClientRect().bottom - top0);
    const rg = document.createRange(); const nodes = [];
    items.forEach((it) => {
      const d = ((it.getBoundingClientRect().top - top0) / span) * T * 0.6;
      it.style.setProperty('--kz-gd', `${(d + dl) | 0}ms`); it.style.setProperty('--kz-gt', `${(T * 0.4) | 0}ms`);
      it.classList.add('is-gl');
      const tw = document.createTreeWalker(it, NodeFilter.SHOW_TEXT); let n;
      while ((n = tw.nextNode())) {
        if (n.parentElement.closest('svg, .kz-spec__svg, .kz-spec__d') || !n.data.trim()) continue;
        const ts = [], G = glyphs(n.parentElement);
        for (let i = 0; i < n.length; i++) {
          if (!GLRE.test(n.data[i])) { ts.push(0); continue; } // boşluk, noktalama: karışmaz
          rg.setStart(n, i); rg.setEnd(n, i + 1);
          const y = (rg.getBoundingClientRect().top - top0) / span;
          ts.push(Math.min(T, Math.max(d + 60, y * T * 0.8 + Math.random() * T * 0.2)));
        }
        const orig = n.data, w0 = Array.from({ length: orig.length }, (_, i) => (ts[i] > 0 ? G.wOf(orig[i]) : 0)); // UTF-16 sırası (ts gibi)
        // err: karışık harflerin asıllarına göre toplam genişlik farkı; üst sınır lim (asıl kerning + 0,3 px pay), hedef biraz altı
        const lim = Math.min(0, G.kern(orig)) - 0.3;
        nodes.push({ n, orig, ts, w0, gw: G.gw, cw: w0.slice(), err: 0, lim, aim: lim - 0.35 });
      }
    });
    // Harf i için işaret: düğümün toplam farkını hedefe (aim) en çok yaklaştıran 3 işaretten rastgele biri
    const pick = (o, i) => {
      const base = o.err - (o.cw[i] - o.w0[i]), want = o.w0[i] + o.aim - base, gw = o.gw;
      const b3 = [-1, -1, -1], d3 = [Infinity, Infinity, Infinity];
      for (let j = 0; j < gw.length; j++) {
        const v = Math.abs(gw[j] - want);
        if (v < d3[2]) { let k = 2; while (k > 0 && v < d3[k - 1]) { d3[k] = d3[k - 1]; b3[k] = b3[k - 1]; k--; } d3[k] = v; b3[k] = j; }
      }
      const j = b3[(Math.random() * 3) | 0];
      o.err = base + gw[j] - o.w0[i]; o.cw[i] = gw[j];
      return GL[j];
    };
    const settle = (o, i) => { o.err -= o.cw[i] - o.w0[i]; o.cw[i] = o.w0[i]; };
    // Yazmadan önce: karışık hal asıl halden geniş olamaz. Aşarsa karışık harfler hedefe göre yeniden seçilir; yine
    // aşarsa bu kare asıl hali yazılır
    const fit = (o) => {
      if (o.err <= o.lim) return o.cur.join('');
      for (let i = 0; i < o.orig.length && o.err > o.lim; i++) if (o.cur[i] !== o.orig[i]) o.cur[i] = pick(o, i);
      return o.err <= o.lim ? o.cur.join('') : o.orig;
    };
    list.setAttribute('aria-busy', 'true');
    // Kare hızı yöneticisiyle her karede çizilir; her harf kendi aralığıyla (30-80 ms) değişir
    nodes.forEach((o) => { o.cur = Array.from({ length: o.orig.length }, (_, i) => (o.ts[i] > 0 ? pick(o, i) : o.orig[i])); o.nx = o.ts.map(() => 0); });
    const t0 = performance.now() + dl;
    let stop = null;
    const end = () => {
      if (!stop) return;
      stop(); stop = null;
      nodes.forEach((o) => { o.n.data = o.orig; });
      items.forEach((it) => { it.classList.remove('is-gl'); it.style.removeProperty('--kz-gd'); it.style.removeProperty('--kz-gt'); });
      list.removeAttribute('aria-busy');
    };
    stop = kzFps.add((now) => {
      const t = now - t0;
      if (t < 0) return;
      if (t >= T) { end(); return; }
      nodes.forEach((o) => {
        let ch = false;
        for (let i = 0; i < o.orig.length; i++) {
          if (t >= o.ts[i]) { if (o.cur[i] !== o.orig[i]) { o.cur[i] = o.orig[i]; settle(o, i); ch = true; } } else if (t >= o.nx[i]) { o.cur[i] = pick(o, i); o.nx[i] = t + 30 + Math.random() * 50; ch = true; }
        }
        if (ch) o.n.data = fit(o);
      });
    });
    return end;
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kz-more]');
    if (!b) return;
    const items = [...b.closest('section').querySelectorAll('[data-kz-more-item]')];
    items.forEach((el) => { el.hidden = false; });
    const kb = document.activeElement === b;
    b.remove();
    if (!items.length) return;
    // Klavyeyle basıldıysa odak kaybolmasın: ilk açılan gruba geç
    if (kb) { items[0].tabIndex = -1; items[0].focus({ preventScroll: true }); }
    if (b.dataset.fx === 'decode_glitch' && window.kzFx?.on && !lite) moreFx(items[0].parentElement, items, Math.max(300, +b.dataset.ms || 900));
  });

  // ---------- Modeller: "Farkları gör" açılır kutusu (açılış ve kapanış animasyonu) ----------
  // Ayarlar "Farklar (açılır buton)" bloğundan (data-an*, data-bx*, data-cl*; süreler ve eğri CSS değişkeni,
  // kz-models.liquid). details'in kendi aç-kapa'sı yerine burada.
  // Kutu: yüksekliği kare kare büyür / küçülür (kzFps.addHi, düzen okuması yok: boy tıklamada bir kez ölçülür); liste
  // ekranın altında kalıyorsa sayfa aynı karede, aynı eğriyle kayar: üstteki öğeler yukarı, alttakiler aşağı yumuşakça
  // gider (28.09.2026 kullanıcı isteği: ışınlanma yok). Bu sırada tarayıcının kaydırma sabitlemesi (overflow-anchor)
  // kapalı: yoksa kutu büyürken sayfayı kendisi bir anda kaydırabiliyor. Bayrak <body>'de, <html>'de değil: kökün
  // hesaplanmış stili değişince bütün belge (~1100 öğe) yeniden hesaplanıyor (Android, 4× yavaş işlemcide 40-125 ms,
  // açılışta ve bitişte iki kez; body'de 1-4 ms, sabitleme aynı kapanıyor; KARARLAR §8). Ziyaretçi dokunur/kaydırırsa
  // sayfa kayması durur.
  // Satırlar: açarken .is-in, kapatırken .is-out ve her satırın gecikmesi (--d) sıraya göre; animasyonlar CSS'te
  // (transform/opacity). Şifre çözme: Devamını gör'ün motoru (moreFx), atmosfer kapalı / hareketi azalt / veri
  // tasarrufunda kayarak belirme. Hareketi azalt: hepsi anında.
  const bez = (x1, y1, x2, y2) => (x) => {
    if (x <= 0) return 0;
    if (x >= 1) return 1;
    let t = x;
    for (let i = 0; i < 8; i++) {
      const cx = 3 * x1 * t * (1 - t) ** 2 + 3 * x2 * t * t * (1 - t) + t ** 3 - x;
      const dx = 3 * x1 * (1 - t) ** 2 + 6 * (x2 - x1) * t * (1 - t) + 3 * (1 - x2) * t * t;
      if (Math.abs(cx) < 1e-5 || !dx) break;
      t = Math.min(1, Math.max(0, t - cx / dx));
    }
    return 3 * y1 * t * (1 - t) ** 2 + 3 * y2 * t * t * (1 - t) + t ** 3;
  };
  const DD_EZ = { smooth: bez(0.4, 0, 0.2, 1), soft: bez(0.16, 1, 0.3, 1), lin: (x) => x, spring: bez(0.34, 1.56, 0.64, 1) };
  const initDd = (root) => $$('.kz-dd', root).forEach((d) => {
    const sm = d.querySelector(':scope > summary'), body = $('.kz-dd__body', d);
    if (d._dd || !sm || !body) return;
    const num = (k, v) => { const n = parseFloat(d.dataset[k]); return Number.isFinite(n) ? n : v; };
    // Sıra: 0 ilk başlayan. Ortadan dışa: ortadaki satır önce
    const order = (n) => {
      const dir = d.dataset.anDir;
      return (i) => (dir === 'up' ? n - 1 - i : dir === 'mid' ? Math.round(Math.abs(i - (n - 1) / 2)) : dir === 'all' ? 0 : i);
    };
    let tm = 0, grow = null, closing = false, fx = null, unT = 0;
    // Genişlik kilidi (28.09.2026, kullanıcı isteği: "yatay olarak asla ilerlemesin veya gerilemesin, açılırken yalnız
    // nihai yatay boyut geçerli olsun"): kutu içeriğine göre genişlik alabiliyor (Kutu hizalaması orta/sol/sağ); açılış
    // ve kapanış boyunca son haldeki genişliğinde (ölçülen, kesirli px) sabit kalır, bitince serbest. Pencere boyu
    // değişirse hemen serbest
    const bx = $('.kz-dd__box', d);
    const lock = (on) => {
      clearTimeout(unT);
      if (bx) bx.style.width = on ? `${bx.getBoundingClientRect().width}px` : '';
    };
    onWidth(() => { if (bx?.style.width) lock(false); }); // yalnız genişlik (araç çubuğu kilidi bırakmaz)
    // Kutu yüksekliği from → to (px), sayfa aynı anda dy kadar kayar; süre ve eğri ayardan (Kutunun açılma süresi,
    // Kutu ve sayfa kayma eğrisi; varsayılan yumuşak başlar, yumuşak durur: ilk karede sıçrama yok)
    const run = (from, to, dy, onEnd) => {
      grow?.stop(false);
      const T = Math.max(1, num('bxMs', 460)), ez = DD_EZ[d.dataset.bxEz] || DD_EZ.smooth, y0 = scrollY;
      let t0 = 0, sc = dy !== 0;
      const cancel = () => { sc = false; };
      const evs = ['wheel', 'touchstart', 'keydown'];
      evs.forEach((ev) => addEventListener(ev, cancel, { passive: true }));
      document.body.style.overflowAnchor = 'none';
      body.classList.add('is-grow');
      body.style.height = `${from}px`;
      let off = null;
      const stop = (done) => {
        off?.(); evs.forEach((ev) => removeEventListener(ev, cancel));
        document.body.style.overflowAnchor = '';
        body.classList.remove('is-grow'); body.style.height = '';
        grow = null;
        if (done) onEnd?.();
      };
      off = kzFps.addHi((now) => {
        if (!t0) t0 = now;
        const p = Math.min(1, (now - t0) / T), e = ez(p);
        body.style.height = `${Math.max(0, from + (to - from) * e)}px`;
        if (sc) scrollTo(0, Math.max(0, y0 + dy * e));
        if (p >= 1) stop(true);
      });
      grow = { stop };
    };
    // Kutunun doğal boyu (satır içi yükseklik geçici kaldırılarak; tıklamada bir kez)
    const natural = () => { const h = body.style.height; body.style.height = ''; const v = body.offsetHeight; body.style.height = h; return v; };
    const show = () => {
      clearTimeout(tm);
      closing = false;
      fx?.(); fx = null; // önceki açılışın harf çözmesi sürüyorsa yazı hemen asıl haline (ölçüm doğru olsun)
      lock(false);
      const cur = grow ? body.offsetHeight : 0;
      d.classList.remove('is-in', 'is-out');
      d.open = true;
      const H = natural();
      // Liste ekranın altında kalıyorsa: altı ekranın 16 px üstüne gelene kadar, buton üst barın altında kalacak kadar
      let dy = 0;
      if (d.hasAttribute('data-an-go')) {
        const top = body.getBoundingClientRect().top, sr = sm.getBoundingClientRect();
        const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kz-bar-h')) || 0;
        if (top + H > innerHeight) dy = Math.max(0, Math.min(top + H - innerHeight + 16, sr.top - bar - 12));
      }
      if (reduce) { grow?.stop(false); if (dy) scrollTo(0, scrollY + dy); return; }
      lock(true);
      const bxT = d.dataset.bxAn !== 'none' ? num('bxMs', 460) : 0, free = (t) => { unT = setTimeout(() => lock(false), Math.max(bxT, t) + 80); };
      if (d.dataset.bxAn !== 'none') run(cur, H, dy);
      else if (dy) run(H, H, dy);
      let an = d.dataset.an || 'slide';
      const its = $$('.kz-dd__an', d), n = its.length;
      if (an === 'none' || !n) { free(0); return; }
      if (an === 'glitch' && !(window.kzFx?.on && !lite)) { an = d.dataset.an = 'slide'; d.style.setProperty('--dd-ez', 'var(--kz-ease)'); }
      const ms = num('anMs', 380), fd = num('anFd', 300), st = num('anSt', 45), dl = num('anDl', 0), T = ms + (n - 1) * st;
      if (an === 'glitch') { fx = moreFx(body, its, T, dl); free(T + dl); return; }
      let mx = 0;
      if (an === 'scan') {
        // Çizgi kutunun tepesinden dibine T sürede iner; her satır çizgi üstüne geldiğinde belirir (konumlar kutunun
        // doğal boyuna göre, büyüme başlamadan ölçüldü)
        const bx = $('.kz-dd__box', d) || body, bh = bx.offsetHeight, top = bx.getBoundingClientRect().top;
        its.forEach((it) => { const t = dl + (Math.max(0, it.getBoundingClientRect().top - top) / Math.max(1, bh)) * T; it.style.setProperty('--d', `${t | 0}ms`); mx = Math.max(mx, t); });
        if (!$('.kz-dd__scan', body)) { const ln = document.createElement('i'); ln.className = 'kz-dd__scan'; ln.setAttribute('aria-hidden', 'true'); body.appendChild(ln); }
        d.style.setProperty('--dd-t0', `${bx === body ? 0 : bx.offsetTop}px`);
        d.style.setProperty('--dd-h', `${Math.max(0, bh - 2)}px`); d.style.setProperty('--dd-T', `${T}ms`); d.style.setProperty('--dd-dl', `${dl}ms`);
      } else {
        const o = order(n);
        its.forEach((it, i) => { const t = dl + o(i) * st; it.style.setProperty('--d', `${t}ms`); it.style.setProperty('--sd', i % 2 ? -1 : 1); mx = Math.max(mx, t); });
      }
      d.style.setProperty('--dbx', `${dl}ms`);
      void d.offsetWidth; // editörde yeniden oynatma: animasyon baştan başlasın
      d.classList.add('is-in');
      const tIn = Math.max(mx + Math.max(ms, fd), an === 'scan' ? dl + T : 0) + 60;
      tm = setTimeout(() => d.classList.remove('is-in'), tIn);
      free(tIn);
    };
    const hide = () => {
      clearTimeout(tm);
      const cl = d.dataset.cl || 'rev', its = $$('.kz-dd__an', d), n = its.length;
      fx?.(); fx = null; // harf çözmesi sürerken kapanıyorsa yazı hemen asıl haline
      its.forEach((it) => it.classList.remove('is-gl'));
      const shut = () => { closing = false; d.open = false; d.classList.remove('is-in', 'is-out'); lock(false); };
      closing = true;
      if (reduce) { grow?.stop(false); shut(); return; }
      lock(true);
      const box = d.dataset.bxAn !== 'none';
      let mx = 0, dur = 0;
      if (cl !== 'none' && n) {
        const cms = num('clMs', 260), cfd = num('clFd', 220), cst = num('clSt', 25);
        if (cl === 'rev') {
          // Açılış sırasının tersi (tarama ve şifre çözmede aşağıdan yukarı)
          const o = ['scan', 'glitch'].includes(d.dataset.an) ? (i) => i : order(n);
          const ords = its.map((_, i) => o(i)), last = Math.max(...ords);
          its.forEach((it, i) => { const t = (last - ords[i]) * cst; it.style.setProperty('--d', `${t}ms`); mx = Math.max(mx, t); });
        } else its.forEach((it) => it.style.setProperty('--d', '0ms'));
        dur = cl === 'rev' ? Math.max(cms, cfd) : cfd;
        d.style.setProperty('--dbx', `${Math.max(0, mx + dur - cfd)}ms`); // kutu en sonda solar
        d.classList.remove('is-in');
        d.classList.add('is-out');
      }
      // Kutu küçülürken satırlar da kapanır; kutu yumuşak değilse satırlar bitince kapanır
      if (box) run(body.offsetHeight, 0, 0, shut);
      else if (dur) tm = setTimeout(shut, mx + dur + 30);
      else shut();
    };
    sm.addEventListener('click', (e) => {
      e.preventDefault();
      if (d.open && !closing) hide(); else show();
    });
    d._dd = { show, hide };
  });
  initDd(document);
})();
